/* 26.09.2026: переклад через Translate & Adapt. ADL("текст") повертає переклад
   з window.ADAPTIS_L (snippets/adaptis-l.liquid, ключі locales/uk.json
   adaptis_js.*), а без перекладу той самий український текст. */
var ADL = window.ADL || (window.ADL = function(s){ return window.ADAPTIS_L ? window.ADAPTIS_L(s) : s; });
/* Конструктор комплектів Adaptis: рушій.
   Перенесено з перевіреного прототипу adaptis-configurator.vercel.app
   (assets/app.js) 21.09.2026. Логіка вибору, збірки комплекту й підрахунку
   лишилась як у прототипі. Змінено рівно три речі:
     1. рушій загорнутий у функцію, дані товару приходять з window.ADAPTIS_CONFIG,
        а конфіг звертається до стану через window.ADX;
     2. payload іде в справжній Shopify Ajax Cart API замість console.debug;
     3. позиція, що має ціну, але ще не має товару в каталозі, показується
        з підписом «за запитом» і не входить у суму (рішення власника 21.09.2026).
   Рушій не знає про конкретні товари: усе предметне живе у файлах
   adaptis-cfg-*.js. */
/* 27.09.2026: навігація по сторінці товару винесена з рушія в окремий
   модуль, щоб та сама смуга розділів була і на сторінках без конструктора
   (аксесуари, інші Starlink, послуги): там її запускає adaptis-product.js з
   коренем #adaptisPm. Код той самий, змінено лише, звідки береться корінь. */
(function(){
"use strict";
if (window.AdaptisPageNav) return;
/* 21.09.2026. Рядок розділів під шапкою сайту: «Все про товар» і заголовки
   h2 з текстових блоків нижче. Пункти беруться зі сторінки, тому коли опис
   товару розділять на окремі блоки, навігація підхопить їх сама.
   Навігація стоїть першою в #MainContent і просто sticky: браузер сам тримає
   її під шапкою і сам відпускає наприкінці контенту, над підвалом. Позицію
   під час прокрутки ми не рахуємо, тому вона не стрибає. Шар нижчий за шапку
   (у шапки z-index 8), щоб меню шапки відкривались поверх навігації. */
window.AdaptisPageNav = function(root){
  /* Навігація одна на сторінку: після перезапуску рушія лишається перша. */
  if (document.querySelector(".cfgnav")) return;
  const main = document.getElementById("MainContent");
  if (!root || !main) return;
  const heads = [...document.querySelectorAll(".adaptis-text-section h2")]
    .filter(h => h.textContent.trim() && h.offsetParent !== null);
  if (!heads.length) return;
  const items = [{t:ADL("Все про товар"), n:root}].concat(heads.map(h => ({t:h.textContent.trim(), n:h})));
  const nav = document.createElement("nav");
  nav.className = "adaptis-cfg cfgnav";
  nav.setAttribute("aria-label", "Розділи сторінки товару");
  nav.innerHTML = '<div class="pw cfgnav__in"></div>';
  const inner = nav.firstChild;
  const header = document.querySelector('[id$="__header_section"]');
  /* Шапка липне з top:-1px, тому прилиплий низ шапки це offsetHeight - 1.
     Дробовий піксель при масштабі закриває біла смужка над навігацією (CSS),
     зсувати саму навігацію не можна: вона б стрибала при прилипанні. */
  const headerH = () => header ? Math.max(0, header.offsetHeight - 1) : 0;
  const offset = () => headerH() + nav.offsetHeight;
  items.forEach((it, k) => {
    const a = document.createElement("a");
    a.className = "cfgnav__a";
    a.href = "#";
    a.textContent = it.t;
    a.addEventListener("click", e => {
      e.preventDefault();
      const y = k === 0 ? 0 : it.n.getBoundingClientRect().top + window.pageYOffset - offset() - 12;
      window.scrollTo({top:Math.max(0, y), behavior:"smooth"});
    });
    it.a = a;
    inner.appendChild(a);
  });
  /* Зона навігації: секції від конструктора до останнього розділу, на який
     вона веде. Sticky не виходить за межі батька, тому наприкінці опису
     навігація відʼїжджає разом із контентом, а не висить над «Схожими
     товарами» і підвалом. Порядок секцій не змінюється. */
  const firstSec = root.closest('[id^="shopify-section"]');
  const lastSec = heads[heads.length - 1].closest('[id^="shopify-section"]');
  let zone = main;
  if (firstSec && lastSec && firstSec.parentNode === lastSec.parentNode){
    zone = document.createElement("div");
    zone.className = "cfgnav-zone";
    firstSec.parentNode.insertBefore(zone, firstSec);
    let n = firstSec;
    while (n){
      const next = n.nextElementSibling;
      zone.appendChild(n);
      if (n === lastSec) break;
      n = next;
    }
  }
  zone.insertBefore(nav, zone.firstChild);
  /* 23.09.2026, вечір: на телефоні навігація не sticky. Липка шапка і липка
     навігація в іншому контейнері це два незалежні шари, і iPhone під час
     інерційної прокрутки рухав їх не синхронно: навігація сіпалась вгору-вниз.
     Тут вона звичайний блок, під шапкою стає fixed (замість неї заглушка тієї ж
     висоти, щоб сторінка не стрибала), а наприкінці розділів прикріплюється до
     низу зони й відʼїжджає разом із вмістом. На десктопі лишається sticky.
     Усередину секції шапки її не ставимо: Horizon перебудовує шапку при
     оновленні кошика і викидає чуже. */
  /* 26.09.2026: так само на всіх сенсорних екранах: iPad горизонтально
     (1180 px) сіпав липку навігацію, як iPhone до цього. */
  const mq = window.matchMedia("(max-width: 749px), (hover: none), (pointer: coarse)");
  const ph = document.createElement("div");
  ph.className = "cfgnav-ph";
  ph.setAttribute("aria-hidden", "true");
  zone.insertBefore(ph, nav);
  let pin = "";
  const setPin = (p) => {
    if (p === pin) return;
    pin = p;
    nav.classList.toggle("cfgnav--fix", p === "fix");
    nav.classList.toggle("cfgnav--end", p === "end");
    ph.style.height = p ? nav.offsetHeight + "px" : "";
  };
  /* 27.09.2026: на сенсорних екранах навігація fixed одразу з верху сторінки,
     а не з першого пікселя прокрутки. Перемикання звичайний блок → fixed
     робить скрипт, а iPhone прокручує сторінку раніше, ніж скрипт встигає:
     на початку прокрутки навігація на мить їхала вгору під шапку і
     поверталась («мікропідйом»). Тепер на початку перемикати нічого. На верху
     сторінки вона на 1 px під шапкою (шапка липне з top:-1px), при відтягуванні
     сторінки вниз (scrollY < 0 на iPhone) опускається разом із шапкою. */
  const pinNav = () => {
    if (!mq.matches){ setPin(""); return; }
    const hh = headerH();
    const h = nav.offsetHeight;
    if (zone.getBoundingClientRect().bottom - h < hh) setPin("end");
    else setPin("fix");
    if (pin === "fix"){
      const t = (hh + Math.max(0, -window.pageYOffset)) + "px";
      if (nav.style.top !== t) nav.style.top = t;
    }
  };

  /* Галерея липне рівно там, де стоїть на початку сторінки: відступ між
     навігацією і галереєю міряємо, а не задаємо числом. Інакше при першій
     прокрутці вона зсувалась на кілька пікселів. */
  /* Галерея липне рівно там, де стоїть на початку сторінки, з тим самим
     зсувом, що й навігація над нею, тому відносно неї не рухається. */
  /* 22.09.2026: зберігаємо не абсолютний відступ, а відстань від низу шапки.
     Масштаб браузера міняє висоту шапки, і старе число зсувало галерею.
     На верху сторінки після зміни розміру міряємо заново. */
  let galGap = null, lastStick = "";
  /* Пишемо тільки змінене: на iPhone resize приходить під час прокрутки,
     коли ховається панель Safari. */
  const place = (fresh) => {
    const stuck = headerH();
    if (!mq.matches && nav.style.top !== stuck + "px") nav.style.top = stuck + "px";
    const gal = root.querySelector(".gal");
    if (gal && (galGap === null || fresh === true) && window.pageYOffset < 2){
      galGap = gal.getBoundingClientRect().top - nav.getBoundingClientRect().top;
    }
    const st = (galGap === null ? offset() + 24 : stuck + galGap) + "px";
    /* 27.09.2026: і на всю сторінку, щоб смуга розділів і описи нижче рахували
       ширину галереї з тим самим значенням (інакше розходились на 2-4 px). */
    if (st !== lastStick){ root.style.setProperty("--cfg-stick", st); document.documentElement.style.setProperty("--cfg-stick", st); lastStick = st; }
  };
  let cur = -1, ticking = false;
  const mark = () => {
    ticking = false;
    pinNav();
    const line = offset() + 24;
    let on = 0;
    items.forEach((it, k) => { if (k && it.n.getBoundingClientRect().top <= line) on = k; });
    if (on === cur) return;
    cur = on;
    items.forEach((it, k) => it.a.classList.toggle("is-on", k === on));
    const a = items[on].a;
    if (inner.scrollWidth > inner.clientWidth)
      /* 10.10.2026: активний пункт стає біля лівого поля смуги (на десктопі воно дорівнює відступу галереї). */
      inner.scrollTo({left:a.offsetLeft - (parseFloat(getComputedStyle(inner).paddingLeft) || 16), behavior:"smooth"});
  };
  window.addEventListener("scroll", () => { if (!ticking){ ticking = true; requestAnimationFrame(mark); } }, {passive:true});
  window.addEventListener("resize", () => { place(true); mark(); });
  const onMq = () => { setPin(""); nav.style.top = ""; place(true); mark(); };
  if (mq.addEventListener) mq.addEventListener("change", onMq); else if (mq.addListener) mq.addListener(onMq);
  place();
  mark();
};


})();

/* ---------- pop-up кошика ---------- */
/* У теми немає бічного кошика, тільки окрема сторінка. Pop-up показує весь
   кошик, а не лише цю збірку: покупець бачить, що саме оплатить.
   22.09.2026: окремий модуль, бо його відкриває і конструктор, і квіз підбору.
   Сторінка передає товар, від якого брати рекомендації, і цінову категорію. */
(function(){
"use strict";
if (window.AdaptisCartPop) return;

const cartRoot = () =>
  (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
/* 26.09.2026: внутрішні посилання з даних («/pages/...») з мовним префіксом,
   інакше з /en/ вони ведуть на українську сторінку. */
const locHref = h => (typeof h === "string" && h.charAt(0) === "/" && h.charAt(1) !== "/")
  ? cartRoot() + h.slice(1) : h;
const money = c => (c/100).toLocaleString("uk-UA").replace(/[, ]/g," ") + " ₴";
function postJSON(url, body){
  return fetch(url, {
    method:"POST",
    headers:{"Content-Type":"application/json", "Accept":"application/json"},
    body:JSON.stringify(body)
  }).then(r => r.json().then(d => {
    if (!r.ok) throw new Error(d && (d.description || d.message) || ("HTTP " + r.status));
    return d;
  }));
}
let liveCart = null;
/* 26.09.2026: одна цінова категорія на весь кошик (правило власника). Якщо
   хоч одна позиція з ціною для Сил Оборони, позиції з цивільною ціною, які
   мають пару (той самий товар і варіант, інше «Призначення»), переходять на
   ціну для Сил Оборони. Вимкнення в кошику вимикає її в усіх позиціях
   (adaptis-cart.js). Працює після кожного додавання, до вікна «Додано в
   кошик» і до переходу на оформлення. На сторінці кошика це робить сам
   кошик (adaptis-cart.js), тут пропускаємо, щоб не міняти двічі. */
const DEF_RE = /Оборони/;
function purposeOf(it){
  return (it.options_with_values || []).find(o => /Призначення/.test(o.name || ""));
}
function defSync(c){
  if (!c || !c.items || document.getElementById("adaptisCart")) return Promise.resolve(c);
  const withP = c.items.map(it => ({it, p:purposeOf(it)})).filter(x => x.p);
  const civ = withP.filter(x => !DEF_RE.test(x.p.value));
  if (!civ.length || !withP.some(x => DEF_RE.test(x.p.value))) return Promise.resolve(c);
  const json = {"Content-Type":"application/json", Accept:"application/json"};
  const byHandle = {};
  const prod = h => byHandle[h] || (byHandle[h] = fetch(cartRoot() + "products/" + h + ".js", {headers:{Accept:"application/json"}}).then(r => r.json()));
  return Promise.all(civ.map(x => prod(x.it.handle).then(p => {
    const names = (p.options || []).map(o => typeof o === "string" ? o : o.name);
    const pi = names.findIndex(n => /Призначення/.test(n || ""));
    if (pi < 0) return null;
    const cur = x.it.variant_options || [];
    const v = (p.variants || []).find(v => v.available && v.id !== x.it.variant_id &&
      (v.options || []).every((val, k) => k === pi ? DEF_RE.test(val) : val === cur[k]));
    return v ? {it:x.it, pair:v.id, pairp:v.options[pi]} : null;
  }).catch(() => null))).then(list => {
    list = list.filter(Boolean);
    if (!list.length) return c;
    const plain = [], rich = [];
    list.forEach(x => {
      const props = Object.assign({}, x.it.properties || {});
      if ("Призначення" in props) props["Призначення"] = x.pairp;
      const dup = c.items.some(i => i.variant_id === x.pair) || plain.some(y => y.pair === x.pair);
      x.props = props;
      (!Object.keys(props).length && !dup ? plain : rich).push(x);
    });
    const updates = {};
    plain.forEach(x => { updates[x.pair] = x.it.quantity; updates[x.it.key] = 0; });
    rich.forEach(x => { updates[x.it.key] = 0; });
    const first = rich.length
      ? fetch(cartRoot() + "cart/add.js", {method:"POST", headers:json, body:JSON.stringify({items:rich.map(x => ({id:x.pair, quantity:x.it.quantity, properties:x.props}))})})
      : Promise.resolve();
    return first
      .then(() => fetch(cartRoot() + "cart/update.js", {method:"POST", headers:json, body:JSON.stringify({updates})}))
      .then(r => r.json())
      .then(n => { if (n && n.items) announceCart(n); return n && n.items ? n : c; });
  }).catch(() => c);
}
const refreshCart = () => fetch(cartRoot() + "cart.js", {headers:{Accept:"application/json"}})
  .then(r => r.json()).then(defSync).then(c => { liveCart = c; return c; });
/* Horizon оновлює лічильник у шапці за подією cart:update і читає
   detail.data.itemCount. Без detail лічильник падав з помилкою. */
function announceCart(c){
  document.dispatchEvent(new CustomEvent("cart:update", {bubbles:true, detail:{
    resource:c, sourceId:"adaptis-configurator",
    data:{itemCount:c.item_count, source:"adaptis-configurator"}
  }}));
}
let opts = {productId:null, productHandle:null, purpose:() => "civil", onChange:() => {}};
let pop = null, popRecs = null, popRecsFor = null, popBusy = false;
const escHtml = t => String(t == null ? "" : t).replace(/[&<>"']/g, c =>
  ({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"})[c]);
const sized = (u, w) => !u ? "" : u + (u.indexOf("?") > -1 ? "&" : "?") + "width=" + w;

function openCartPop(o){
  const adding = o && o.adding, preview = (o && o.preview) || [];
  if (o){ opts = Object.assign({}, opts, o); delete opts.adding; delete opts.preview; }
  if (!pop){
    pop = document.createElement("div");
    pop.className = "adaptis-cfg cpop cpop--anim";
    pop.hidden = true;
    pop.innerHTML =
      '<div class="cpop__bg" data-close></div>' +
      '<div class="cpop__box" role="dialog" aria-modal="true" aria-labelledby="cpopT">' +
        ("<div class=\"cpop__head\"><h2 class=\"cpop__t\" id=\"cpopT\">" + ADL("Додано в кошик") + "</h2>") +
        ("<button type=\"button\" class=\"cpop__x\" data-close aria-label=\"" + ADL("Закрити").replace(/"/g, "&quot;") + "\">&#215;</button></div>") +
        /* 22.09.2026: фокус на допродажі. Кошик тут коротким рядком: скільки
           товарів і маленькі прев'ю, повний список і правки в кошику. */
        '<div class="cpop__body"><p class="cpop__err" role="alert" hidden></p><div class="cpop__bag"></div><div class="cpop__recs"></div></div>' +
        '<div class="cpop__foot">' +
          ("<div class=\"cpop__sum\"><span>" + ADL("Разом") + "</span><b class=\"cpop__tot\"></b></div>") +
          '<a class="buy cpop__go" href="' + cartRoot() + ("checkout\">" + ADL("Оформити замовлення") + "</a>") +
          ("<button type=\"button\" class=\"btn btn--3 cpop__more\" data-close>" + ADL("Продовжити покупки") + "</button>") +
        '</div>' +
      '</div>';
    document.body.appendChild(pop);
    pop.addEventListener("click", e => {
      if (e.target.closest("[data-close]")) { closeCartPop(); return; }
      /* 28.09.2026: «Оформити замовлення», поки товар ще додається: переходимо,
         щойно Shopify його додасть, інакше на оформленні його не було б. */
      const go = e.target.closest(".cpop__go");
      if (go && pop.classList.contains("cpop--adding")) { e.preventDefault(); goAfter = go.href; }
    });
    document.addEventListener("keydown", e => { if (e.key === "Escape" && pop && !pop.hidden) closeCartPop(); });
  }
  if (adding) return openAdding(adding, preview);
  /* 26.09.2026: подія воронки допродажу (adaptis-src). */
  if (window.AdaptisSrc) window.AdaptisSrc.track("upsell_popup_view");
  setTitle(ADL("Додано в кошик"));
  pop.classList.remove("cpop--adding", "cpop--fail");
  /* 22.09.2026: показуємо вікно, коли зібрані і кошик, і допродаж. Раніше
     спершу зʼявлявся кошик, потім у нього доїжджали картки, і вікно смикалось.
     Дані зазвичай уже в кеші (prefetch), тому клік лишається миттєвим;
     якщо мережа тормозить, чекаємо не довше півсекунди. */
  const cartReady = liveCart ? Promise.resolve(liveCart) : refreshCart();
  const recsReady = loadRecs().catch(() => []);
  /* 25.09.2026: кошик чекаємо завжди (без нього вікно порожнє), а допродаж
     не довше 150 мс, далі він домальовується. */
  const wait = Promise.all([cartReady, Promise.race([recsReady, new Promise(r => setTimeout(r, 150))])]);
  /* 25.09.2026: вікно зʼявляється плавно й цілим: спершу малюємо вміст і
     чекаємо фото (не довше 400 мс), потім показуємо з анімацією, як інші
     вікна сайту. Раніше воно виникало різко, а фото домальовувались. */
  wait.then(() => {
    paintPop(liveCart);
    trackAm();
    const imgs = [].slice.call(pop.querySelectorAll("img"));
    return Promise.race([
      Promise.all(imgs.map(i => i.decode ? i.decode().catch(() => {}) : null)),
      new Promise(r => setTimeout(r, 100))
    ]);
  }).then(() => {
    showPop();
    /* Хто відкрив вікно (швидке додавання), закриває своє саме зараз, щоб
       між вікнами не було порожньої паузи. */
    if (typeof opts.onShown === "function"){ const f = opts.onShown; opts.onShown = null; f(); }
    /* Якщо допродаж приїхав після відкриття, домальовуємо його тихо. */
    recsReady.then(() => { if (!pop.hidden){ paintRecs(liveCart); trackAm(); } });
  });
}
function setTitle(t){ const h = pop.querySelector(".cpop__t"); if (h.textContent !== t) h.textContent = t; }
function showPop(){
  clearTimeout(popHideT);
  if (pop.hidden || !pop.classList.contains("is-open")){
    pop.hidden = false;
    void pop.offsetWidth;
    pop.classList.add("is-open");
  }
  document.documentElement.classList.add("cpop-open");
  const x = pop.querySelector(".cpop__x");
  if (x && document.activeElement !== x) x.focus({preventScroll:true});
}
/* Картка Amulet у допродажі: подія один раз і лише в готовому вікні. */
function trackAm(){
  if (window.AdaptisSrc && pop.querySelector(".cpop__rc--am")) window.AdaptisSrc.track("upsell_amulet_view", {once:true});
}
/* 28.09.2026: вікно відкривається одразу після «Купити», не чекаючи Shopify
   (додавання там триває 0,5-0,9 с). Одразу видно те, що сторінка вже знає:
   фото, назву, ціну й кількість, заголовок «Додаємо в кошик…». Коли Shopify
   відповів, одним запитом беремо кошик і домальовуємо суму, лічильник і
   допродаж; події аналітики теж лише тепер. Якщо Shopify відмовив (немає в
   наявності, ліміт), пояснення в цьому ж вікні.
   adding: запит додавання (Promise). Якщо він повертає весь кошик (update.js
   у конструкторі), окремий /cart.js не потрібен.
   preview: [{title, image, line_price, quantity, variant_id, product_id, handle}] */
let goAfter = null, addSeq = 0;
function openAdding(adding, preview){
  const seq = ++addSeq;
  goAfter = null;
  const known = (window.AdaptisSrc && window.AdaptisSrc.cart && window.AdaptisSrc.cart()) || null;
  const draft = draftCart(known, preview);
  pop.classList.remove("cpop--fail");
  pop.classList.add("cpop--adding");
  pop.querySelector(".cpop__err").hidden = true;
  setTitle(ADL("Додаємо в кошик…"));
  paintBag(draft.cart, draft.line);
  pop.querySelector(".cpop__tot").textContent = known ? money(draft.cart.total_price) : " ";
  const key = opts.productId || opts.productHandle || "";
  /* Допродаж, уже завантажений заздалегідь, показуємо одразу; після
     відповіді Shopify картки міняються, лише якщо кошик їх змінив. */
  /* 28.09.2026 (власник): поки товар додається, замість карток сірі
     заготовки: кошик «як буде» зібраний з неповних даних, і вікно показувало
     те, що вже не потрібно (Amulet, коли він уже в кошику). */
  paintRecsWait();
  showPop();
  if (typeof opts.onOpen === "function"){ const f = opts.onOpen; opts.onOpen = null; f(); }
  const recsReady = loadRecs().catch(() => []);
  const whole = c => c && c.items && typeof c.item_count === "number";
  adding
    .then(r => whole(r) ? defSync(r).then(c => { liveCart = c; return c; }) : refreshCart().catch(() => draft.cart))
    .then(c => {
      if (seq !== addSeq) return;
      if (goAfter){ window.location.href = goAfter; return; }
      pop.classList.remove("cpop--adding");
      setTitle(ADL("Додано в кошик"));
      if (window.AdaptisSrc) window.AdaptisSrc.track("upsell_popup_view");
      paintPop(c);
      trackAm();
      if (typeof opts.onShown === "function"){ const f = opts.onShown; opts.onShown = null; f(); }
      recsReady.then(() => { if (seq === addSeq && !pop.hidden){ paintRecs(liveCart); trackAm(); } });
    }, err => {
      if (seq !== addSeq) return;
      goAfter = null;
      pop.classList.remove("cpop--adding");
      pop.classList.add("cpop--fail");
      setTitle(ADL("Не вдалося додати"));
      showPop();
      const e = pop.querySelector(".cpop__err");
      e.textContent = (err && err.message && !/^HTTP \d/.test(err.message) ? err.message : "") || ADL("Не вдалося додати в кошик");
      e.hidden = false;
      opts.onShown = null;
      if (typeof opts.onFail === "function"){ const f = opts.onFail; opts.onFail = null; f(err); }
    });
}
/* Кошик «як буде»: те, що вже лежить (якщо відомо), плюс те, що додаємо. */
function draftCart(known, preview){
  const items = ((known && known.items) || []).map(i => Object.assign({}, i));
  let total = known ? known.total_price : 0;
  preview.forEach(p => {
    const q = p.quantity || 1;
    total += p.line_price || 0;
    const same = p.variant_id && items.find(i => String(i.variant_id) === String(p.variant_id));
    if (same) same.quantity += q;
    else items.push({variant_id:p.variant_id, product_id:p.product_id, handle:p.handle || "", product_title:p.title || "", image:p.image || "", image_exact:p.image_exact || "", quantity:q});
  });
  const line = preview.length ? preview[0].title + (preview.length > 1 ? (" " + ADL("і ще") + " ") + (preview.length - 1) : "") : "";
  return {cart:{items:items, total_price:total, item_count:items.reduce((a, i) => a + i.quantity, 0)}, line:line};
}
/* Місце під допродаж, поки він вантажиться: вікно не міняє висоту. */
function paintRecsWait(){
  const host = pop.querySelector(".cpop__recs");
  if (host.querySelector(".cpop__rc--sk")) return;
  host.dataset.sig = "";
  host.innerHTML = '<h3 class="cpop__rt">' + ADL("Разом із цим купують") + '</h3><div class="cpop__rrow" aria-hidden="true">' +
    '<div class="cpop__rc cpop__rc--sk"><span class="cpop__ri"></span><span class="cpop__rn">&nbsp;<br>&nbsp;</span><b class="cpop__rp">&nbsp;</b><span class="cpop__ra">&nbsp;</span></div>'.repeat(4) + '</div>';
}
let popHideT = null;
function closeCartPop(){
  if (!pop) return;
  pop.classList.remove("is-open");
  document.documentElement.classList.remove("cpop-open");
  clearTimeout(popHideT);
  popHideT = setTimeout(() => { if (!pop.classList.contains("is-open")) pop.hidden = true; }, 220);
  opts.onChange();
}

/* Українська множина: 1 товар, 2-4 товари, 5 і більше товарів. */
function goodsT(n){
  const m10 = n % 10, m100 = n % 100;
  const w = m10 === 1 && m100 !== 11 ? ADL("товар") : m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14) ? ADL("товари") : ADL("товарів");
  return n + " " + w;
}
function paintPop(c){
  if (!pop || !c) return;
  paintBag(c);
  pop.querySelector(".cpop__tot").textContent = money(c.total_price);
  const go = pop.querySelector(".cpop__go");
  go.classList.toggle("is-off", !c.items.length);
  paintRecs(c);
}
/* line: рядок замість «В кошику N товарів», поки товар додається.
   28.09.2026: прев'ю, які вже стоять у вікні (той самий варіант), лишаються
   тими самими елементами: фото не вантажиться вдруге і не блимає, коли
   «Додаємо…» змінюється на готовий кошик. */
function paintBag(c, line){
  const bag = pop.querySelector(".cpop__bag");
  const n = c.items.length;
  if (!n){
    bag.innerHTML = ("<p class=\"cpop__empty\">" + ADL("Кошик порожній") + "</p>");
    return;
  }
  let row = bag.querySelector(".cpop__thumbs");
  if (!row){ bag.innerHTML = ""; row = document.createElement("div"); row.className = "cpop__thumbs"; bag.appendChild(row); }
  const old = {};
  [].forEach.call(row.querySelectorAll(".cpop__th[data-v]"), t => { old[t.dataset.v] = t; });
  const seen = {};
  /* До шести прев'ю, решта числом. */
  const next = c.items.slice(0, 6).map(i => {
    const k = String(i.variant_id) + "#" + (seen[i.variant_id] = (seen[i.variant_id] || 0) + 1);
    let th = old[k];
    delete old[k];
    if (!th){
      th = document.createElement("span");
      th.className = "cpop__th";
      th.dataset.v = k;
      const src = lineImg(i, 120);
      if (src){ const im = document.createElement("img"); im.src = src; im.alt = ""; im.decoding = "async"; th.appendChild(im); }
    }
    th.title = i.product_title || "";
    let q = th.querySelector("i");
    if (i.quantity > 1){ if (!q){ q = document.createElement("i"); th.appendChild(q); } q.textContent = i.quantity; }
    else if (q) q.remove();
    return th;
  });
  if (n > 6){ const m = document.createElement("span"); m.className = "cpop__th cpop__th--more"; m.textContent = "+" + (n - 6); next.push(m); }
  if (next.length !== row.children.length || next.some((t, k) => row.children[k] !== t)) row.replaceChildren.apply(row, next);
  /* 22.09.2026: сам рядок «У кошику N товарів» і є посиланням на кошик.
     Унизу лишились дві кнопки, щоб допродаж вміщувався в екран телефона. */
  const cnt = document.createElement("p");
  cnt.className = "cpop__cnt" + (line ? " cpop__cnt--wait" : "");
  if (line) cnt.textContent = line;
  else cnt.innerHTML = '<a class="cpop__view" href="' + cartRoot() + ("cart\">" + ADL("В кошику") + " ") + goodsT(n) + '</a>' +
    (" " + ADL("на") + " ") + money(c.total_price);
  const was = bag.querySelector(".cpop__cnt");
  if (was) bag.replaceChild(cnt, was); else bag.appendChild(cnt);
  /* 27.09.2026 (власник): пояснення, навіщо оцинковані пластини, лишається
     тільки в кошику; у вікні над допродажем його немає. */
}

/* Допродаж: Adaptis Amulet і підписка першими, далі стандартні рекомендації
   Shopify до цього товару (Search & Discovery). 21.09.2026: готові набори,
   корпуси-комплекти, термінали й монтаж сюди не йдуть, лише аксесуари,
   підписка і послуга Amulet. */
/* 22.09.2026: монтаж теж пропонуємо, але лише коли в кошику є корпус. */
const INSTALL_HANDLE = "adaptis_installation";
/* 22.09.2026: Adaptis Amulet у конструкторі й кошику показуємо власним фото теми
   (ADAPTIS_ASSETS.amulet), фото товару в каталозі не міняємо. */
const AMULET_HANDLE = "service-adaptis-amulet-starlink";
/* 24.09.2026: Adaptis Amulet пропонуємо лише українською. В англійській,
   польській та інших мовах його немає ніде: ні кроку, ні допродажу. */
const AMULET_ON = (window.ADAPTIS_LOCALE || "uk") === "uk";
function lineImg(x, w){
  /* 28.09.2026: фото, яке сторінка вже завантажила (картка каталогу, галерея). */
  if (x && x.image_exact) return x.image_exact;
  const own = x && x.handle === AMULET_HANDLE && (window.ADAPTIS_ASSETS || {}).amulet;
  if (own) return own;
  const src = x && (x.image || x.featured_image);
  return src && w ? sized(src, w) : src;
}
/* Підписка: одна позиція це один місяць, строк обирається в самій картці
   допродажу, мінімум три місяці. */
const SUB_HANDLE = "roam-unlim-starlink-account-management";
const SUB_HOME = "residential-unlimited-abonplata";
const SUB_PRIO = "starlink-global-priority-500-gb-plan";
const SUB_MONTHS = [3, 6, 12];
const monthsT = n => n + (n < 5 ? (" " + ADL("місяці")) : (" " + ADL("місяців")));
/* 28.09.2026 (сесія 6в, ревізія 2 рекомендацій): вікно спершу визначає, що
   людина збирається робити зі Starlink (авто, дім, поїздки, пішки чи невідомо)
   з усього кошика, і добирає картки під цей сценарій з поясненням «навіщо».
   Логіка нижче це модуль AdaptisRecsCore, перенесений з перевіреного
   симулятора (Інструменти перевірки/рекомендації-28.09/ревізія-2: sim5.py,
   recs-core.js, test-core.mjs, 121/121 кошиків). Змінювати спершу там, потім
   вставляти сюди заново, замінивши виклики T( на ADL( (для ключів перекладу).
   Рекомендацій Shopify у вікні немає. */
/* recs-core.js: логіка вікна «Додано в кошик» Adaptis без DOM і без мережі.
   Перенесено з sim5.py (ревізія 2 рекомендацій, 28.09, рішення власника 1-8) рядок у рядок:
   bagOf = bag_of, flagsOf = flags_of, scenarioOf = scenario_of, rules = rules, windowOf = window.
   Будь-яка зміна тут спершу робиться в sim5.py, далі test-core.mjs має дати 121/121.

   Вхід: cart у форматі Shopify /cart.js; ctx = {locale, purpose, products, T}.
     locale    'uk' | 'en' | 'pl' (Amulet і монтаж лише uk);
     purpose   'civil' | 'defense': цінова категорія перемикача сайту; діє, лише коли кошик сам
               не каже про категорію (варіант чи властивість «Призначення»);
     products  {handle: {available, variants:[{id, title, price, available, option1, option2}], models?}}
               (/products/<handle>.js); models необов'язкові: назви моделей з метаполя
               сумісності ('Mini', 'Mini X', 'Standard 4X', ...), інакше вбудована таблиця FAMILY;
     T         функція перекладу (у темі ADL), кожен видимий текст іде через ADL('...').
   Вихід windowCards: масив карток по порядку {h, rule, qty, variantId, why, action,
   replaceKeys?, incKey?, note?, from?}. ES2019, без import/export. */
var AdaptisRecsCore = (function(){
"use strict";

/* ---------------------------------------------------------------- довідники */
var H = {
  amuletT:"starlink-adaptis-amulet", amuletS:"service-adaptis-amulet-starlink",
  tMini:"starlink-mini", tMiniX:"starlink-mini-x", t4x:"starlink-standard-gen3",
  /* 17.10.2026 (s77, власник): Standard 4 = та сама антена, що в 4X, з Router Mini замість Router 3 */
  t4:"starlink-standard-4-with-router-mini",
  tGen2:"tarlink-standard-actuated-gen2", tV5:"starlink-v5-kit",
  tPerf1:"starlink-high-performance-terminal", tFlat:"starlink-flat-high-performance",
  miniKit:"adaptis-minikit-for-starlink-mini", g3kit:"products-gen3-main-unit-rev4",
  g2kit:"adaptis-g2kit-starlink-gen2", hp:"adaptis-hp-for-starlink-high-performance",
  psu:"starlink-mini-adapter-12-24v", cc160:"adaptis-gp-cc160-160w-2-type-c-usb",
  ccSet:"adaptis-car-charger-5m-dc-typec-cable", dc:"cable-dc-type-c-5m", mini15:"mini-5m-cable",
  p2fit:"powerbank-adaptis-p2fit-for-starlink-mini", pb27:"powerbank-27000mah",
  eb3a:"bluetti-eb3a-600w-portable-power-station", river3:"ecoflow-river-3-245wh-power-station",
  eth:"starlink-gen3-cable", ethGen2:"starlink-cable-30-м-gen2-gen3",
  ethAdapter:"starlink-ethernet-adapter-v2", cover:"adaptis-case-cover",
  backpack:"water-resistant-starlink-mini-backpack", plates:"metal-plates-starlink",
  magnets:"adaptis-magnets-set-4", install:"adaptis_installation",
  /* 07.10.2026 (власник): окремі товари, раніше були лише в наборах або приміткою для менеджера. */
  psu56p:"12-56v-power-supply-starlink-standard", invp:"inverter-450-900w-dc-ac-starlink-standard",
  installAway:"starlink-installation-on-site",
  subHome:"residential-unlimited-abonplata", subRoam:"roam-unlim-starlink-account-management",
  subPrio:"starlink-global-priority-500-gb-plan",
  biz:"starlink-for-business", consult:"satellite-connectivity-consulting-and-custom-solutions",
  diag:"starlink-diagnostics"
};
var SUBS = [H.subHome, H.subRoam, H.subPrio];
var REQUESTS = [H.biz, H.consult, H.diag];
/* Передзамовлення: кандидатами не бувають (V5, Performance Gen1 і Gen2, Adaptis HP). */
var PREORDER = [H.tV5, H.tPerf1, H.tFlat, H.hp];
var CAR_POWER = [H.psu, H.cc160, H.ccSet];
/* Живлення від авто саме під Mini і Mini X; GP-CC160 універсальна, модель з неї не випливає. */
var CAR_POWER_MINI = [H.psu, H.ccSet];
var NO_CAR_SET = ["kit-starlink-mini-adaptis-p2"];

var TERMS = {};
TERMS[H.tMini] = "mini"; TERMS[H.tMiniX] = "minix"; TERMS[H.t4x] = "std4x"; TERMS[H.t4] = "std4"; TERMS[H.tGen2] = "gen2";
TERMS[H.tV5] = "v5"; TERMS[H.tPerf1] = "perf1"; TERMS[H.tFlat] = "flat";
/* Порядок важливий: Mini X раніше Mini. */
var AMULET_MODELS = [["Mini X", "minix"], ["Mini", "mini"], ["Standard 4X", "std4x"]];
var MODEL_T = {mini:"Mini", minix:"Mini X", std4x:"Standard 4X", std4:"Standard 4", gen2:"Gen2", v5:"V5",
               perf1:"Performance Gen1", flat:"Performance Gen2"};
var MINI_FAM = ["mini", "minix"];
var CORPORA = {};
CORPORA[H.miniKit] = "Mini"; CORPORA[H.g3kit] = "Gen3"; CORPORA[H.g2kit] = "Gen2"; CORPORA[H.hp] = "HP";
/* G3kit підходить і до Standard 4X, і до Standard 4 (s77, 17.10.2026) */
var CORPUS_MODELS = {Mini:["mini", "minix"], Gen3:["std4x", "std4"], Gen2:["gen2"], HP:["perf1"]};

/* spec.md п. 1.4: склад наборів. car: psu (12-24V), azp (GP-CC160), cig (прикурювач),
   psu56 (блок 12-56 В), inv (інвертор). auto: p2fit або pb27. */
var SETS = {
  "adaptis-minikit-starlink-mini-terminal-auto-power-adapter-12-24v": {term:"mini", corpus:"Mini", car:"psu"},
  "auto-kit-starlink-mini-adaptis-car-charger-dc-typec-5": {term:"mini", corpus:"Mini", car:"azp", dc:true},
  "starlink-mini-adaptis-mini-azp-komplekt-dlya-auto": {term:"mini", corpus:"Mini", car:"azp", needDc:true},
  "adaptis-minikit-starlink-mini-kit": {term:"mini", corpus:"Mini"},
  "starlink-mini-adaptis-minikit-type-c-powerbank": {term:"mini", corpus:"Mini", car:"cig", auto:"pb27", dc:true},
  "starlink-mini-adaptis-mini-power-bank-p1-kit": {term:"mini", corpus:"Mini", auto:"p2fit"},
  "kit-starlink-mini-adaptis-p2": {term:"mini", auto:"p2fit"},
  "starlink-mini-terminal-kit-power-adapter-12-24vdc": {term:"mini", car:"psu"},
  "adaptis-starlink-mini-x-cc160": {term:"minix", corpus:"Mini", car:"azp", needDc:true},
  "set-starlink-mini-x-adaptis-mini": {term:"minix", corpus:"Mini"},
  "set-starlink-mini-x-adaptis-mini-with-acc-typec-ethernet": {term:"minix", corpus:"Mini", car:"azp", dc:true, eth:true},
  "adaptis-minikit-case-car-power-adapter-12-24v": {corpus:"Mini", car:"psu"},
  "minikit-case-type-c-cable-powerbank-kit": {corpus:"Mini", auto:"pb27", dc:true},
  "starlink-gen3-terminal-adaptis-g3kit-case": {term:"std4x", corpus:"Gen3"},
  "starlink-gen3-terminal-adaptis-g3kit-case-power-adapter-12-24v": {term:"std4x", corpus:"Gen3", car:"psu56"},
  "starlink-gen3-adaptis-g3kit-12-56v": {term:"std4x", corpus:"Gen3", car:"inv"},
  "products-starlink-gen2-terminal-adaptis-g2kit-case": {term:"gen2", corpus:"Gen2"}
};
var NEEDS_DC = [H.cc160], HAS_DC = [H.dc, H.ccSet];
Object.keys(SETS).forEach(function(h){
  if (SETS[h].needDc) NEEDS_DC.push(h);
  if (SETS[h].dc) HAS_DC.push(h);
});

/* Моделі кандидатів з матриця-сумісності.json (сесія 6). Чого тут немає, те на будь-який
   термінал ('*'). Метаполе сумісності товару (products[h].models) має пріоритет. */
var FAMILY = {};
FAMILY[H.amuletT] = ["mini", "minix", "std4x"];
FAMILY[H.tMini] = ["mini"]; FAMILY[H.tMiniX] = ["minix"]; FAMILY[H.t4x] = ["std4x"]; FAMILY[H.t4] = ["std4"];
[H.miniKit, H.dc, H.cc160, H.psu, H.ccSet, H.p2fit, H.pb27, H.backpack, H.mini15].forEach(function(h){ FAMILY[h] = ["mini", "minix"]; });
FAMILY[H.river3] = FAMILY[H.eb3a] = ["mini", "minix", "std4x", "std4", "gen2", "v5"];
FAMILY[H.eth] = ["mini", "minix", "std4x"];
FAMILY[H.install] = ["mini", "minix", "std4x", "std4", "gen2"];
FAMILY[H.plates] = ["mini", "minix", "std4x", "std4", "gen2", "perf1"];
FAMILY[H.cover] = ["mini", "minix", "std4x", "std4", "gen2"];
var MNORM = {"Mini":"mini", "Mini X":"minix", "Standard 4X":"std4x", "Standard 4":"std4", "Gen2":"gen2", "Performance Gen1":"perf1",
             "Performance Gen2":"flat", "V5":"v5", "будь-яка":"*"};

/* Товари, які вікно може показати: їх тема вантажить заздалегідь (PIN_RECS). */
var CANDIDATES = [H.amuletT, H.amuletS, H.tMini, H.tMiniX, H.t4x, H.miniKit, H.dc, H.cc160, H.subRoam, H.subHome,
  H.psu, H.ccSet, H.p2fit, H.pb27, H.eth, H.install, H.plates, H.river3, H.eb3a, H.cover, H.backpack];

/* Коротка назва в картці й у примітках. Кожен рядок через ADL(літерал). */
function shortName(h, T){
  T = T || ident;
  switch (h){
    case H.tMini: return ADL("Starlink Mini");
    case H.tMiniX: return ADL("Starlink Mini X");
    case H.t4x: return ADL("Starlink Standard 4X");
    case H.t4: return ADL("Starlink Standard 4");
    case H.amuletT: return ADL("Starlink з модифікацією Adaptis Amulet");
    case H.amuletS: return ADL("Adaptis Amulet на ваш термінал");
    case H.dc: return ADL("Кабель живлення USB-C, 5 м");
    case H.subRoam: return ADL("Тариф «Мандрівний»");
    case H.subHome: return ADL("Тариф «Домашній»");
    case H.subPrio: return ADL("Тариф «Глобальний Пріоритет»");
    case H.install: return ADL("Монтаж на авто");
    case H.plates: return ADL("Оцинковані пластини");
    case H.psu: return ADL("Адаптер 12-24V");
    case H.ccSet: return ADL("Автозарядка з кабелем 5 м");
    case H.cc160: return ADL("Автозарядка 160 Вт");
    case H.p2fit: return ADL("Павербанк P2Fit");
    case H.pb27: return ADL("Павербанк 27 000 mAh");
    case H.eth: return ADL("Кабель Ethernet");
    case H.eb3a: return ADL("Станція Bluetti EB3A");
    case H.river3: return ADL("Станція EcoFlow River 3");
    case H.cover: return ADL("Чохол на корпус");
    case H.backpack: return ADL("Рюкзак для Starlink");
    case H.miniKit: return ADL("Корпус MiniKit");
    case H.g3kit: return ADL("Корпус G3kit");
    case H.g2kit: return ADL("Корпус G2kit");
    case H.hp: return ADL("Корпус Adaptis HP");
    case H.mini15: return ADL("Кабель Starlink Mini 15 м");
    case H.tV5: return ADL("Starlink V5 Kit");
    case H.tGen2: return ADL("Starlink Standard Actuated Gen2");
    case H.tPerf1: return ADL("Starlink Performance Gen1");
    case H.tFlat: return ADL("Starlink Performance Gen2");
  }
  return null;
}

/* ---------------------------------------------------------------- дрібниці */
function ident(s){ return s; }
function inArr(a, x){ return a.indexOf(x) > -1; }
function str(x){ return x == null ? "" : String(x); }
function uniq(a){ var o = []; a.forEach(function(x){ if (o.indexOf(x) < 0) o.push(x); }); return o; }
function sum(a, f){ return a.reduce(function(s, x){ return s + f(x); }, 0); }
function keys(o){ return Object.keys(o); }
function norm(ctx){
  ctx = ctx || {};
  return {locale:ctx.locale || "uk", purpose:ctx.purpose === "defense" ? "defense" : "civil",
          products:ctx.products || {}, T:typeof ctx.T === "function" ? ctx.T : ident};
}
function variants(ctx, h){ var p = ctx.products[h]; return p && p.variants || []; }
function avail(ctx, h, vt){
  var p = ctx.products[h];
  if (!p || p.available === false) return false;
  return variants(ctx, h).some(function(v){ return v.available && (vt == null || v.title === vt); });
}
function familyOf(ctx, h){
  var p = ctx.products[h];
  if (p && Array.isArray(p.models) && p.models.length) return p.models.map(function(m){ return MNORM[m] || m; });
  return FAMILY[h] || ["*"];
}
function isDefense(s){ return /Сил Оборони/.test(s || ""); }
function variantTitle(it){
  var vt = str(it.variant_title);
  return vt === "Default Title" ? "" : vt;
}
/* Модель «Starlink з модифікацією Adaptis Amulet» лише у варіанті: назва варіанта, опції,
   варіант за id з products. */
function amuletModel(ctx, it, vt){
  var txt = vt + " " + (Array.isArray(it.options_with_values) ? it.options_with_values.map(function(o){ return str(o && o.value); }).join(" ") : "");
  var v = variants(ctx, it.handle).find(function(x){ return String(x.id) === String(it.variant_id); });
  if (v) txt += " " + str(v.title);
  return AMULET_MODELS.find(function(m){ return txt.indexOf(m[0]) > -1; }) || null;
}

/* ---------------------------------------------------------------- 1.1 склад кошика */
function bagOf(cart, ctx){
  ctx = norm(ctx);
  cart = cart || {};
  var attrs = cart.attributes || {};
  var A = function(k){ return str(attrs[k]); };
  var b = {items:[], has:{}, terms:[], ownTerm:false, amulet:false, corpora:[], car:{}, needDc:false,
           hasDc:false, auto:{}, eth:false, subs:{}, mount:false, plates:false, cover:false, backpack:false,
           p2:false, pb27:false, roofRaw:"", roofSrc:"", roof:"unknown", roofKind:"unknown", roofAnswered:false,
           white:false, defense:false, locale:ctx.locale, carAttr:[], homeAttr:[], quiz:false, carPower:false,
           carPowerMini:false, subHomeQ:0, dcLoose:false, noCarSet:false, svcQty:0, subQty:{}, corpusColors:{}, ownRouter:false,
           homeAc:false, noCorpus:false, ownKnown:false};
  var roofVals = [A("Дах авто")], colorVals = [A("Колір")], purposeVals = [A("Призначення")];
  var roofSrc = A("Дах авто") ? ["«Дах авто»"] : [];
  var carAttr = [];
  ["Модель авто", "Код кольору кузова"].forEach(function(k){ if (A(k)) carAttr.push(k); });
  if (A("Інвертор 12-230V з монтажем")){ carAttr.push("Інвертор 12-230V з монтажем"); b.car["inv-attr"] = true; }
  /* 09.10.2026 (власник): «Встановлення» не завжди про авто. «на кондиціонер» (квіз і комплект «для
     квартири та дому») це ознака дому; «без корпусу» (квіз, удома) про авто нічого не каже і означає,
     що корпус на кондиціонер людина вже відхилила; «на будинку» це дім. Решта значень це монтаж на авто. */
  var instKind = function(v){
    if (!v) return;
    if (/будинку/.test(v)){ if (!inArr(b.homeAttr, "виїзний монтаж на будинку")) b.homeAttr.push("виїзний монтаж на будинку"); }
    else if (/кондиціонер/.test(v)) b.homeAc = true;
    else if (/без корпусу/.test(v)) b.noCorpus = true;
    else b.mount = true;
  };
  instKind(A("Встановлення"));
  if (attrs.mobile_install) b.mount = true;
  /* 09.10.2026 (власник): сторінка корпусу з відповіддю «Starlink у мене вже є» пише властивість
     «Starlink: свій»: термінал до корпусу тоді не пропонуємо. */
  if (/свій/.test(A("Starlink"))) b.ownKnown = true;
  if (/власного термінала/.test(A("Adaptis Amulet"))){ b.ownTerm = true; b.amulet = true; }
  if (A("Локація")) b.homeAttr.push("Локація: " + A("Локація"));
  /* Сесія 9 (власник 28.09): «Роутер» з квізу чи сторінки Mini вдома; «свій» означає, що Starlink
     підключатимуть до власного роутера кабелем: тоді до Mini пропонуємо кабель Ethernet (R5). */
  if (/свій|свого/.test(A("Роутер"))) b.ownRouter = true;
  if (A("Підібрано").indexOf("квіз") > -1) b.quiz = true;

  (cart.items || []).forEach(function(it, idx){
    var h = str(it.handle), q = parseInt(it.quantity, 10) || 1, pr = it.properties || {};
    var P = function(k){ return str(pr[k]); };
    var vt = variantTitle(it), key = it.key != null ? it.key : String(it.variant_id) + ":" + idx;
    b.items.push({h:h, q:q, vt:vt, props:pr, i:idx, key:key});
    b.has[h] = true;
    if (P("Дах авто")){ roofVals.push(P("Дах авто")); roofSrc.push("«Дах авто»"); }
    colorVals.push(P("Колір")); colorVals.push(vt);
    purposeVals.push(P("Призначення")); purposeVals.push(vt);
    if (/свій|свого/.test(P("Роутер"))) b.ownRouter = true;
    ["Модель авто", "Код кольору кузова"].forEach(function(k){ if (P(k)) carAttr.push(k); });
    instKind(P("Встановлення"));
    if (/свій/.test(P("Starlink"))) b.ownKnown = true;
    if (P("Підібрано") && P("Підібрано").indexOf("квіз") > -1) b.quiz = true;
    if (TERMS[h]) b.terms.push({h:h, model:TERMS[h], q:q, set:false, amulet:false, i:idx, key:key});
    if (h === H.amuletT){
      var am = amuletModel(ctx, it, vt);
      /* модель не вдалось прочитати: позиція однаково модифікований термінал, Amulet уже є */
      if (am) b.terms.push({h:h, model:am[1], q:q, set:false, amulet:true, i:idx, key:key});
      b.amulet = true;
    }
    if (h === H.amuletS){ b.ownTerm = true; b.amulet = true; b.svcQty += q; }
    var s = SETS[h];
    if (CORPORA[h] || (s && s.corpus)){
      var col = ["В колір авто", "Білий", "Чорний", "Сірий", "Олива", "Premium"].find(function(c){
        return vt.indexOf(c) > -1 || P("Колір").indexOf(c) > -1; });
      b.corpusColors[col || "?"] = true;
    }
    if (s){
      if (s.term) b.terms.push({h:h, model:s.term, q:q, set:true, amulet:false, i:idx, key:key});
      if (s.corpus) b.corpora.push({h:h, m:s.corpus, q:q});
      if (s.car) b.car[s.car] = true;
      if (s.auto) b.auto[s.auto] = true;
      if (s.auto === "p2fit") b.p2 = true;
      if (s.auto === "pb27") b.pb27 = true;
      if (s.eth) b.eth = true;
    }
    if (CORPORA[h]) b.corpora.push({h:h, m:CORPORA[h], q:q});
    if (h === H.psu) b.car.psu = true;
    if (h === H.psu56p) b.car.psu56 = true;
    if (h === H.invp) b.car.inv = true;
    if (h === H.installAway) b.mount = true;
    if (h === H.cc160 || h === H.ccSet) b.car.azp = true;
    if (inArr(CAR_POWER, h)) b.carPower = true;
    if (inArr(CAR_POWER_MINI, h)) b.carPowerMini = true;
    if (h === H.dc) b.dcLoose = true;
    if (inArr(NO_CAR_SET, h)) b.noCarSet = true;
    if (h === H.p2fit){ b.auto.p2fit = true; b.p2 = true; }
    if (h === H.pb27){ b.auto.pb27 = true; b.pb27 = true; }
    if (h === H.eb3a) b.auto.eb3a = true;
    if (h === H.river3) b.auto.river3 = true;
    if (inArr(NEEDS_DC, h)) b.needDc = true;
    if (inArr(HAS_DC, h)) b.hasDc = true;
    if (h === H.eth || h === H.tV5) b.eth = true;
    if (inArr(SUBS, h)){ b.subs[h] = true; b.subQty[h] = (b.subQty[h] || 0) + q; }
    if (h === H.subHome) b.subHomeQ += q;
    if (h === H.install){
      b.mount = true;
      /* варіант монтажу сам каже про дах */
      if (vt){ roofVals.push(vt); roofSrc.push("варіант монтажу"); }
    }
    if (h === H.plates) b.plates = true;
    if (h === H.cover) b.cover = true;
    if (h === H.backpack) b.backpack = true;
  });
  var roof = roofVals.filter(Boolean).join(" ").trim();
  b.roofRaw = roof;
  b.roofSrc = uniq(roofSrc).join(", ");
  b.roofAnswered = !!roof;
  if (/броньов/i.test(roof)){ b.roof = "ok"; b.roofKind = "armored"; }
  else if (/стал/i.test(roof)){ b.roof = "ok"; b.roofKind = "steel"; }
  else if (/панорам|скл|алюмін|пластик/i.test(roof)){ b.roof = "bad"; b.roofKind = "bad"; }
  b.white = /Біл/i.test(colorVals.join(" "));
  b.carColor = /В колір авто/.test(colorVals.join(" ")) || inArr(carAttr, "Код кольору кузова");
  /* категорія з кошика; якщо кошик про неї мовчить, з перемикача сайту */
  var pv = purposeVals.join(" ");
  b.defense = isDefense(pv) || (!/цивіл|Сил Оборони/i.test(pv) && ctx.purpose === "defense");
  b.carAttr = carAttr;
  b.termQty = sum(b.terms, function(t){ return t.q; });
  /* тариф не до термінала на передзамовленні */
  b.tariffTermQty = sum(b.terms.filter(function(t){ return !inArr(PREORDER, t.h); }), function(t){ return t.q; });
  b.miniTermQty = sum(b.terms.filter(function(t){ return inArr(MINI_FAM, t.model); }), function(t){ return t.q; });
  b.minixQty = sum(b.terms.filter(function(t){ return t.model === "minix"; }), function(t){ return t.q; });
  b.miniOnlyQty = sum(b.terms.filter(function(t){ return t.model === "mini"; }), function(t){ return t.q; });
  b.corpusM = b.corpora.map(function(c){ return c.m; });
  b.corpusQty = sum(b.corpora, function(c){ return c.q; });
  b.miniCorpusQty = sum(b.corpora.filter(function(c){ return c.m === "Mini"; }), function(c){ return c.q; });
  b.miniCorpus = inArr(b.corpusM, "Mini");
  var tm = uniq(b.terms.map(function(t){ return t.model; }));
  var models = tm.slice();
  b.corpora.forEach(function(c){
    var cm = CORPUS_MODELS[c.m];
    if (!cm.some(function(m){ return inArr(tm, m); })) models = uniq(models.concat(cm));
  });
  if (!b.terms.length && !b.corpora.length && b.carPowerMini) models = uniq(models.concat(MINI_FAM));
  b.bagOnly = b.backpack && !b.terms.length && !b.corpora.length;
  if (b.bagOnly) models = uniq(models.concat(MINI_FAM));
  b.models = models;
  b.termModels = tm;
  var otherCar = keys(b.car).length || b.mount || b.plates || b.roofAnswered || b.carAttr.length || b.carColor || b.has[H.tFlat];
  b.walkCorpus = !!(b.backpack && b.corpora.length && uniq(b.corpusM).join() === "Mini" && !otherCar);
  /* 09.10.2026 (власник): корпус MiniKit сам ознакою авто не є, його ставлять і на кондиціонер.
     Авто він означає лише поруч з іншою ознакою авто або з тарифом для поїздок. */
  b.miniCarSign = !!(otherCar || b.has[H.subRoam] || b.has[H.subPrio]);
  return b;
}

/* ---------------------------------------------------------------- 1.2 сценарій */
function flagsOf(b){
  var car = [], home = [], move = [], p2bag = [], walk = [];
  if (b.walkCorpus) walk.push("корпус MiniKit разом з рюкзаком");
  else b.corpora.forEach(function(c){ if (c.m !== "Mini" || b.miniCarSign) car.push("корпус " + c.m); });
  if (b.carColor) car.push("корпус «В колір авто»");
  if (keys(b.car).length) car.push("живлення від авто");
  if (b.mount) car.push("обрано спосіб встановлення");
  if (b.plates) car.push("пластини");
  if (b.roofAnswered) car.push("дах (" + b.roofSrc + "): " + b.roofRaw);
  b.carAttr.forEach(function(k){ car.push("«" + k + "»"); });
  if (b.has[H.tFlat]) car.push("Performance Gen2");
  if (b.has[H.subHome]) home.push("тариф «Домашній»");
  home = home.concat(b.homeAttr);
  if (b.homeAc) home.push("корпус на кондиціонер");
  if (b.has[H.tV5]) home.push("V5 Kit");
  if (b.has[H.subRoam]) move.push("тариф «Мандрівний»");
  if (b.has[H.subPrio]) move.push("тариф «Глобальний Пріоритет»");
  if (b.p2) p2bag.push("P2Fit");
  if (b.pb27) p2bag.push("павербанк 27 000");
  if (b.backpack) walk.push("рюкзак");
  return {CAR:car, HOME:home, MOVE:move, WALK:walk, P2BAG:p2bag};
}
function scenarioOf(b){
  var f = flagsOf(b);
  var s = f.CAR.length ? "car" : f.HOME.length ? "home" : f.MOVE.length ? "move" : f.WALK.length ? "walk" : "unknown";
  return {scenario:s, flags:f};
}

/* ---------------------------------------------------------------- 2. правила */
function card(h, rule, order, why, o){
  o = o || {};
  return {h:h, rule:rule, order:order, why:why, vt:o.vt || null, q:o.q == null ? 1 : o.q, note:o.note || "",
          frm:!!o.frm, tag:o.tag || "", lines:o.lines || [], pickNote:!!o.pick};
}

function rules(b, scen, flags, ctx){
  var T = ctx.T, out = [];
  var uk = b.locale === "uk";
  var has = b.has, tm = b.termModels;
  var miniFam = b.models.some(function(m){ return inArr(MINI_FAM, m); });
  var newTerm = b.terms.length > 0;
  var perTerm = Math.max(b.miniTermQty, 1);
  var perCorpus = Math.max(b.corpusQty, 1);
  var carKeys = keys(b.car), autoKeys = keys(b.auto);
  var station = function(){ return avail(ctx, H.river3) ? H.river3 : H.eb3a; };
  /* 28.09.2026 (власник, s10e): коротше пояснення Amulet і без підказок, як працює кнопка
     («Додати» відкриває вибір кольору чи довжини): вибір і так відкривається. */
  var AMULET_WHY = ADL("Starlink працює під час повітряних тривог.");
  var KIT_NOTE = "";

  /* R1. Amulet на кожен немодифікований термінал; послуга спершу покриває термінали, до яких іде послугою. */
  if (uk && newTerm){
    var cat = b.defense ? "Для Сил Оборони України та волонтерів" : "Для цивільного та комерційного використання";
    var kind = function(t){
      return !t.set && inArr(["mini", "minix", "std4x"], t.model) && avail(ctx, H.amuletT, cat + " / " + MODEL_T[t.model]) ? "a" : "svc";
    };
    var svcLeft = b.svcQty, svcQ = 0;
    var ts = b.terms.filter(function(t){ return !t.amulet; })
      .map(function(t, i){ return {t:t, i:i, k:kind(t) === "svc" ? 0 : 1}; })
      .sort(function(x, y){ return x.k - y.k || x.i - y.i; }).map(function(x){ return x.t; });
    ts.forEach(function(t){
      var q = t.q - Math.min(t.q, svcLeft);
      svcLeft -= t.q - q;
      if (!q) return;
      if (kind(t) === "a"){
        out.push(card(H.amuletT, "R1a", 1, AMULET_WHY, {vt:cat + " / " + MODEL_T[t.model], q:q, tag:"replace", lines:[t.key]}));
      } else svcQ += q;
    });
    if (svcQ){
      var want = b.defense ? "Для Сил Оборони України та волонтерів" : "Для цивільного використання";
      var svcLine = b.items.filter(function(it){ return it.h === H.amuletS; }).slice(0, 1).map(function(it){ return it.key; });
      out.push(card(H.amuletS, "R1b", 1, AMULET_WHY, {vt:want, q:svcQ, tag:has[H.amuletS] ? "topup" : "", lines:svcLine}));
    }
  }
  if (b.miniCorpus && !newTerm && !b.ownTerm && !b.ownKnown){
    out.push(card(H.tMini, "R1c", 1, ADL("Якщо Starlink у вас ще немає: найменший Starlink з вбудованим Wi-Fi, стає у ваш корпус."), {q:b.miniCorpusQty}));
    /* Сесія 9 (власник 28.09): Mini X для авто не пропонуємо ніколи, корпус MiniKit це авто. */
  }
  /* 17.10.2026: G3kit поруч зі Standard 4 теж має свій термінал. Без термінала R1d, як і раніше, радить 4X. */
  if (inArr(b.corpusM, "Gen3") && !inArr(tm, "std4x") && !inArr(tm, "std4") && !b.ownTerm && !b.ownKnown)
    out.push(card(H.t4x, "R1d", 1, ADL("Якщо Starlink у вас ще немає: велика антена з окремим роутером, під неї зроблено ваш корпус.")));
  /* R1f (власник 28.09): корпус MiniKit, G3kit чи G2kit без Starlink, імовірно термінал уже є: послуга
     Amulet на свій термінал, по одній на такий корпус. HP ні: там замовлення йдуть інакше. */
  var ownQ = b.corpora.reduce(function(s, c){ return s + (c.m === "Mini" || c.m === "Gen3" || c.m === "Gen2" ? c.q : 0); }, 0);
  if (ownQ && !newTerm && !b.ownTerm)
    out.push(card(H.amuletS, "R1f", 1, b.ownKnown ? ADL("Модифікуємо ваш Starlink, і він працюватиме під час повітряних тривог.")
      : ADL("Якщо Starlink у вас уже є: модифікуємо його, і він працюватиме під час повітряних тривог."),
      {vt:b.defense ? "Для Сил Оборони України та волонтерів" : "Для цивільного використання", q:ownQ}));

  /* R1e / R11. Корпус MiniKit до Mini чи Mini X (або до живлення від авто без термінала). */
  var kitVt = (b.defense ? "Для Сил Оборони України" : "Для цивільного чи комерційного використання") + " / Чорний";
  var miniSrc = b.miniTermQty > 0 || (!newTerm && b.carPowerMini);
  if (miniSrc && !b.corpora.length){
    var kit = function(rule, order, why, q){ out.push(card(H.miniKit, rule, order, why, {vt:kitVt, q:q == null ? perTerm : q, note:KIT_NOTE, pick:true})); };
    if (b.backpack && b.miniTermQty) kit("R11", 2.5, ADL("Корпус на магнітах: саме за нього рюкзак тримає Starlink зовні, на передній панелі."));
    else if (scen === "car") kit("R1e", 2.5, ADL("Тримає Starlink на даху авто на магнітах: без свердління, знімається за хвилину."));
    /* Сесія 9 (власник 28.09): Mini X для авто не пропонуємо, тож умовний корпус «на дах авто» лише до Mini. */
    else if ((scen === "move" || scen === "unknown") && b.miniOnlyQty){
      var why;
      if (b.noCarSet) why = ADL("Корпус на магнітах: Starlink стає на дах авто без свердління або на рюкзак Adaptis.");
      else if (b.p2) why = ADL("Корпус на магнітах: Starlink стає на дах авто без свердління або на рюкзак Adaptis.");
      else why = ADL("Корпус на магнітах: Starlink стоїть на даху авто чи на кондиціонері за вікном, без свердління.");
      kit("R1e", scen === "move" ? 8.5 : 3.5, why, b.miniOnlyQty);
    }
    /* R1h (власник 09.10.2026): удома до Mini чи Mini X радимо корпус на кондиціонер; білий, як у комплекті
       «для квартири та дому». Не радимо, коли у квізі людина обрала «без корпусу». */
    else if (scen === "home" && !flags.MOVE.length && b.miniTermQty && !b.noCorpus)
      out.push(card(H.miniKit, "R1h", 3.5, ADL("Корпус на магнітах: Starlink стоїть на кондиціонері за вікном, без свердління."),
        {vt:kitVt.replace("Чорний", "Білий"), q:perTerm, note:KIT_NOTE, pick:true}));
    else if (scen === "home" && flags.MOVE.length && b.miniOnlyQty)
      kit("R1e", 8.5, ADL("Корпус на магнітах: Starlink стоїть на даху авто чи на кондиціонері за вікном, без свердління."), b.miniOnlyQty);
  }
  /* R11b. Лише рюкзак: корпус умовно. */
  if (b.bagOnly)
    out.push(card(H.miniKit, "R11", 8.5, ADL("Якщо ваш Starlink ще без корпусу: рюкзак тримає термінал саме за магніти корпусу."),
      {vt:kitVt, note:KIT_NOTE, pick:true}));

  /* R2. Кабель DC-TypeC до АЗП без кабелю. */
  if (b.needDc && !b.hasDc){
    var w2 = b.corpora.length ? ADL("З'єднує вашу автозарядку зі Starlink: 5 м вистачає від прикурювача до даху.")
           : newTerm ? ADL("З'єднує вашу автозарядку зі Starlink: 5 м від прикурювача до термінала.")
           : ADL("Якщо автозарядка для Starlink Mini чи Mini X: цей кабель з'єднує її з терміналом.");
    out.push(card(H.dc, "R2", 2, w2, {tag:"r2"}));
  }

  /* R2b. Кабель DC-TypeC окремо без джерела USB-C PD 100 Вт. */
  var src = b.car.azp || b.car.cig || b.pb27 || b.auto.river3 || b.auto.eb3a;
  if (b.dcLoose && !src){
    if (scen !== "car")
      out.push(card(H.cc160, "R2b", 2, ADL("Якщо Starlink буде в авто: порт 100 Вт живить його через ваш кабель, ще USB-C і USB по 30 Вт."), {tag:"r2b"}));
    else if (carKeys.length)
      out.push(card(H.cc160, "R2b", 2, ADL("Порт 100 Вт живить Starlink через ваш кабель, ще USB-C і USB по 30 Вт для ваших пристроїв."), {tag:"r2b"}));
    if (scen !== "car")
      out.push(card(station(), "R2b", 2, scen === "home"
        ? ADL("Живить Starlink через ваш кабель, коли немає світла: приблизно 5 годин.")
        : ADL("Якщо Starlink працюватиме без розетки: живить його через ваш кабель приблизно 5 годин."), {tag:"r2b"}));
  }

  /* R3. Тариф, 3 місяці на кожен термінал. */
  if (b.tariffTermQty && !keys(b.subs).length){
    var q3 = 3 * b.tariffTermQty;
    var roamCar = ADL("Інтернет в авто й у поїздках, зокрема в русі. Акаунт оформимо й оплачуватимемо за вас.");
    /* 28.09.2026 (власник, s10e): «у русі» без «їздитиме чи ходитиме», «за однією адресою»
       без «удома чи на дачі». */
    var roamUnk = ADL("Якщо Starlink їздитиме з вами: працює в русі й там, де ви зупинились.");
    var roamBag = roamUnk;
    var homeHome = ADL("Безлімітний інтернет за однією адресою. Акаунт оформимо й оплачуватимемо за вас.");
    var homeUnk = ADL("Якщо Starlink стоятиме на одному місці: безлімітний інтернет за однією адресою.");
    if (scen === "car") out.push(card(H.subRoam, "R3", 3, roamCar, {q:q3}));
    else if (scen === "home" && b.backpack){
      out.push(card(H.subRoam, "R3", 3, roamBag, {q:q3}));
      out.push(card(H.subHome, "R3", 3, homeUnk, {q:q3}));
    }
    else if (scen === "home") out.push(card(H.subHome, "R3", 3, homeHome, {q:q3}));
    else if (b.backpack) out.push(card(H.subRoam, "R3", 3, roamBag, {q:q3}));
    else if (scen === "unknown"){
      out.push(card(H.subRoam, "R3", 3, roamUnk, {q:q3}));
      out.push(card(H.subHome, "R3", 3, homeUnk, {q:q3}));
    }
  }
  /* R3b і R3c прибрано 09.10.2026 (власник): тариф не радимо, коли в кошику вже є будь-який тариф.
     Примітка про зайвий тариф лишилась. */
  b.winNote = "";
  if (b.tariffTermQty && keys(b.subs).length){
    if (keys(b.subs).length > b.tariffTermQty) b.winNote = ADL("Один Starlink працює на одному тарифі: залиште той, що вам підходить.");
  }

  /* R4. Живлення від авто. */
  if (miniFam && scen === "car" && !carKeys.length){
    var pb = b.p2 || b.pb27;
    if (b.hasDc) out.push(card(H.cc160, "R4", 4, ADL("Порт 100 Вт живить Starlink через ваш кабель, ще USB-C і USB по 30 Вт для ваших пристроїв."), {q:perTerm}));
    else out.push(card(H.ccSet, "R4", 4, pb ? ADL("У дорозі живить Starlink і заряджає ваш павербанк від того самого прикурювача.")
      : ADL("Автозарядка на 160 Вт: порт 100 Вт для Starlink, ще USB-C і USB по 30 Вт для ваших пристроїв."), {q:perTerm}));
    if (b.corpora.length && !pb && !b.hasDc)
      out.push(card(H.psu, "R4", 4, ADL("Найпростіше живлення від прикурювача: кабель Starlink з коробки вмикається напряму."), {q:perTerm}));
  }

  /* R4u (власник 09.10.2026): корпус MiniKit без ознак авто чи дому. Про авто не стверджуємо, тож
     живлення від прикурювача умовно, одним товаром. */
  if (b.miniCorpus && scen === "unknown" && !carKeys.length && !b.dcLoose && !b.hasDc)
    out.push(card(H.ccSet, "R4", 4, ADL("Якщо корпус стоятиме на авто: автозарядка з портом 100 Вт для Starlink, ще USB-C і USB по 30 Вт."), {q:perTerm}));

  /* R5. Кабель Ethernet. */
  var bagNoHome = b.backpack && !flags.HOME.length;
  if (!b.eth){
    if (inArr(tm, "minix") && bagNoHome){ /* пішому довгий кабель до роутера ні до чого */ }
    else if (inArr(tm, "minix")){
      out.push(card(H.eth, "R5", 5, ADL("З'єднує антену надворі з роутером Mini X у приміщенні: у коробці такого кабелю немає."),
        {q:b.minixQty, pick:true}));
    }
    else if (inArr(tm, "std4x") && scen !== "car")
      out.push(card(H.eth, "R5", 5, ADL("Якщо 15 м з коробки замало: кабель від антени до роутера на 23 або 45 м."),
        {pick:true}));
    /* Сесія 9 (власник 28.09): людина сама сказала, що підключить Starlink Mini до свого роутера (квіз чи
       сторінка Mini, вдома). Кабель підходить до будь-якого роутера, зокрема не Starlink. Без цієї
       відповіді кабель до Mini не пропонуємо (правило 3). */
    else if (inArr(tm, "mini") && b.ownRouter && !flags.CAR.length)
      out.push(card(H.eth, "R5", 5, ADL("З'єднує Starlink за вікном з вашим роутером у квартирі."),
        {q:b.miniOnlyQty, pick:true}));
  }

  /* R6. Монтаж у Центрі інсталяції; дах невідомий: «від», варіант даху в картці.
     09.10.2026 (власник): лише в сценарії авто; до корпусу MiniKit без ознак умовно; удома не пропонуємо. */
  if (uk && b.corpusM.some(function(m){ return inArr(["Mini", "Gen3", "Gen2"], m); }) && !b.mount && !b.walkCorpus && (scen === "car" || scen === "unknown")){
    var k = b.roofKind;
    var iv = variants(ctx, H.install).find(function(v){
      var t = str(v.title);
      return k === "steel" || k === "unknown" ? t.indexOf("Сталь") === 0 : k === "armored" ? t.indexOf("Броньоване") === 0 : t.indexOf("Панорама") === 0;
    });
    if (iv) out.push(card(H.install, "R6", 6, scen === "car" ? ADL("У Києві поставимо корпус і прокладемо живлення в салон, виїзний монтаж узгодить менеджер.")
      : ADL("Якщо корпус стоятиме на авто: у Києві поставимо його і прокладемо живлення в салон."),
      {vt:iv.title, frm:k === "unknown", q:perCorpus}));
  }

  /* R7. Пластини: колір наперед лише до всіх білих чи всіх чорних корпусів. */
  if (b.corpora.length && !b.plates && (b.roof === "bad" || b.roof === "unknown") && !b.walkCorpus && scen === "car"){
    var cc = keys(b.corpusColors);
    var pv = cc.length === 1 && cc[0] === "Білий" ? "Білий" : cc.length === 1 && cc[0] === "Чорний" ? "Чорний" : null;
    var po = {vt:pv, q:perCorpus, note:"", pick:!pv};
    if (b.roof === "bad" && b.mount)
      out.push(card(H.plates, "R7", 1.5, ADL("Сталева основа під магніти на вашому даху: чотири пластини наклеїмо під час монтажу."), po));
    else
      out.push(card(H.plates, "R7", 7, b.roof === "bad" ? ADL("Сталева основа під магніти на вашому даху: чотири пластини клеяться без свердління.")
        : ADL("Сталева основа під магніти корпусу на панорамному, алюмінієвому чи пластиковому даху."), po));
  }

  /* R8. Автономне живлення. */
  /* 10.10.2026 (власник): станцію називаємо зарядною станцією, не батареєю (правка 09.10 знята); про режим ДБЖ
     на картці не пишемо, текст однаковий для обох станцій. Час залежить від термінала: Mini і Mini X приблизно
     5 годин, Standard 4X приблизно 2; модель невідома: без цифри. */
  var stHome = function(h, hours){
    if (h === H.river3)
      return hours === 5 ? ADL("Зарядна станція: коли немає світла, Starlink працює від неї приблизно 5 годин.")
           : hours === 2 ? ADL("Зарядна станція: коли немає світла, Starlink працює від неї приблизно 2 години.")
           : ADL("Зарядна станція: коли немає світла, Starlink працює від неї.");
    return hours === 5 ? ADL("Зарядна станція: коли немає світла, Starlink працює від неї приблизно 5 годин.")
         : hours === 2 ? ADL("Зарядна станція: коли немає світла, Starlink працює від неї приблизно 2 години.")
         : ADL("Зарядна станція: коли немає світла, Starlink працює від неї.");
  };
  var homeNt = scen === "home" && !newTerm && !b.corpora.length && !autoKeys.length && (has[H.subHome] || b.ownTerm);
  if (homeNt) out.push(card(station(), "R8", 8, stHome(station(), 0), {tag:"home-reserve anymodel"}));
  var homeO = 4.5;
  if (!autoKeys.length && (newTerm || b.corpora.length || b.carPowerMini || b.bagOnly)){
    var minixOnly = tm.length > 0 && tm.every(function(m){ return m === "minix"; });
    var unkSt = ADL("Зарядна станція: приблизно 5 годин інтернету, коли немає світла або розетки поруч.");
    /* 09.10.2026 (власник): рядок каже, що це і що дає, а не одну ситуацію «стоянка»; 10.10: «павербанк», не «батарея». */
    var p2Bag = ADL("Павербанк для Starlink на приблизно 3 години: у вашому рюкзаку для нього є окрема кишеня.");
    var p2Move = ADL("Павербанк, що кріпиться прямо на Starlink: приблизно 3 години інтернету без розетки й авто.");
    if (miniFam){
      if (scen === "car"){
        /* адаптер 12-24V займає гніздо: про заряджання від авто в такому кошику не пишемо */
        var p2Car = b.car.psu && !b.car.azp ? ADL("Павербанк, що кріпиться прямо на Starlink: приблизно 3 години інтернету із заглушеним двигуном.")
                  : ADL("Павербанк: у дорозі заряджається від авто кабелем DC і водночас живить Starlink, автономно приблизно 3 години.");
        out.push(card(H.p2fit, "R8", 8, p2Car, {q:perTerm}));
        if (b.car.azp && b.hasDc && !b.car.psu)
          out.push(card(H.pb27, "R8", 8.1, ADL("Павербанк на 27 000 mAh: із заглушеним двигуном живить Starlink приблизно 3 години."), {q:perTerm}));
      } else if (scen === "home"){
        out.push(card(station(), "R8", homeO, stHome(station(), 5), {tag:"home-reserve"}));
        /* 28.09 (власник): P2Fit це мобільність (авто, поїздки), не резерв удома. Удома лише станція;
           P2Fit лише з ознакою мобільності (рюкзак чи тариф для поїздок), з текстом про поїздки. */
        if (b.backpack || flags.MOVE.length) out.push(card(H.p2fit, "R8", homeO, b.backpack ? p2Bag : p2Move, {q:perTerm}));
      } else if (b.backpack) out.push(card(H.p2fit, "R8", 8, p2Bag, {q:perTerm}));
      else if (scen === "move") out.push(card(H.p2fit, "R8", 8, p2Move, {q:perTerm}));
      else {
        out.push(card(H.p2fit, "R8", 3.4, p2Move, {q:perTerm}));
        out.push(card(station(), "R8", 3.6, unkSt, {tag:"home-reserve"}));
      }
    }
    if (inArr(tm, "v5")) out.push(card(station(), "R8", scen === "home" ? homeO : 8, stHome(station(), 0), {tag:"home-reserve"}));
    var g3Power = !!(b.car.psu56 || b.car.inv || b.car["inv-attr"]);
    var bigCorpus = b.corpusM.some(function(m){ return m === "Gen3" || m === "Gen2"; });
    var bigTerm = b.models.some(function(m){ return m === "std4x" || m === "std4" || m === "gen2"; });
    /* цифру «приблизно 2 години» пишемо лише для Standard 4X і Standard 4 (опис станції; у Standard 4 те саме
       споживання 75-100 Вт разом з роутером, s77 17.10.2026); з Gen2 без цифри. Назва Standard 4 лише тоді,
       коли 4X у кошику немає (корпус G3kit без термінала дає обидві моделі) */
    var h4 = (inArr(b.models, "std4x") || inArr(b.models, "std4")) && !inArr(b.models, "gen2") ? 2 : 0;
    var s4 = h4 && !inArr(b.models, "std4x");
    var ebCar = s4 ? ADL("Зарядна станція: Standard 4 працює приблизно 2 години там, де розетки немає.")
              : h4 ? ADL("Зарядна станція: Standard 4X працює приблизно 2 години там, де розетки немає.")
              : ADL("Зарядна станція: Starlink працює там, де розетки немає.");
    if (bigCorpus && !g3Power) out.push(card(H.eb3a, "R8", 8, ebCar));
    else if (bigTerm && !bigCorpus){
      if (scen === "home") out.push(card(station(), "R8", homeO, stHome(station(), h4), {tag:"home-reserve"}));
      else if (scen === "unknown"){
        out.push(card(H.eb3a, "R8", 8, s4 ? ADL("Зарядна станція: Standard 4 працює приблизно 2 години, сама заряджається до 80% за 40 хвилин.")
          : h4 ? ADL("Зарядна станція: Standard 4X працює приблизно 2 години, сама заряджається до 80% за 40 хвилин.")
          : ADL("Зарядна станція з розеткою 230 В: заряджається до 80% за 40 хвилин.")));
        out.push(card(H.river3, "R8", 8, stHome(H.river3, h4), {tag:"home-reserve"}));
      }
      else out.push(card(H.eb3a, "R8", 8, ebCar));
    }
  }

  /* R9. Камуфляжний чохол, по картці на модель корпусу. 05.10.2026 (власник): до будь-якого корпусу
     Adaptis, незалежно від кольору й призначення (раніше цивільним з білим чи «В колір авто» не показували).
     06.10.2026 (власник): одразу після Adaptis Amulet і підписки (порядок 3.2, було 9). */
  var cms = uniq(b.corpusM.filter(function(m){ return inArr(["Mini", "Gen3", "Gen2"], m); }));
  /* 09.10.2026 (власник): удома (корпус на кондиціонер) чохол і рюкзак не пропонуємо. */
  if (cms.length && !b.cover && scen !== "home"){
    cms.forEach(function(m){
      out.push(card(H.cover, "R9", 3.2, b.defense ? ADL("Камуфляж робить корпус менш помітним і береже його від пилу й подряпин.")
        : ADL("Береже корпус від пилу й подряпин у дорозі й на зберіганні: Мультикам або Піксель."),
        {vt:"(" + m + ")", q:sum(b.corpora.filter(function(c){ return c.m === m; }), function(c){ return c.q; }),
         pick:true}));
    });
  }

  /* R10 (рішення власника 5, 28.09). Рюкзак лише до корпусу MiniKit, у будь-якому сценарії, після чохла. */
  if (b.miniCorpus && !b.backpack && scen !== "home")
    out.push(card(H.backpack, "R10", 9.5, ADL("Ваш корпус зі Starlink тримається на рюкзаку магнітами, усередині кишеня для павербанка."), {q:b.miniCorpusQty}));
  return out;
}

/* ---------------------------------------------------------------- вето і R99 */
var NEVER = [H.subPrio, H.magnets, H.mini15, H.ethAdapter].concat(REQUESTS, keys(SETS));
var CAR_ONLY = [H.ccSet, H.cc160, H.psu, H.dc];

function actionOf(c){
  if (c.tag === "replace") return "replace";
  if (c.tag === "topup") return "inc";
  return c.pickNote ? "pick" : "add";
}
function variantOf(c, ctx){
  var vs = variants(ctx, c.h), vt = c.vt;
  if (vt && vt.charAt(0) === "(")
    return vs.find(function(x){ return str(x.title).indexOf(vt) > -1 && x.available; }) ||
           vs.find(function(x){ return str(x.title).indexOf(vt) > -1; }) || null;
  if (vt) return vs.find(function(x){ return x.title === vt; }) || null;
  if (c.pickNote) return null;
  return vs.find(function(x){ return x.available; }) || null;
}

function windowOf(cart, ctx){
  ctx = norm(ctx);
  var b = bagOf(cart, ctx);
  var sc = scenarioOf(b), scen = sc.scenario, flags = sc.flags;
  var raw = rules(b, scen, flags, ctx);
  var sorted = raw.map(function(c, i){ return {c:c, i:i}; })
    .sort(function(x, y){ return x.c.order - y.c.order || x.i - y.i; }).map(function(x){ return x.c; });
  var out = [], dropped = [], seen = {};
  sorted.forEach(function(c){
    var h = c.h, why = null, fam = familyOf(ctx, h);
    if (flags.CAR.length && h === H.subHome) why = "вето: авто";
    else if (flags.HOME.length && !flags.CAR.length && inArr(CAR_ONLY, h) && c.tag !== "r2") why = "вето: дім без авто";
    else if (flags.MOVE.length && !flags.HOME.length && (h === H.subHome || c.tag.indexOf("home-reserve") > -1)) why = "вето: поїздки";
    else if (inArr(NEVER, h)) why = "R99: ніколи";
    else if (inArr(PREORDER, h)) why = "R99: передзамовлення";
    else if (b.has[h] && c.tag !== "topup" && c.tag !== "replace") why = "R99: уже в кошику";
    else if (b.locale !== "uk" && (h === H.amuletT || h === H.amuletS || h === H.install)) why = "R99: лише uk";
    else if (!avail(ctx, h, c.vt && c.vt.charAt(0) !== "(" ? c.vt : null)) why = "R99: немає в наявності";
    else if (c.tag !== "r2" && c.tag !== "r2b" && c.tag.indexOf("anymodel") < 0 && !inArr(fam, "*") &&
             !fam.some(function(m){ return inArr(b.models, m); })) why = "R99: чужа модель";
    /* Amulet до двох моделей і чохол на корпуси двох моделей: окремі картки */
    var key = h === H.amuletT || h === H.cover ? h + "|" + c.vt + (c.rule === "R1a" ? "|" + c.lines.join(",") : "") : h;
    if (!why && seen[key]) why = "дубль";
    if (why){ dropped.push({h:h, rule:c.rule, reason:why}); return; }
    seen[key] = true;
    out.push(c);
  });
  var cards = out.slice(0, 10).map(function(c){
    var v = variantOf(c, ctx), a = actionOf(c);
    var r = {h:c.h, rule:c.rule, qty:c.q, variantId:v ? v.id : null, why:c.why, action:a};
    if (a === "replace") r.replaceKeys = c.lines.slice();
    if (a === "inc") r.incKey = c.lines.length ? c.lines[0] : null;
    if (c.note) r.note = c.note;
    if (c.frm) r.from = true;
    return r;
  });
  /* 28.09.2026 (власник, s10j): одна картка Adaptis Amulet на весь кошик. Кілька
     Starlink (Mini і Mini X, набори) давали кілька карток Amulet; тепер одна, і
     «Додати» робить усе разом: кожен Starlink стає «Starlink + Amulet», а до
     термінала, який так не замінити, додається послуга. Ціна картки це сума доплат. */
  var amIdx = [];
  cards.forEach(function(r, i){ if ((r.h === H.amuletT || r.h === H.amuletS) && (r.rule === "R1a" || r.rule === "R1b")) amIdx.push(i); });
  if (amIdx.length > 1){
    var am = amIdx.map(function(i){ return cards[i]; });
    var merged = {h:am[0].h, rule:"R1", qty:sum(am, function(r){ return r.qty; }), variantId:am[0].variantId, why:am[0].why, action:"multi",
      parts:am.map(function(r){ return {h:r.h, variantId:r.variantId, qty:r.qty, action:r.action, replaceKeys:r.replaceKeys || [], incKey:r.incKey || null}; })};
    cards = cards.filter(function(r, i){ return amIdx.indexOf(i) < 0; });
    cards.splice(amIdx[0], 0, merged);
  }
  return {cards:cards, note:b.winNote || null, scenario:scen, flags:flags, dropped:dropped, bag:b};
}
function windowCards(cart, ctx){ return windowOf(cart, ctx).cards; }

return {
  H:H, PIN_RECS:CANDIDATES.slice(), SETS:SETS, FAMILY:FAMILY,
  bagOf:bagOf, flagsOf:flagsOf, scenarioOf:scenarioOf,
  windowOf:windowOf, windowCards:windowCards, shortName:shortName
};
})();
const SUBS = [SUB_HOME, SUB_HANDLE, SUB_PRIO];
const PIN_RECS = AdaptisRecsCore.PIN_RECS.filter(h => AMULET_ON || (h !== AMULET_HANDLE && h !== AdaptisRecsCore.H.amuletT));
function productId(){
  if (opts.productId) return Promise.resolve(opts.productId);
  if (!opts.productHandle) return Promise.resolve(null);
  return fetch(cartRoot() + "products/" + opts.productHandle + ".js").then(r => r.ok ? r.json() : null)
    .then(p => p ? p.id : null).catch(() => null);
}
/* 28.09.2026: той самий запит, поки він ще йде (заздалегідь і з відкриттям
   вікна одночасно), не дублюємо. */
let recsLoading = null, recsLoadingFor = null;
function loadRecs(){
  const key = opts.productId || opts.productHandle || "";
  if (popRecs && popRecsFor === key) return Promise.resolve(popRecs);
  if (recsLoading && recsLoadingFor === key) return recsLoading;
  recsLoadingFor = key;
  /* 28.09.2026: рекомендацій Shopify у вікні немає, тож id товару не потрібен. */
  const p = recsLoading = loadRecsFor(null, key);
  p.then(() => { if (recsLoading === p) recsLoading = null; }, () => { if (recsLoading === p) recsLoading = null; });
  return p;
}
let pinsReady = null, pinsBy = {};
function loadRecsFor(pid, key){
  const one = h => fetch(cartRoot() + "products/" + h + ".js").then(r => r.ok ? r.json() : null).catch(() => null);
  /* 25.09.2026: товари матриці вантажимо раз за відвідування сторінки. */
  if (!pinsReady) pinsReady = Promise.all(PIN_RECS.map(one)).then(list => {
    list.forEach(p => { if (p) pinsBy[p.handle] = Object.assign({}, p, {url:p.url || (cartRoot() + "products/" + p.handle)}); });
    return list;
  });
  /* 28.09.2026 (власник): рекомендацій Shopify (complementary, related) у
     вікні більше немає, лише матриця. */
  return pinsReady.then(() => { popRecs = []; popRecsFor = key; return popRecs; });
}
/* 09.10.2026 (власник): ті самі картки показує і сторінка кошика (блок «Разом із цим купують»). inline це
   {host}: куди малювати замість вікна. Картки Adaptis Amulet там не показуємо: у кошику для нього є свій блок. */
function paintRecs(c, inline){
  const host = inline ? inline.host : pop.querySelector(".cpop__recs");
  /* 28.09.2026: картки, їхній порядок, кількість, варіант і «навіщо» рахує
     AdaptisRecsCore за всім кошиком; тут лише малюємо й виконуємо дію картки. */
  const win = AdaptisRecsCore.windowOf(c, {locale: window.ADAPTIS_LOCALE || "uk", purpose: opts.purpose(), products: pinsBy, T: ADL});
  const list = (win.cards || []).filter(k => pinsBy[k.h] && !(inline && (k.h === AMULET_HANDLE || k.h === AdaptisRecsCore.H.amuletT)));
  /* 28.09.2026: той самий набір карток не перемальовуємо (вікно могло вже
     показати його): без блимання фото й без скидання обраного строку чи даху. */
  const sig = list.map(k => [k.h, k.qty, k.variantId, k.action].join(":")).join(",") + "|" + (win.note || "") + "|" + opts.purpose();
  if (host.dataset.sig === sig && host.querySelector(".cpop__rc:not(.cpop__rc--sk)")) return;
  host.dataset.sig = sig;
  host.innerHTML = "";
  if (!list.length && !win.note) return;
  const h = document.createElement("h3");
  h.className = "cpop__rt";
  h.textContent = ADL("Разом із цим купують");
  host.appendChild(h);
  if (win.note){
    const n = document.createElement("p");
    n.className = "cpop__rnote";
    n.textContent = win.note;
    host.appendChild(n);
  }
  if (!list.length) return;
  const row = document.createElement("div");
  row.className = "cpop__rrow";
  const lineBy = {};
  (c.items || []).forEach(i => { if (i.key) lineBy[i.key] = i; });
  list.forEach(k => {
    const p = pinsBy[k.h];
    const avail = (p.variants || []).filter(x => x.available);
    let v = avail.find(x => x.id === k.variantId) || avail[0];
    if (!v) return;
    const isSub = SUBS.indexOf(k.h) > -1;
    const isInstall = k.h === INSTALL_HANDLE;
    const isAm = k.h === AMULET_HANDLE || k.h === AdaptisRecsCore.H.amuletT;
    const pick = k.action === "pick";
    /* s24b 06.10.2026 (власник): чохол у цьому вікні обирається списком «Мультикам / Піксель», як строк підписки,
       і додається одразу, без вікна швидкої покупки. У списку лише варіанти під модель корпусу з кошика. */
    const coverTag = k.h === AdaptisRecsCore.H.cover ? (String(v.title).match(/\([^)]+\)\s*$/) || [""])[0].trim() : "";
    const coverVars = coverTag ? avail.filter(x => String(x.title).indexOf(coverTag) > -1) : [];
    const coverSel = coverVars.length > 1;
    let qty = pick && !coverSel ? 1 : (k.qty || 1);
    /* Ціна: для заміни термінала на «Starlink з модифікацією» показуємо саму
       модифікацію (різницю), для решти ціну варіанта на кількість. */
    const replaced = (k.replaceKeys || []).map(x => lineBy[x]).filter(Boolean);
    const partVar = pt => ((pinsBy[pt.h] || {}).variants || []).find(x => x.id === pt.variantId);
    const priceOf = () => {
      if (k.action === "multi") return (k.parts || []).reduce((s, pt) => {
        const pv = partVar(pt), rl = (pt.replaceKeys || []).map(x => lineBy[x]).filter(Boolean);
        if (!pv) return s;
        return s + (pt.action === "replace" && rl[0] ? Math.max(0, (pv.price - rl[0].price) * pt.qty) : pv.price * pt.qty);
      }, 0);
      if (k.action === "replace" && isAm && replaced[0]) return Math.max(0, (v.price - replaced[0].price) * qty);
      return v.price * qty;
    };
    /* 09.10.2026 (власник): «від» рахуємо серед варіантів тієї ж цінової категорії, що й варіант картки.
       Раніше цивільний покупець бачив у картці корпусу «від 7 200 ₴», ціну для Сил Оборони. */
    const defRe = /Сил Оборони|Defen[cs]e|Sił Obrony|Siły Obrony/i;
    const priceHtml = () => {
      const same = avail.filter(x => defRe.test(String(x.title)) === defRe.test(String(v.title)));
      if ((pick || k.from) && same.some(x => x.price !== v.price)) return (ADL("від") + " ") + money(Math.min.apply(null, same.map(x => x.price)) * (pick ? 1 : qty));
      return money(priceOf());
    };
    const name = isAm ? "Adaptis Amulet" : (AdaptisRecsCore.shortName(k.h, ADL) || p.title);
    const months = SUB_MONTHS.indexOf(qty) > -1 ? SUB_MONTHS : SUB_MONTHS.concat([qty]).sort((a, b) => a - b);
    const card = document.createElement("div");
    card.className = "cpop__rc" + (isAm ? " cpop__rc--am" : "");
    const img = isAm ? lineImg({handle: AMULET_HANDLE, image: p.featured_image}, 240) : lineImg(p, 240);
    card.innerHTML =
      '<a class="cpop__ri" href="' + escHtml(p.url) + '">' + (img ? '<img src="' + escHtml(img) + '" alt="" loading="lazy">' : '') + '</a>' +
      '<a class="cpop__rn" href="' + escHtml(p.url) + '">' + escHtml(name) + '</a>' +
      (k.why ? '<span class="' + (isAm ? "cpop__racc" : "cpop__rwhy") + '">' + escHtml(k.why) + '</span>' : '') +
      /* s13z12 (власник): лише картка Amulet, форма та сама: посилання на вікно «Що таке Adaptis Amulet?». */
      (isAm ? '<button type="button" class="cpop__rinfo" data-aminfo>' + escHtml(ADL("Що таке Adaptis Amulet?")) + '</button>' : '') +
      (k.note ? '<span class="cpop__rwhy">' + escHtml(k.note) + '</span>' : '') +
      /* 22.09.2026: ціна одразу під назвою, вибір строку чи даху вже під нею. */
      '<b class="cpop__rp">' + priceHtml() + '</b>' +
      (isInstall && avail.length > 1 ? ("<select class=\"cpop__rs\" aria-label=\"" + ADL("Тип даху").replace(/"/g, "&quot;") + "\">") + avail.map(x =>
        '<option value="' + x.id + '"' + (x.id === v.id ? ' selected' : '') + '>' + escHtml(x.title.replace(/\s*\(.*\)\s*/, "")) + '</option>').join("") + '</select>' : '') +
      (coverSel ? ("<select class=\"cpop__rs\" aria-label=\"" + ADL("Камуфляж").replace(/"/g, "&quot;") + "\">") + coverVars.map(x =>
        '<option value="' + x.id + '"' + (x.id === v.id ? ' selected' : '') + '>' + escHtml(String(x.title).replace(coverTag, "").trim()) + '</option>').join("") + '</select>' : '') +
      (isSub && k.action !== "inc" ? ("<select class=\"cpop__rs\" data-months aria-label=\"" + ADL("Строк підписки").replace(/"/g, "&quot;") + "\">") + months.map(n =>
        '<option value="' + n + '"' + (n === qty ? ' selected' : '') + '>' + monthsT(n) + '</option>').join("") + '</select>' : '') +
      ("<button type=\"button\" class=\"cpop__ra\">" + ADL("Додати") + "</button>");
    const sel = card.querySelector(".cpop__rs");
    /* чохол: одразу фото того камуфляжу, що стоїть у списку */
    const coverImg = () => {
      const vi = coverSel && v.featured_image && (v.featured_image.src || v.featured_image);
      const im0 = vi && card.querySelector(".cpop__ri img");
      if (im0) im0.src = String(vi).replace(/([?&])width=\d+/, "$1width=240");
    };
    coverImg();
    if (sel) sel.addEventListener("change", () => {
      if (isSub) qty = +sel.value || qty;
      else v = avail.find(x => String(x.id) === sel.value) || v;
      card.querySelector(".cpop__rp").textContent = money(priceOf());
      coverImg();
    });
    const amInfo = card.querySelector("[data-aminfo]");
    if (amInfo) amInfo.addEventListener("click", ev => { ev.preventDefault(); ev.stopPropagation(); if (window.AdaptisUI && window.AdaptisUI.amulet) window.AdaptisUI.amulet(); });
    card.querySelector(".cpop__ra").addEventListener("click", ev => {
      const bt = ev.currentTarget;
      if (popBusy || (pop && pop.classList.contains("cpop--adding"))) return;
      /* 28.09.2026 (власник): товар з вибором: вікно кошика закривається,
         вибір варіанта у вікні швидкої покупки; після додавання вікно кошика
         відкривається знову й рахується заново. */
      if (pick && !coverSel && window.AdaptisQuickBuy){
        if (!inline) closeCartPop();
        window.AdaptisQuickBuy.open(k.h, v.id, null, {src:inline ? "cart-upsell" : "popup-upsell", ev:isAm ? "upsell_amulet_add" : "upsell_other_add"});
        return;
      }
      popBusy = true;
      bt.textContent = ADL("Додаємо…");
      /* 26.09.2026: джерело позиції для аналітики: допродаж у вікні «Додано в кошик». */
      if (window.AdaptisSrc) { window.AdaptisSrc.next = inline ? "cart-upsell" : "popup-upsell"; window.AdaptisSrc.track(isAm ? "upsell_amulet_add" : "upsell_other_add", {value: priceOf() / 100}); }
      let job;
      if (k.action === "multi"){
        /* s10j: одна картка Amulet на весь кошик: спершу одним запитом додаємо все
           («Starlink + Amulet» з властивостями замінених рядків, послуги), потім
           знімаємо замінені Starlink і збільшуємо наявну послугу. Якщо додати не
           вдалося, кошик лишається як був. */
        const adds = [], later = [];
        (k.parts || []).forEach(pt => {
          if (pt.action === "inc" && pt.incKey && lineBy[pt.incKey]){
            later.push(() => postJSON(cartRoot() + "cart/change.js", {id:pt.incKey, quantity:lineBy[pt.incKey].quantity + pt.qty}));
            return;
          }
          const rl = (pt.replaceKeys || []).map(x => lineBy[x]).filter(Boolean);
          const props = Object.assign({}, (rl[0] && rl[0].properties) || {});
          delete props._src;
          adds.push(Object.assign({id:pt.variantId, quantity:pt.qty}, Object.keys(props).length ? {properties:props} : {}));
          let left = pt.qty;
          rl.forEach(line => {
            const take = Math.min(line.quantity, left);
            left -= take;
            if (take > 0) later.push(() => postJSON(cartRoot() + "cart/change.js", {id:line.key, quantity:line.quantity - take}));
          });
        });
        job = (adds.length ? postJSON(cartRoot() + "cart/add.js", {items:adds}) : Promise.resolve())
          .then(() => later.reduce((pr, f) => pr.then(f), Promise.resolve()));
      } else if (k.action === "inc" && lineBy[k.incKey]){
        job = postJSON(cartRoot() + "cart/change.js", {id:k.incKey, quantity:lineBy[k.incKey].quantity + qty});
      } else if (k.action === "replace" && replaced.length){
        /* 28.09.2026 (власник): «Starlink з модифікацією» замінює всю позицію ×N;
           «Мандрівний» замінює «Домашній». Спершу додаємо, потім знімаємо старе:
           якщо додати не вдалося, термінал лишається в кошику. Властивості
           першого рядка (дах, встановлення, модель авто) переносимо. */
        const props = Object.assign({}, replaced[0].properties || {});
        delete props._src;
        let left = qty;
        job = postJSON(cartRoot() + "cart/add.js", {items:[Object.assign({id:v.id, quantity:qty}, Object.keys(props).length ? {properties:props} : {})]})
          .then(() => replaced.reduce((pr, line) => pr.then(() => {
            const take = Math.min(line.quantity, left);
            left -= take;
            return take > 0 ? postJSON(cartRoot() + "cart/change.js", {id:line.key, quantity:line.quantity - take}) : null;
          }), Promise.resolve()));
      } else {
        job = postJSON(cartRoot() + "cart/add.js", {items:[{id:v.id, quantity:qty}]});
      }
      job.then(() => refreshCart())
        /* у кошику сторінку перемальовує сам кошик: він чує cart:update від announceCart */
        .then(c2 => { announceCart(c2); if (!inline){ paintPop(c2); trackAm(); opts.onChange(); } })
        .catch(() => { bt.textContent = ADL("Не вдалося"); })
        .then(() => { popBusy = false; });
    });
    row.appendChild(card);
  });
  host.appendChild(row);
}

/* Допродаж і його фото тягнемо заздалегідь, щоб вікно відкривалось готовим. */
function prefetch(o){
  if (o) opts = Object.assign({}, opts, o);
  return loadRecs().then(list => {
    (list || []).slice(0, 4).forEach(p => {
      const src = lineImg(p, 240);
      if (src){ const im2 = new Image(); im2.decoding = "async"; im2.src = src; }
    });
    return list;
  }).catch(() => []);
}

window.AdaptisCartPop = {
  open: openCartPop, prefetch: prefetch, close: closeCartPop, refresh: refreshCart, announce: announceCart, sync: defSync,
  postJSON: postJSON, cartRoot: cartRoot, loc: locHref, esc: escHtml, sized: sized,
  /* 09.10.2026: блок рекомендацій поза вікном (сторінка кошика). */
  recsInto: function(host, o){
    if (o && typeof o.purpose === "function") opts = Object.assign({}, opts, {purpose:o.purpose});
    return loadRecs().then(() => refreshCart()).then(c => { paintRecs(c, {host:host}); return c; });
  },
  get cart(){ return liveCart; }, set cart(c){ liveCart = c; }
};
})();

/* ---------- спільні вікна ---------- */
/* 26.09.2026: вікно поверх сторінки і «Що таке Adaptis Amulet?» один раз для
   конструктора і квізу. Раніше квіз мав власну копію вікна, і вона розійшлась
   з конструктором: не знала про фото adaptis-amulet-info-3.png і запасне фото. */
(function(){
"use strict";
if (window.AdaptisUI) return;
const esc = t => String(t == null ? "" : t).replace(/[&<>"']/g, c =>
  ({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"})[c]);
const locHref = h => (window.AdaptisCartPop && window.AdaptisCartPop.loc) ? window.AdaptisCartPop.loc(h) : h;

/* 22.09.2026: одне вікно для «Дізнатися більше». Оформлення те саме, що в
   pop-up кошика: на десктопі по центру, на телефоні виїжджає знизу. */
function sheet(o){
  const root = document.createElement("div");
  root.className = "adaptis-cfg cpop cpop--sheet" + (o.cls ? " " + o.cls : "");
  root.innerHTML =
    '<div class="cpop__bg" data-close></div>' +
    '<div class="cpop__box" role="dialog" aria-modal="true" aria-label="' + esc(o.title) + '">' +
      '<div class="cpop__head"><h2 class="cpop__t">' + esc(o.title) + '</h2>' +
      ("<button type=\"button\" class=\"cpop__x\" data-close aria-label=\"" + ADL("Закрити").replace(/"/g, "&quot;") + "\">&#215;</button></div>") +
      '<div class="cpop__body"></div>' +
      (o.foot ? '<div class="cpop__foot"></div>' : '') +
    '</div>';
  root.querySelector(".cpop__body").appendChild(o.body);
  if (o.foot) root.querySelector(".cpop__foot").appendChild(o.foot);
  const close = () => {
    root.remove();
    /* s13z12: вікно може стояти поверх вікна «Додано в кошик»: блокування прокрутки лишаємо, поки є інше. */
    if (!document.querySelector(".cpop")) document.documentElement.classList.remove("cpop-open");
    document.removeEventListener("keydown", onKey);
  };
  const onKey = e => { if (e.key === "Escape") close(); };
  root.addEventListener("click", e => { if (e.target.closest("[data-close]")) close(); });
  document.addEventListener("keydown", onKey);
  document.body.appendChild(root);
  document.documentElement.classList.add("cpop-open");
  root.querySelector(".cpop__x").focus();
  return {root, close};
}

/* «Дізнатися більше»: пояснення без переходу на сторінку товару. icon(name)
   малює іконку характеристики, її передає сторінка. Якщо файлу фото вікна
   (adaptis-amulet-info-3.png у «Файлах») немає, підставляємо запасне. */
function info(inf, icon){
  const A = window.ADAPTIS_ASSETS || {};
  const ic = typeof icon === "function" ? icon : () => "";
  const body = document.createElement("div");
  body.className = "cinfo";
  const first = inf.img ? '<img src="' + esc(inf.img) + '" alt="" data-fallback="' + esc(A.amuletInfoFallback || A.amulet || (window.ADAPTIS_AMULET_INFO || {}).fb || "") + '" onerror="if(this.dataset.fallback&&this.src!==this.dataset.fallback){this.src=this.dataset.fallback}">' : '';
  /* 28.09.2026 (власник): після фото-порівняння ще слайди (фото товару Amulet
     з третього, snippets/adaptis-amulet-kit.liquid): гортаються свайпом,
     стрілками (де є миша), крапками й клавішами ← →; тап по фото відкриває
     його на весь екран, бо дрібний текст у слайдах на телефоні не читається. */
  let slides = inf.img ? (inf.slides || (inf.title === "Adaptis Amulet" ? window.ADAPTIS_AMULET_SLIDES : null) || []).filter(u => u && u !== inf.img) : [];
  /* s15r 01.10.2026 (власник): у вікні Amulet третім слайд «Як працює» з «GPS підмінили» (файл теми
     adaptis-amulet-how.jpg) замість фото товару AdaptisAmulet1x103 зі старим «GPS заглушили». */
  if (inf.title === "Adaptis Amulet" && slides.length){
    const me = document.querySelector('script[src*="adaptis-configurator.js"]');
    const how = me ? me.getAttribute("src").replace(/adaptis-configurator\.js[^"]*$/, "adaptis-amulet-how.jpg") : "";
    if (how){ slides = slides.filter(u => !/AdaptisAmulet1x103/i.test(u)); slides.splice(Math.min(1, slides.length), 0, how); }
  }
  const gal = slides.length
    ? '<div class="cinfo__gal"><div class="cinfo__track">' +
        '<div class="cinfo__sl cinfo__sl--first">' + first + '</div>' +
        slides.map(u => '<div class="cinfo__sl"><img src="' + esc(u) + '" alt="" loading="lazy"></div>').join("") +
      '</div>' +
      ("<button type=\"button\" class=\"gnav gnav--prev\" data-gal=\"-1\" aria-label=\"" + ADL("Попереднє фото").replace(/"/g, "&quot;") + "\">&#8249;</button>") +
      ("<button type=\"button\" class=\"gnav gnav--next\" data-gal=\"1\" aria-label=\"" + ADL("Наступне фото").replace(/"/g, "&quot;") + "\">&#8250;</button>") +
      '</div><div class="cinfo__dots">' +
      [first].concat(slides).map((_, i) => '<button type="button" class="gdot' + (i ? '' : ' is-on') + '" data-dot="' + i + '" aria-label="' + esc(ADL("Фото")) + ' ' + (i + 1) + '"></button>').join("") +
      '</div>'
    : (first ? '<div class="cinfo__img">' + first + '</div>' : '');
  /* s15b/s15e 01.10.2026 (власник): перше фото Amulet зі зірочкою біля «Немає інтернету»,
     під галереєю розшифровка: без Amulet при підміні GPS не працює, при глушінні нестабільно. */
  const star = inf.star || (inf.title === "Adaptis Amulet" && inf.img ? ADL("* Без Amulet: під час підміни GPS (спуфінг) інтернету немає, під час глушіння (джемінг) він нестабільний.") : "");
  /* s15u 01.10.2026 (власник): у вікні Amulet перші два пункти (головний з Wi-Fi і «Встановлюється на будь-який
     Starlink…») одним рядком звичайним шрифтом, щоб на телефоні лишалось більше місця під фото й свайп. */
  let facts = inf.facts || [];
  if (inf.title === "Adaptis Amulet" && facts.length > 1 && facts[0].main){
    /* s15w (власник): жирним лише «Starlink працює під час повітряних тривог», решта звичайним */
    const a = facts[0].t.replace(/[.\s]+$/, ""), mm = /^(.+?\.)\s+(.+)$/.exec(a);
    facts = [{i:facts[0].i, html:(mm ? esc(mm[1]) + " <b>" + esc(mm[2]) + ".</b>" : "<b>" + esc(a) + ".</b>") + " " + esc(facts[1].t), main:true, plain:true}].concat(facts.slice(2));
  }
  body.innerHTML =
    gal +
    (inf.lead ? '<p class="cinfo__lead">' + esc(inf.lead) + '</p>' : '') +
    '<ul class="cfgcard__f">' + facts.map(f => '<li' + (f.main ? ' class="cinfo__main' + (f.plain ? ' cinfo__plain' : '') + '"' : '') + '>' + ic(f.i) + '<span>' + (f.html || esc(f.t)) + '</span></li>').join("") +
      /* Застереження тим самим рядком, але іконка на червоному тлі. */
      (inf.warn ? '<li class="cinfo__warn">' + ic(inf.warn.i) + '<span>' + esc(inf.warn.t) + '</span></li>' : '') +
      /* s15e (власник 01.10): розшифровка зірочки окремим пунктом у кінці списку, не під фото. */
      (star ? '<li class="cinfo__star"><svg class="cfgcard__fi" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5.9 8.5l12.2 7M5.9 15.5l12.2-7"/></svg><span>' + esc(star.replace(/^\*\s*/, "")) + '</span></li>' : '') +
    '</ul>';
  const foot = document.createElement("div");
  foot.className = "cinfo__foot";
  const more = document.createElement("button");
  more.type = "button"; more.className = "btn btn--3"; more.setAttribute("data-close", "");
  more.textContent = ADL("Закрити");
  foot.appendChild(more);
  const res = sheet({title:inf.title, body, foot, cls:"cpop--info"});
  if (slides.length) galInit(res.root);
  return res;
}
/* Галерея вікна: стрічка, яку гортає сам браузер (свайп), як на сторінці товару.
   28.09.2026 (власник): по колу, з останнього слайда далі на перший і навпаки:
   по краях копії крайніх слайдів, після прокрутки на копію стрічка тихо
   перестрибує на справжній слайд. */
function galInit(root){
  const track = root.querySelector(".cinfo__track");
  const dots = [].slice.call(root.querySelectorAll(".cinfo__dots .gdot"));
  const real = [].slice.call(track.children), n = real.length;
  const head = real[n - 1].cloneNode(true), tail = real[0].cloneNode(true);
  [head, tail].forEach(c => { c.setAttribute("aria-hidden", "true"); c.querySelectorAll("img").forEach(i => { i.loading = "lazy"; }); });
  track.insertBefore(head, real[0]);
  track.appendChild(tail);
  let cur = 0, seen = false, t = 0;
  const W = () => Math.max(1, track.clientWidth);
  const to = (r, smooth) => track.scrollTo({left:r * W(), behavior:smooth ? "smooth" : "instant"});
  const mark = i => {
    cur = (i % n + n) % n;
    dots.forEach((d, k) => d.classList.toggle("is-on", k === cur));
    if (cur > 0 && !seen){ seen = true; if (window.AdaptisSrc) window.AdaptisSrc.track("amulet_info_slide", {once:true}); }
  };
  const settle = () => {
    const r = Math.round(track.scrollLeft / W());
    if (r <= 0){ to(n, false); mark(n - 1); }
    else if (r >= n + 1){ to(1, false); mark(0); }
    else mark(r - 1);
  };
  to(1, false);
  /* 28.09.2026 (власник): на телефоні вікно без внутрішньої прокрутки. Фото
     квадратне, тож якщо вміст вищий за вікно, зменшуємо фото рівно на
     стільки, на скільки не вміщається; перераховуємо, коли Safari ховає чи
     показує свої панелі. */
  const gal = root.querySelector(".cinfo__gal"), body = root.querySelector(".cpop__body");
  const fit = () => {
    if (!root.isConnected) return;
    gal.style.width = "";
    if (window.innerWidth < 750 && body){
      const over = body.scrollHeight - body.clientHeight;
      if (over > 0) gal.style.width = Math.max(150, Math.floor(gal.getBoundingClientRect().width - over)) + "px";
    }
    to(cur + 1, false);
  };
  fit();
  const onVv = () => setTimeout(fit, 50);
  window.addEventListener("resize", onVv);
  if (window.visualViewport) window.visualViewport.addEventListener("resize", onVv);
  const step = d => { to(Math.round(track.scrollLeft / W()) + d, true); mark(cur + d); };
  track.addEventListener("scroll", () => { clearTimeout(t); t = setTimeout(settle, 90); }, {passive:true});
  if ("onscrollend" in window) track.addEventListener("scrollend", () => { clearTimeout(t); settle(); });
  root.addEventListener("click", e => {
    const b = e.target.closest("[data-gal]");
    if (b){ step(+b.dataset.gal); return; }
    const d = e.target.closest("[data-dot]");
    if (d){ to(+d.dataset.dot + 1, true); mark(+d.dataset.dot); return; }
    /* Фото на весь екран лише на телефоні (власник: на десктопі без збільшення). */
    const im = e.target.closest(".cinfo__sl img");
    if (im && window.innerWidth < 750) zoom(im.currentSrc || im.src);
  });
  const onKey = e => {
    if (!root.isConnected){ document.removeEventListener("keydown", onKey); return; }
    if (document.querySelector(".cinfo__zoom")) return;
    if (e.key === "ArrowRight"){ e.preventDefault(); step(1); }
    else if (e.key === "ArrowLeft"){ e.preventDefault(); step(-1); }
  };
  document.addEventListener("keydown", onKey);
}
/* Фото на весь екран: тап або Escape закривають, на телефоні можна збільшити пальцями. */
function zoom(src){
  const z = document.createElement("div");
  z.className = "cinfo__zoom";
  z.setAttribute("role", "dialog");
  z.setAttribute("aria-modal", "true");
  z.innerHTML = '<img src="' + esc(src) + '" alt="">' +
    ("<button type=\"button\" class=\"cinfo__zx\" aria-label=\"" + ADL("Закрити").replace(/"/g, "&quot;") + "\">&#215;</button>");
  const close = () => { z.remove(); document.removeEventListener("keydown", onKey, true); };
  /* Escape закриває лише фото, а не все вікно під ним. */
  const onKey = e => { if (e.key === "Escape"){ e.stopImmediatePropagation(); e.preventDefault(); close(); } };
  z.addEventListener("click", close);
  document.addEventListener("keydown", onKey, true);
  /* На телефоні фото на весь екран лише тієї ж ширини, що у вікні, тому
     показуємо його більшим, і його рухають пальцем; тап закриває. */
  if (window.innerWidth < 700) z.classList.add("cinfo__zoom--pan");
  document.body.appendChild(z);
  z.querySelector(".cinfo__zx").focus();
}

/* Підписка Starlink: одна розмітка для конструктора і квізу (26.09.2026).
   Раніше квіз збирав її сам, і посилання «Дізнатися більше про тарифи» стояло
   окремим рядком, а не під описом тарифу поруч з іконкою. Сторінка передає
   свій стан: cur (обраний тариф), money, price(опція строку), icon(name, cls),
   pressed(handle). Кліки обробляє сама сторінка: [data-subplansel] і [data-sub]. */
const CHEV = '<svg class="subsel__ch" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9L12 15L18 9"/></svg>';
function subs(s, o){
  const cur = o.cur, svc = s.svc || {};
  const ic = typeof o.icon === "function" ? o.icon : () => "";
  const on = h => String(!!(o.pressed && o.pressed(h)));
  const more = s.more ? '<a class="cfgset__more subs__more" href="' + esc(locHref(s.more.href)) + '" target="_blank" rel="noopener">' + esc(s.more.text) + '</a>' : '';
  const self = (s.options || []).find(x => x.handle === "self");
  let h = '<h2 class="cfgset__t">' + esc(s.title) + '</h2>' +
    ("<label class=\"subsel\"><span class=\"subsel__w\"><select class=\"subsel__s\" data-subplansel aria-label=\"" + ADL("Тариф Starlink").replace(/"/g, "&quot;") + "\">") +
      s.plans.map(p => '<option value="' + esc(p.h) + '"' + (p.h === cur.h ? ' selected' : '') + '>' + esc(p.label) + '</option>').join('') +
    '</select>' + CHEV + '</span></label>' +
    /* 25.09.2026: «Дізнатися більше про тарифи» другим рядком під перевагою
       тарифу, вирівняне по тексту поруч з іконкою (власник). */
    (cur.lead
      ? '<ul class="cfgcard__f subs__f"><li>' + ic(cur.lead.i, "cfgcard__fi") +
          (more ? '<span class="subs__lt"><span>' + esc(cur.lead.t) + '</span>' + more + '</span>' : '<span>' + esc(cur.lead.t) + '</span>') + '</li></ul>'
      : more) +
    '<hr class="subs__hr"><div class="subs__list">';
  if (self) h += '<button type="button" class="card-opt" data-sub="self" aria-pressed="' + on("self") + '">' +
    '<span class="card__main"><span class="card__row"><span class="card__t">' + esc(self.title) + '</span>' +
    '<span class="card__p free">' + Number(cur.usd).toLocaleString("uk-UA") + (" " + ADL("$ / міс") + "</span></span>") +
    (self.desc ? '<span class="card__d">' + esc(self.desc) + '</span>' : '') + '</span></button>';
  /* 23.09.2026, вечір: без рядка-розрахунку тарифу й супроводу, ціни видно в строках. */
  h += '<div class="subs__svc"><b>' + esc(svc.title || ADL("Оформить Adaptis")) + '</b>' +
    '<ul>' + (svc.points || []).map(t => '<li>' + esc(t) + '</li>').join('') + '</ul><div class="subs__rows">' +
    s.options.filter(x => x.months).map(x =>
      '<button type="button" class="card-opt subs__m" data-sub="' + esc(x.handle) + '" aria-pressed="' + on(x.handle) + '">' +
        '<span class="subs__mt"><span>' + esc(x.title) + '</span><small>' + o.money(cur.price) + ' × ' + x.months + '</small></span>' +
        '<b class="subs__mp">' + o.money(o.price(x)) + '</b></button>').join('') +
    '</div></div></div>';
  return h;
}

/* 30.09.2026 (власник, s13z12): «Що таке Adaptis Amulet?» без даних конструктора: з вікна
   «Додано в кошик» і зі сторінки кошика. Тексти ті самі, що в кроці Amulet конструкторів;
   фото й слайди з snippets/adaptis-amulet-info-data.liquid (або даних сторінки, якщо є). */
const AM_IC = {
  wifi:'<path d="M2 8.8C7.6 4 16.4 4 22 8.8"/><path d="M5.2 12.3C9 9.2 15 9.2 18.8 12.3"/><path d="M8.5 15.7C10.6 14.1 13.4 14.1 15.5 15.7"/><path d="M12 19.5H12.01"/>',
  check:'<circle cx="12" cy="12" r="10"/><path d="M8 12.5L10.5 15L16 9.5"/>',
  gpsoff:'<path d="M9.2 3A8.6 8.6 0 0 1 20.3 7.4C21.4 10 21 12.3 19.8 14.4"/><path d="M17.2 17.6C16 18.9 14.8 20.1 13.6 21.4C13.2 21.8 12.6 22 12 22C11.4 22 10.8 21.8 10.4 21.4C6.4 17.6 1.1 13.4 3.7 7.4"/><path d="M12 14.5A3.5 3.5 0 0 1 8.5 11"/><path d="M3 3L21 21"/>'
};
function amulet(){
  const A = window.ADAPTIS_ASSETS || {}, D = window.ADAPTIS_AMULET_INFO || {};
  if (window.AdaptisSrc) window.AdaptisSrc.track("amulet_info_open");
  return info({title:"Adaptis Amulet", img:A.amuletInfo || D.img || A.amulet || D.fb,
    slides:window.ADAPTIS_AMULET_SLIDES || D.slides,
    facts:[
      {i:"wifi", t:ADL("Модифікація термінала. Starlink працює під час повітряних тривог"), main:true},
      {i:"check", t:ADL("Встановлюється на будь-який Starlink без змін зовнішнього вигляду. Новий Starlink з Amulet готуємо орієнтовно 2-4 робочі дні")}
    ],
    warn:{i:"gpsoff", t:ADL("Amulet тримає інтернет, а не навігацію: GPS-навігація під час тривог не працює")}},
    n => '<svg class="cfgcard__fi" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (AM_IC[n] || "") + '</svg>');
}
/* 09.10.2026 (власник): фото галереї товару на весь екран. urls це повні адреси фото, start це номер
   першого, onGo(i) кличеться при гортанні, щоб галерея під вікном ішла слідом. low це ті самі фото
   в розмірі галереї: вони вже в пам'яті браузера, тож при гортанні фото з'являється одразу, а велике
   підміняє його, щойно завантажиться (власник: «гортається із великою затримкою»). Сусідні великі фото
   вантажимо наперед. Стрілки на екрані й на
   клавіатурі гортають, Escape, хрестик або клік повз фото закривають. На телефоні фото спершу видно цілим,
   дотик до нього збільшує вдвічі, і тоді його рухають пальцем: інакше дрібний текст на картці не прочитати. */
function photos(urls, start, onGo, low){
  const n = urls.length;
  if (!n || document.querySelector(".galzoom")) return;
  let i = Math.min(Math.max(0, start | 0), n - 1);
  const back = document.activeElement;
  const z = document.createElement("div");
  z.className = "galzoom" + (window.innerWidth < 750 ? " galzoom--pan" : "");
  z.setAttribute("role", "dialog");
  z.setAttribute("aria-modal", "true");
  z.setAttribute("aria-label", ADL("Фото"));
  z.innerHTML = '<div class="galzoom__box"><img class="galzoom__im" alt=""></div>' +
    (n > 1 ? '<button type="button" class="galzoom__nav galzoom__nav--prev" data-gz="-1" aria-label="' + esc(ADL("Попереднє фото")) + '">&#8249;</button>' +
      '<button type="button" class="galzoom__nav galzoom__nav--next" data-gz="1" aria-label="' + esc(ADL("Наступне фото")) + '">&#8250;</button>' +
      '<span class="galzoom__n" aria-live="polite"></span>' : '') +
    '<button type="button" class="cinfo__zx" aria-label="' + esc(ADL("Закрити")) + '">&#215;</button>';
  const img = z.querySelector(".galzoom__im"), box = z.querySelector(".galzoom__box"), cnt = z.querySelector(".galzoom__n");
  img.addEventListener("load", () => { if (img.naturalHeight) img.style.setProperty("--ar", (img.naturalWidth / img.naturalHeight).toFixed(4)); });
  const big = {};
  const load = k => {
    if (big[k]) return big[k];
    const im2 = new Image();
    big[k] = {im:im2, ok:false};
    im2.onload = () => { big[k].ok = true; if (k === i && z.isConnected) img.src = urls[k]; };
    im2.src = urls[k];
    return big[k];
  };
  const show = () => {
    const b = load(i);
    img.src = b.ok || !(low && low[i]) ? urls[i] : low[i];
    if (cnt) cnt.textContent = (i + 1) + " / " + n;
    z.classList.remove("is-in");
    if (n > 1){ load((i + 1) % n); load((i - 1 + n) % n); }
  };
  /* телефон: дотик до фото збільшує його й повертає назад; збільшене показуємо з середини */
  const zoomIn = () => {
    const on = z.classList.toggle("is-in");
    if (on) requestAnimationFrame(() => { box.scrollLeft = (box.scrollWidth - box.clientWidth) / 2; box.scrollTop = (box.scrollHeight - box.clientHeight) / 2; });
  };
  const go = d => { i = (i + d + n) % n; show(); if (typeof onGo === "function") onGo(i); };
  const close = () => {
    z.remove();
    document.removeEventListener("keydown", onKey, true);
    document.documentElement.classList.remove("galzoom-on");
    if (back && back.focus) back.focus({preventScroll:true});
  };
  const onKey = e => {
    if (e.key === "Escape"){ e.stopImmediatePropagation(); e.preventDefault(); close(); }
    else if (e.key === "ArrowRight" && n > 1){ e.preventDefault(); go(1); }
    else if (e.key === "ArrowLeft" && n > 1){ e.preventDefault(); go(-1); }
  };
  z.addEventListener("click", e => {
    const b = e.target.closest("[data-gz]");
    if (b){ go(+b.dataset.gz); return; }
    if (e.target === img){ if (z.classList.contains("galzoom--pan")) zoomIn(); return; }
    close();
  });
  document.addEventListener("keydown", onKey, true);
  document.documentElement.classList.add("galzoom-on");
  show();
  document.body.appendChild(z);
  z.querySelector(".cinfo__zx").focus();
}
window.AdaptisUI = {sheet, info, subs, amulet, photos};

/* 26.09.2026 (власник): термінал разом з Adaptis Amulet іде в кошик однією
   позицією «Starlink з модифікацією Adaptis Amulet», а не терміналом і
   послугою: так виробництво й продажі не плутають, чий термінал модифікуємо.
   Дані з snippets/adaptis-amulet-kit.liquid. Послуга без термінала в
   замовленні (модифікація термінала покупця) лишається окремою позицією. */
window.AdaptisAmuletKit = (function(){
  const D = () => window.ADAPTIS_AMULET_KIT || null;
  const model = v => { const d = D(); return d && d.byTerminal ? d.byTerminal[String(v)] || null : null; };
  const isSvc = v => { const d = D(); return !!(d && (d.svc || []).some(x => String(x && x.id != null ? x.id : x) === String(v))); };
  const kit = (m, defense) => { const d = D(); return d ? (d.variants || []).find(x => x.o2 === m && /оборон/i.test(x.o1 || "") === !!defense && x.available) || null : null; };
  const name = m => "Starlink " + m + (" " + ADL("з модифікацією Adaptis Amulet"));
  function mergeItems(items, defense){
    const t = items.find(i => model(i.id)), s = items.find(i => isSvc(i.id));
    if (!t || !s) return items;
    const k = kit(model(t.id), defense);
    if (!k) return items;
    return items.filter(i => i !== s).map(i => i === t ? Object.assign({}, i, {id:k.id}) : i);
  }
  return {model, isSvc, kit, name, mergeItems};
})();
})();

/* 26.09.2026: рушій функцією window.AdaptisEngine, щоб сторінка Adaptis Amulet
   могла перезапустити його з даними іншої моделі без перезавантаження
   (adaptis-amulet.js ставить ADAPTIS_ENGINE_MANUAL). Решта сторінок
   запускають його одразу, як раніше. Обробники на window від попереднього
   запуску вимикає live(). */
window.AdaptisEngine = function(){
"use strict";

var P = window.ADAPTIS_CONFIG;
if (!P || !P.CONFIG) return;
const GEN = window.__adxGen = (window.__adxGen || 0) + 1;
const live = () => GEN === window.__adxGen;
if ((window.ADAPTIS_LOCALE || "uk") !== "uk") (P.CONFIG.steps || []).forEach(s => { if (s.handle === "amulet"){ s.when = () => false; s.def = null; } });
if (!document.getElementById("steps")) return;

/* Дані сторінки. Імена ті самі, що в прототипі, тому решта коду не змінювалась.
   Відсутнє значення лишається undefined, і перевірки typeof працюють як раніше. */
const PAGE_MODE     = P.PAGE_MODE;
const CONFIG        = P.CONFIG;
const CDN           = P.CDN;
const BASE          = P.BASE;
const BASE_TITLE    = P.BASE_TITLE;
const BASE_SHORT    = P.BASE_SHORT;
const PURPOSE_TITLE = P.PURPOSE_TITLE;
const PURPOSE_NOTE  = P.PURPOSE_NOTE;
const PURPOSE_LABEL = P.PURPOSE_LABEL;
const BUNDLE_PREFIX = P.BUNDLE_PREFIX;
const BUNDLES       = P.BUNDLES;
const PACKS         = P.PACKS;
const TERMINAL      = P.TERMINAL;
const COLOR_MEDIA   = P.COLOR_MEDIA;
/* s13r: фото товару з Shopify для галереї сторінки корпусу (див. slides). */
const PMEDIA = ((window.ADAPTIS_ASSETS || {}).pmedia || []).filter(Boolean);
const LIFESTYLE     = P.LIFESTYLE;
const MEDIA         = P.MEDIA;
const KIT_FOR       = P.KIT_FOR;
/* 23.09.2026: концепт «питання замість готових комплектів». Секція вибирає
   концепт у налаштуваннях (data-concept); без даних SIMPLE працює старий. */
const SIMPLE        = P.SIMPLE;
/* 26.09.2026: сторінка Adaptis Amulet (adaptis-amulet.js): термінал це товар
   «Starlink з модифікацією Adaptis Amulet», його ціна залежить від призначення. */
const AMULET_MODE   = !!P.AMULET;
const SIMPLE_ON     = !!SIMPLE && (document.getElementById("adaptisCfg") || {dataset:{}}).dataset.concept !== "bundles";
const im0           = P.im || function(f, w){ return CDN + f + "&width=" + (w || 900); };
/* 24.09.2026: фото може бути повною адресою (файл теми, як інвертор), тоді
   беремо його як є, а не з CDN каталогу. */
/* s27 07.10.2026: повна адреса з CDN магазину без розміру (фото з файлів теми, тимчасові картки галереї)
   теж отримує ширину, щоб мініатюри не тягнули повний файл. Решта повних адрес лишається як є. */
const im            = (f, w) => /^(https?:)?\/\//.test(f || "")
  ? (/\/cdn\/shop\//.test(f) && !/[?&]width=/.test(f) ? f + (f.indexOf("?") > -1 ? "&" : "?") + "width=" + (w || 900) : f)
  : im0(f, w);

/* Рушій обслуговує два типи сторінок.
   configurator: продаємо корпус, термінал це опція всередині (/mini/, /gen3/).
   terminal:     продаємо термінал, комплектація це апсел (/starlink-mini/).

   Сторінка віддає рушію дані, рушій нічого не знає про конкретні товари.
   Обовʼязкове для обох режимів: CDN, im(), BASE, BASE_TITLE, BASE_SHORT,
   PURPOSE_LABEL, CONFIG.steps, BUNDLE_PREFIX. */
const MODE = typeof PAGE_MODE === "undefined" ? "configurator" : PAGE_MODE;
const STEPS = CONFIG.steps;

/* 26.09.2026: висота вікна для розміру галереї (--adx-vh). На сенсорних
   екранах оновлюємо лише при зміні ширини (поворот): Arc і Safari на iPad
   міняють висоту під час прокрутки, і галерея тремтіла. */
{
  const touch = window.matchMedia("(hover: none), (pointer: coarse)");
  let vw = 0;
  const setVh = () => {
    if (window.innerWidth === vw && touch.matches) return;
    vw = window.innerWidth;
    document.documentElement.style.setProperty("--adx-vh", window.innerHeight + "px");
  };
  setVh();
  window.addEventListener("resize", setVh);
}

/* 26.09.2026: фото з каталогу, а не з імен файлів у даних. Галерея термінала
   приходить із сервера (ADAPTIS_ASSETS.media), решта з adaptis-stock.js: якщо
   каталог уже в кеші, до першого малювання, інакше після його завантаження. */
{
  const SM = ((window.ADAPTIS_ASSETS || {}).media || []).filter(Boolean);
  if (MODE === "terminal" && SM.length && Array.isArray(MEDIA)){ MEDIA.length = 0; SM.forEach(f => MEDIA.push(f)); }
  if (window.AdaptisStock && window.AdaptisStock.known()) window.AdaptisStock.syncImages(P);
}

/* ---------- стан ---------- */
const state = {};
STEPS.forEach(s => state[s.handle] = Array.isArray(s.def) ? [...s.def] : s.def);
/* Дві цінові категорії це знижка, а не властивість товару, тому призначення
   живе не в кроці, а в перемикачі біля ціни. Дефолт цивільна ціна. */
state.purpose = "civil";
/* 24.09.2026: синя рамка «обрано» тільки на тому, що покупець обрав сам
   (або що підставилось від його вибору). Значення за замовчуванням рахуються
   в ціні, але виглядають необраними. Ключі: handle кроку або "sp:" + питання. */
const touched = new Set();
if (MODE === "terminal") state.pack = PACKS[0].handle;
/* 22.09.2026: на сторінці термінала можна купити кілька комплектів одразу.
   Кількість множить усі позиції збірки. */
state.qty = 1;
const qtyN = () => MODE === "terminal" ? state.qty : 1;
/* Відповіді на питання концепту SIMPLE. На сторінці корпусу вони лише ставлять
   кроки, на сторінці термінала з них збирається комплектація «mix». */
const sp = {};
if (SIMPLE_ON){
  ["where", "home", "corpus", "power", "auto", "mount", "roof", "homeMount", "homeCorpus"].forEach(k => { if (SIMPLE[k]) sp[k] = SIMPLE[k].def; });
  if (MODE === "terminal"){ PACKS.push({handle:"mix", title:"", parts:[]}); state.pack = "mix"; }
}

/* Міст до конфігів товарів. У прототипі їхні стрілочні функції бачили state
   напряму, бо все жило в глобальній області. У темі рушій загорнутий, тому
   конфіг звертається до state і до packHasCorpus через ADX. */
const ADX = window.ADX = {
  state: state,
  /* 24.09.2026: відповіді на питання сторінки термінала (дах для ціни монтажу). */
  sp: sp,
  packHasCorpus: () => packHasCorpus(),
  get gateOn(){ return gateOn; }
};

let slide = 0;
let paintCode = "";
/* 23.09.2026, вечір: модель і рік авто, коли тип даху «Не знаю». Як у квізі:
   менеджер перевіряє дах за моделлю. */
let carModel = "";
const roofUnknown = () => { const p = SIMPLE_ON && SIMPLE.roof ? spPicked("roof") : null; return !!p && p.h === "unknown"; };
const openSteps = new Set();       /* кроки, які покупець розгорнув на мобільному */
let fromBundle = null;             /* остання застосована готова комплектація */
const byBundle = new Set();        /* кроки, які досі тримають її значення */
const manual = new Set();          /* кроки, змінені вручну після неї */

/* ---------- дрібні помічники ---------- */
const money = c => (c/100).toLocaleString("uk-UA").replace(/[, ]/g," ") + " ₴";
/* Українська множина: 1 товар, 2-4 товари, 5 і більше товарів. */
const goodsN = n => {
  const m10 = n % 10, m100 = n % 100;
  return n + " " + (m10 === 1 && m100 !== 11 ? ADL("товар") : m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14) ? ADL("товари") : ADL("товарів"));
};
const opt = (s,h) => s.options.find(o => o.handle === h);
const step = h => STEPS.find(s => s.handle === h);
const val = (v) => typeof v === "function" ? v() : v;
const priceOf = o => val(o.price) || 0;
const isQuote = o => !!val(o.quote);
const variantOf = o => o.variantFn ? o.variantFn() : (o.variant || null);
const shortOf = o => o.short || o.title;
/* Позиція має ціну, але товару в каталозі ще немає. Рішення власника 21.09.2026:
   показуємо, у суму не рахуємо, підписуємо «за запитом». */
const noCat = o => !variantOf(o) && priceOf(o) > 0;
/* Українська множина: 1 позиція, 2 позиції, 5 позицій, 0 позицій. */

const vis = s => !s.when || s.when();
const slot = s => s.slot || "main";
const mainSteps = () => STEPS.filter(s => !s.parent && slot(s) === "main" && vis(s) &&
  !(SIMPLE_ON && (SIMPLE.hide || []).indexOf(s.handle) > -1));
const slotSteps = n => STEPS.filter(s => !s.parent && slot(s) === n && vis(s));
const kids = h => STEPS.filter(s => s.parent === h && vis(s));

const colorTitle = () => { const s = step("color"); return s ? opt(s, state.color).title : ""; };
/* Сторінка може ще не перейти на нову структуру кроків, тоді підписи базові. */
const baseTitle = () => typeof BASE_TITLE === "undefined" ? ADL("Корпус") : BASE_TITLE;
const baseShort = () => typeof BASE_SHORT === "undefined" ? ADL("Корпус") : BASE_SHORT;
const purposeTitle = () => typeof PURPOSE_TITLE === "undefined" ? PURPOSE_LABEL : PURPOSE_TITLE;
const corpusPrice = () => BASE[state.purpose][state.color][1];
const corpusVariant = () => BASE[state.purpose][state.color][0];

/* Система знижок: там, де в каталозі є справжній набір із тим самим складом,
   готова комплектація йде в кошик однією позицією за ціною набору. Вона
   дешевша за ті самі товари окремо, і це не вигадана знижка, а реальна ціна
   товару. Поле covers каже, які кроки набір уже містить. */
/* Один і той самий набір може мати кілька версій у каталозі: наприклад, зі
   Starlink Mini і зі Starlink Mini X, з різними ID і різними цінами. Яку саме
   брати, вирішує сторінка через KIT_FOR. Якщо потрібної версії в каталозі
   немає, набір не застосовується і ціна рахується компонентами. */
/* 22.09.2026: від наборів як окремих товарних позицій відмовляємось. Кожен
   товар комплектації йде в кошик окремо за своєю ціною. Механізм наборів
   лишається в коді: USE_KITS = true повертає його. */
const USE_KITS = false;
const kitOf = p => !USE_KITS ? null : typeof KIT_FOR === "function" ? KIT_FOR(p) : p.kit;
const kitPrice = k => k.price[state.purpose][state.color];
const kitVariant = k => k.variant[state.purpose][state.color];
function activeKit(){
  const list = typeof BUNDLES === "undefined" ? [] : BUNDLES;
  for (let i = 0; i < list.length; i++){
    const p = list[i], k = kitOf(p);
    if (!k || k.colors.indexOf(state.color) < 0) continue;
    if (!k.covers.every(h => state[h] === p.pick[h])) continue;
    /* Сама відповідь про термінал не збирає набір. Без цієї умови покупець
       відповідав «куплю разом з корпусом», і в підсумку мовчки зʼявлявся
       «Набір: Starlink Mini + Adaptis MiniKit», хоча жодної комплектації він
       не обирав. Питання про термінал лише каже, чи входить термінал у те,
       що ми показуємо, і більше нічого. */
    if (!bundleMeaningful(p) && fromBundle !== p.handle) continue;
    return {p:p, k:k};
  }
  return null;
}
/* Скільки коштували б ті самі товари окремими позиціями. */
function loosePrice(k){
  return corpusPrice() + k.covers.reduce((a,h) => {
    const st = step(h), o = st ? opt(st, state[h]) : null;
    return a + (o ? priceOf(o) : 0);
  }, 0);
}

/* ---------- стан у посиланні ---------- */
/* Менеджер збирає комплектацію і шле лінк клієнту.
   ?preset=auto це коротка форма того самого стану, ?cfg=... повна. */
function applyBundle(h){
  const p = (typeof BUNDLES === "undefined" ? [] : BUNDLES).find(x => x.handle === h);
  if (!p) return false;
  fromBundle = p.handle;
  byBundle.clear();
  manual.clear();
  Object.keys(p.pick).forEach(k => {
    if (!(k in state)) return;
    /* Модель термінала обирає покупець, а не комплектація: якщо він уже сказав
       «куплю Mini X», набір не має мовчки повернути його на Mini. */
    /* Без відповіді набір ставить термінал сам: картка показувала ціну з
       терміналом, а в суму він не йшов. */
    if (k === "terminal" && state[k] && termGroup(state[k]) === p.pick[k]) return;
    state[k] = Array.isArray(p.pick[k]) ? [...p.pick[k]] : p.pick[k];
    byBundle.add(k);
  });
  return true;
}
/* Зняти комплектацію означає повернути її кроки до дефолтних значень:
   інакше «скасувати» лишало б заповнені кроки і плутало. */
function clearBundle(p){
  fromBundle = null;
  byBundle.clear();
  manual.clear();
  Object.keys(p.pick).forEach(k => {
    const st = step(k);
    if (!st || !(k in state)) return;
    /* Відповідь про термінал це питання сторінки, а не частина комплектації.
       Скидати її означало б викинути покупця назад у чужу групу наборів. */
    if (k === "terminal") return;
    state[k] = Array.isArray(st.def) ? [...st.def] : st.def;
  });
}
/* Комплектація підсвічується, коли стан блоків збігається з нею. Але сама по
   собі відповідь про термінал це не вибір комплектації: одразу після неї стан
   збігається з базовою, і вона світилась обраною, хоча покупець її не обирав.
   Тому підсвічується та, що відрізняється від дефолтів хоча б одним блоком,
   крім термінала. Або та, яку обрали явно, інакше клік по базовій нічого б
   не робив. */
/* Відповідей про термінал більше двох, бо моделі різні, а груп наборів дві:
   з терміналом і без. */
const termGroup = t => t === "own" ? "own" : "buy";
const bundleMeaningful = p => Object.keys(p.pick).some(k => {
  if (k === "terminal") return false;
  const st = step(k);
  if (!st) return false;
  const d = st.def, v = p.pick[k];
  return Array.isArray(d)
    ? !(Array.isArray(v) && v.length === d.length && d.every(x => v.includes(x)))
    : v !== d;
});
const bundleOn = p => (bundleMeaningful(p) || fromBundle === p.handle) &&
  Object.keys(p.pick).every(k => {
    const a = k === "terminal" ? termGroup(state[k]) : state[k], b = p.pick[k];
    return Array.isArray(b) ? a.length === b.length && b.every(x => a.includes(x)) : a === b;
  });

const QTY_MAX = 20;
function readUrl(qs){
  const q = new URLSearchParams(qs === undefined ? location.search : qs);
  const pre = q.get("preset");
  if (pre && applyBundle(pre)) STEPS.forEach(x => touched.add(x.handle));
  /* коротка форма для посилань зі сторінки термінала: ?terminal=have */
  const t = q.get("terminal");
  if (t && "terminal" in state) state.terminal = t === "buy" ? "buy" : "own";
  const cfg = q.get("cfg");
  if (cfg) cfg.split(";").forEach(pair => {
    const [k, v] = pair.split(":");
    if (!(k in state) || v === undefined) return;
    if (Array.isArray(state[k])) state[k] = v ? v.split(",") : [];
    else state[k] = v === "-" ? null : v;
    touched.add(k);
  });
  const code = q.get("paint");
  if (code) paintCode = decodeURIComponent(code);
  const car = q.get("car");
  if (car) carModel = car;
  /* Цінова категорія і комплектація сторінки термінала теж їдуть у посиланні,
     інакше менеджер зібрав би одне, а клієнт відкрив би інше. */
  const m = q.get("mode");
  if (m === "civil" || m === "defense") state.purpose = m;
  const pk = q.get("pack");
  if (pk && MODE === "terminal" && PACKS.some(x => x.handle === pk)) state.pack = pk;
  const spq = q.get("sp");
  if (SIMPLE_ON && spq && MODE === "terminal"){
    const [c, pw, au, wh, hm, mt, rf, hmt, hc] = spq.split(".");
    const has = (k, h) => SIMPLE[k] && SIMPLE[k].options.some(o => o.h === h);
    if (has("corpus", c)) sp.corpus = c;
    if (has("power", pw)) sp.power = pw;
    if (has("auto", au)) sp.auto = au;
    if (has("where", wh)) sp.where = wh;
    if (has("home", hm)) sp.home = hm;
    if (has("mount", mt)) sp.mount = mt;
    if (has("roof", rf)) sp.roof = rf;
    if (has("homeMount", hmt)) sp.homeMount = hmt;
    if (has("homeCorpus", hc)) sp.homeCorpus = hc;
    if (sp.where === "move" && SIMPLE.corpus) sp.corpus = "yes";
    /* У посиланні збірка вже обрана: показуємо її обраною. */
    Object.keys(sp).forEach(k => touched.add("sp:" + k));
  }
  const n = parseInt(q.get("qty"), 10);
  if (MODE === "terminal" && n > 1) state.qty = Math.min(n, QTY_MAX);
}

/* F1: менеджер збирає комплектацію сам і шле клієнту готове посилання. Це
   потрібно щоразу, коли замовлення фактично оформлює відділ продажів:
   наприклад, коли в клієнта не проходить міжнародна оплата. */
function cfgUrl(){
  const q = new URLSearchParams();
  const cfg = STEPS.map(st => {
    const v = state[st.handle];
    if (v === null || v === undefined) return null;
    return st.handle + ":" + (Array.isArray(v) ? v.join(",") : v);
  }).filter(Boolean).join(";");
  if (cfg) q.set("cfg", cfg);
  q.set("mode", state.purpose);
  if (MODE === "terminal") q.set("pack", state.pack);
  if (SIMPLE_ON && MODE === "terminal") q.set("sp", [sp.corpus, sp.power, sp.auto, sp.where, sp.home, sp.mount, sp.roof, sp.homeMount, sp.homeCorpus].join("."));
  if (qtyN() > 1) q.set("qty", String(qtyN()));
  if (paintCode.trim()) q.set("paint", paintCode.trim());
  if (roofUnknown() && carModel.trim()) q.set("car", carModel.trim());
  return location.origin + location.pathname + "?" + q.toString();
}
/* 28.09.2026 (власник): оновлення сторінки не скидає конструктор. Стан той
   самий, що в посиланні менеджера (cfgUrl), лежить у браузері покупця 7 днів,
   окремо для кожного товару (на сторінці Amulet і для кожної моделі).
   Посилання з ?cfg, ?preset тощо сильніше за збережене, крім випадку, коли
   покупець змінював вибір саме на цьому посиланні й оновив сторінку. */
const SAVE_KEY = "adx_cfg:" + ((document.getElementById("adaptisCfg") || {dataset:{}}).dataset.handle || location.pathname) +
  (TERMINAL && TERMINAL.variant ? ":" + TERMINAL.variant : "");
const SAVE_TTL = 7 * 864e5;
const URL_KEYS = ["cfg", "preset", "terminal", "pack", "sp", "mode", "qty", "paint", "car"];
function saveState(){
  if (!live()) return;
  try {
    localStorage.setItem(SAVE_KEY, JSON.stringify({at:Date.now(), from:location.search, q:cfgUrl().split("?")[1] || "",
      touched:[...touched], fb:fromBundle, bb:[...byBundle], mn:[...manual]}));
  } catch (e) {}
}
function restoreState(){
  /* 28.09.2026 (власник): зібране повертається лише кнопкою «Назад» чи
     оновленням сторінки (рятує від випадкового кліку). Новий прихід на
     сторінку, за посиланням чи з меню, починає з чистого конструктора. */
  const nav = (performance.getEntriesByType && performance.getEntriesByType("navigation")[0]) || {};
  if (nav.type !== "reload" && nav.type !== "back_forward") return false;
  let s = null;
  try { s = JSON.parse(localStorage.getItem(SAVE_KEY) || "null"); } catch (e) { return false; }
  if (!s || typeof s.q !== "string" || !(Date.now() - s.at < SAVE_TTL)) return false;
  const q = new URLSearchParams(location.search);
  if (URL_KEYS.some(k => q.has(k)) && s.from !== location.search) return false;
  readUrl(s.q);
  /* 30.09.2026 (власник, s13z23): відповіді простого конструктора, яких покупець не торкався, беремо
     з поточних значень за замовчуванням, а не із збереженого: інакше зміна значення за замовчуванням
     (корпус MiniKit удома) не діяла після оновлення сторінки ще 7 днів. */
  if (SIMPLE_ON){
    const tt = s.touched || [];
    Object.keys(sp).forEach(k => { if (SIMPLE[k] && tt.indexOf("sp:" + k) < 0) sp[k] = SIMPLE[k].def; });
    if (sp.where === "move" && SIMPLE.corpus) sp.corpus = "yes";
  }
  /* Дані товару могли змінитись, поки стан лежав: варіант, якого вже немає,
     повертається до значення за замовчуванням. */
  STEPS.forEach(st => {
    const v = state[st.handle];
    if (!st.options || v === null || v === undefined) return;
    const has = h => st.options.some(o => o.handle === h);
    if (Array.isArray(v)) state[st.handle] = v.filter(has);
    else if (!has(v)) state[st.handle] = Array.isArray(st.def) ? [...st.def] : st.def;
  });
  /* Синя рамка «обрано» лише на тому, що покупець обирав сам, як до оновлення. */
  touched.clear();
  (s.touched || []).forEach(k => touched.add(k));
  const bn = (typeof BUNDLES === "undefined" ? [] : BUNDLES || []).find(x => x.handle === s.fb);
  fromBundle = bn ? bn.handle : null;
  byBundle.clear(); manual.clear();
  if (bn){ (s.bb || []).forEach(k => byBundle.add(k)); (s.mn || []).forEach(k => manual.add(k)); }
  return true;
}
/* Поле коду фарби й моделі авто не перемальовує сторінку, тому ще раз перед
   виходом або оновленням. */
window.addEventListener("pagehide", saveState);
/* ---------- правила, які змінюють стан ---------- */
/* R3: нульовий залишок блокує опцію. */
const lockReason = o => o.stock === 0 ? ADL("немає в наявності") : null;

/* ---------- згорнуті кроки на мобільному ---------- */
/* Усі кроки складені, поки покупець сам не розгорне потрібний. Після вибору
   крок згортається назад у рядок із тим, що обрано.

   Перемальовування міняє висоту сторінки, тому картку, по якій клікнули,
   тримаємо на тому самому місці екрана: інакше сторінка стрибає й покупець
   опиняється посеред іншого блоку. */
function reRender(handle){
  const box = () => stepsEl.querySelector('[data-step="' + handle + '"]');
  const before = box() ? box().getBoundingClientRect().top : null;
  render();
  const after = box() ? box().getBoundingClientRect().top : null;
  if (before !== null && after !== null && after !== before)
    window.scrollBy({top: after - before, behavior: "instant"});
}
function toggleStep(h){
  if (openSteps.has(h)) openSteps.delete(h);
  else openSteps.add(h);
  reRender(h);
}

/* ---------- рендер ---------- */
const stepsEl = document.getElementById("steps");
const el = id => document.getElementById(id);
const setText = (id, t) => { const n = el(id); if (n) n.textContent = t; };

/* 23.09.2026, вечір: блоки конструктора перемальовуються цілком на кожну
   зміну (вибір, кількість), і фото в них створювались заново: на телефоні
   вони мерехтіли. Перед перемальовуванням збираємо наявні фото, після нього
   ставимо їх на місце нових з тією самою адресою. Галерею не чіпаємо, вона
   керує своїми фото сама. */
function imgPool(){
  const pool = {}, root = el("adaptisCfg");
  if (!root) return pool;
  root.querySelectorAll("img").forEach(im => {
    if (im.closest(".gal")) return;
    const k = im.getAttribute("src");
    if (k && !(im.complete && !im.naturalWidth)) (pool[k] = pool[k] || []).push(im);
  });
  return pool;
}
function imgReuse(pool){
  const root = el("adaptisCfg");
  if (!root) return;
  root.querySelectorAll("img").forEach(im => {
    if (im.closest(".gal")) return;
    /* Беремо тільки фото, які перемальовування прибрало зі сторінки: те, що
       лишилось на місці, не чіпаємо. */
    const list = pool[im.getAttribute("src")];
    const i = list ? list.findIndex(x => !x.isConnected) : -1;
    if (i < 0) return;
    const old = list.splice(i, 1)[0];
    old.className = im.className;
    old.alt = im.alt;
    im.replaceWith(old);
  });
}
function render(){
  /* 09.10.2026: у тестовому варіанті блок «колір корпусу і ціна для Сил Оборони» переїжджає з питання про корпус
     у блок ціни (див. quickPacks). Перед новим малюванням прибираємо переставлений вузол, інакше на сторінці
     було б два з тим самим id, і заповнювався б старий. */
  { const moved = document.querySelector("#adaptisCfg .cfg > .sum > #spCorpusOpts"); if (moved) moved.remove(); }
  const pool = imgPool();
  if (SIMPLE_ON) syncMix();
  if (SIMPLE_ON && SIMPLE.lead) leadBlock();
  else slotCard("lead", "lead");
  /* Amulet питаємо до комплектацій: він потрібен з будь-яким
     набором, і покупець, який прийшов саме по звʼязок у тривогу, не має
     шукати його під усіма кроками. */
  slotCard("amulet", "amulet");
  /* Блок питань малюється до перемикача ціни й кольору: на сторінці термінала
     вони стоять усередині нього, під вибором корпусу. */
  if (SIMPLE_ON) simpleBlock();
  purposeToggle();
  if (!SIMPLE_ON){
    bundles();
    if (MODE === "terminal") packs();
  }
  const list = mainSteps();
  stepsEl.innerHTML = "";
  list.forEach(s => stepsEl.appendChild(stepCard(s)));
  if (SIMPLE_ON) simpleGroup2();
  colorTop();
  slotCard("subs", "sub");
  /* s24 06.10.2026 (власник): камуфляжний чохол окремим блоком після підписки. Місця під нього в розмітці
     секції немає, тому блок створюємо тут, одразу під підпискою. Крок є лише на сторінках корпусів. */
  if (step("cover")){
    if (!el("cover") && el("subs")){
      const ch = document.createElement("section");
      ch.className = "card pane cfgset";
      ch.id = "cover";
      el("subs").insertAdjacentElement("afterend", ch);
    }
    slotCard("cover", "cover");
  }
  quickPacks();
  /* 09.10.2026 (власник): позначка «Є в наявності» біля ціни. Корпус «в колір авто» фарбують під замовлення,
     тому з ним позначку ховаємо (клас is-order); термінал без наявності ховає її класом is-out. */
  { const r0 = el("adaptisCfg"); if (r0) r0.classList.toggle("is-order", MODE !== "terminal" && state.color === "custom"); }
  lockUntilLead();
  imgReuse(pool);
  paint();
  gateSteps();
  foldInit();
  saveState();
}

/* 23.09.2026, вечір: експеримент «крок за кроком». Питання йдуть зверху вниз
   (перше питання сторінки, Amulet, живлення, монтаж, підписка), і наступне
   неактивне, поки на попереднє немає відповіді. Відповідь це вибір покупця:
   значення за замовчуванням рахуються в ціні, але виглядають необраними, тому
   відповіддю не вважаються. Кнопка «Купити» не блокується. Вмикається
   налаштуванням секції, ?steps=0 або ?steps=1 перемикає для перевірки.
   Лише прозорість і inert, без зміни розмітки, тому сторінка не стрибає. */
const STEPS_ON = (() => {
  const q = new URLSearchParams(location.search).get("steps");
  if (q === "0" || q === "1") return q === "1";
  const r = el("adaptisCfg");
  return !!r && r.dataset.steps === "true";
})();
/* Питання сторінки по порядку: питання простого конструктора і картки
   кроків (Amulet, підписка), у яких є варіанти вибору. */
function stepUnits(){
  const root = el("adaptisCfg");
  if (!root) return [];
  /* s24 06.10.2026: блок чохла не крок послідовності, а окрема пропозиція в кінці, тому його не приглушуємо. */
  return [...root.querySelectorAll(".cfg .spick__q, .cfg .cfgset")]
    .filter(u => u.id !== "cover" && u.id !== "quickPacks" && !u.querySelector(".spick__q") && u.querySelector("[aria-pressed]"));
}
function gateSteps(){
  const units = stepUnits();
  let open = true;
  units.forEach(u => {
    if (u.offsetParent === null && !u.classList.contains("is-gated")) return;
    /* 24.09.2026: лише на сторінках адаптацій. На сторінках терміналів
       нічого не блокуємо. */
    const off = STEPS_ON && MODE !== "terminal" && !open;
    u.classList.toggle("is-gated", off);
    u.inert = off;
    if (off) u.setAttribute("aria-disabled", "true"); else u.removeAttribute("aria-disabled");
    if (!u.querySelector('[aria-pressed="true"]')) open = false;
  });
}

/* 24.09.2026: експеримент «згорнутий конструктор на телефоні». Поки
   покупець не відповів на жодне питання, видно перше питання і початок
   наступного, далі все розчиняється в колір фону, під ним кнопка «Показати
   всі кроки». Так до опису товару нижче можна догорнути швидко. Відповідь на
   питання або кнопка розгортають конструктор униз, верх сторінки не рухається.
   Один раз за відвідування: згорнути назад не можна. Якщо відповіді вже є
   (посилання на збірку), не згортаємо. Лише телефон. */
const FOLD_ON = (() => {
  const q = new URLSearchParams(location.search).get("fold");
  if (q === "0" || q === "1") return q === "1";
  const r = el("adaptisCfg");
  return !!r && r.dataset.fold === "true";
})();
let foldDone = false;
function foldInit(){
  if (foldDone) return;
  foldDone = true;
  /* 24.09.2026: лише на сторінках адаптацій, де питань багато. На сторінках
     терміналів конструктор не згортаємо. */
  if (!FOLD_ON || MODE === "terminal" || !window.matchMedia("(max-width: 749px)").matches) return;
  const units = stepUnits();
  if (!units.length || units.some(u => u.querySelector('[aria-pressed="true"]'))) return;
  const col = document.querySelector("#adaptisCfg .cfg");
  const first = col && [...col.children].find(n => n.contains(units[0]));
  if (!first) return;
  const wrap = document.createElement("div");
  wrap.className = "cfgfold is-folded";
  col.insertBefore(wrap, first);
  let n = first;
  while (n){ const next = n.nextElementSibling; wrap.appendChild(n); n = next; }
  const btn = document.createElement("button");
  btn.type = "button";
  btn.className = "btn btn--2 cfgfold__btn";
  btn.innerHTML = ("<span>" + ADL("Показати всі кроки") + "</span>") + icon("chevron", "cfgfold__ch");
  col.appendChild(btn);
  const peek = () => { const u = units[0].getBoundingClientRect(), w = wrap.getBoundingClientRect(); return Math.round(u.bottom - w.top + 140); };
  wrap.style.maxHeight = peek() + "px";
  const open = () => {
    if (!wrap.classList.contains("is-folded")) return;
    wrap.style.maxHeight = wrap.scrollHeight + "px";
    wrap.classList.remove("is-folded");
    btn.remove();
    setTimeout(() => { wrap.style.maxHeight = "none"; }, 450);
  };
  btn.addEventListener("click", open);
  /* Відповідь на питання розгортає: вибір уже зроблено, далі наступні кроки. */
  wrap.addEventListener("click", e => { if (e.target.closest("[aria-pressed], [role=button], .card-opt")) setTimeout(open, 0); });
}

/* Поки на перше питання сторінки немає відповіді, решта конструктора не
   активна: без неї ми не знаємо, чи показувати набори з терміналом, і покупець
   збирав би те, що потім доведеться перезбирати. Блоки лишаються на екрані
   приглушеними, щоб було видно, що далі є з чого вибирати, а не порожньо.
   Блок покупки не блокуємо: корпус можна купити й без відповіді. */
/* Перемикач блокування це інструмент демонстрації, а не поведінка магазину:
   він дозволяє показати обидва флоу поруч, з обовʼязковою відповіддю і без неї.
   За замовчуванням вимкнений, тобто сторінка робоча з першої секунди. */
let gateOn = false;
function lockUntilLead(){
  if (!("terminal" in state)) return;
  const locked = gateOn && state.terminal === null;
  ["bundles", "steps", "subs", "copyCfg"].forEach(id => {
    const n = el(id);
    if (!n) return;
    n.classList.toggle("is-locked", locked);
    if (locked) n.setAttribute("aria-disabled", "true");
    else n.removeAttribute("aria-disabled");
  });
}

/* Вісь «призначення» у каталозі є в корпусів, готових наборів і модуля
   Adaptis Amulet. Термінал, живлення, павербанки, кабелі й монтаж її не мають, тому
   перемикач показується тільки там, де він справді змінює ціну. Опція з
   dual:true теж його вмикає: інакше на сторінці термінала без корпусу покупець
   бачив би ціну для Сил Оборони і не мав чим її перемкнути. */
/* 24.09.2026, ніч: і тоді, коли Amulet є лише для Сил Оборони (adaptis-stock.js
   ставить __lockPurpose): інакше на сторінці термінала не було б перемикача,
   яким його можна отримати. */
const purposeLocked = () => STEPS.some(s => vis(s) && (s.options || []).some(o => o.__lockPurpose));
const purposeMatters = () =>
  AMULET_MODE || MODE !== "terminal" || packHasCorpus() || chosen().some(x => x.o.dual) || purposeLocked();

/* Перемикач цінової категорії стоїть у підсумку, поруч із рядком корпусу,
   на який він впливає, а не в шапці над ціною термінала. */
/* 21.09.2026: на сторінці термінала без корпусу ціну міняє тільки Amulet,
   тому перемикач стоїть у блоці Amulet, а не над ціною. Корпус у комплектації
   повертає його нагору: тоді він міняє ціну всього замовлення. */
function purposeToggle(){
  const top = el("priceMode");
  if (!top) return;
  top.innerHTML = "";
  if (!purposeMatters()) return;
  /* 24.09.2026: перемикач не перестрибує. На сторінці термінала він лишається
     в блоці Amulet (ціна Amulet теж залежить від призначення), а з корпусом
     з'являється ще й під вибором корпусу. Обидва показують той самий стан. */
  const amuletBox = MODE === "terminal" && el("amulet") && !el("amulet").hidden ? el("amulet") : null;
  const hosts = [];
  if (MODE === "terminal"){
    if (amuletBox && (!packHasCorpus() || chosen().some(x => x.o.dual) || purposeLocked())) hosts.push(amuletBox);
    if (packHasCorpus()) hosts.push(el("spCorpusOpts") || top);
    else if (AMULET_MODE) hosts.push(top);
  } else hosts.push(el("spCorpusOpts") || top);
  hosts.forEach(host => {
    if (!host) return;
    const w = document.createElement("label");
    w.className = "tgl";
    w.innerHTML = '<input type="checkbox" class="tgl__i"><span class="tgl__b"></span>' +
      ("<span class=\"tgl__t\"><b>" + ADL("Ціна для Сил Оборони України") + "</b></span>");
    const i = w.querySelector("input");
    i.checked = state.purpose === "defense";
    /* s24b 06.10.2026 (власник): сторінка не стрибає при перемиканні ціни. Перемальовування міняє висоту
       блоків над перемикачем (перекреслена ціна, рядок Amulet), і перемикач тікав з-під пальця на 10-25 px.
       Запам'ятовуємо, де він був на екрані, і після перемальовування повертаємо сторінку так, щоб він
       лишився там само; ще раз у наступному кадрі, бо браузер може підправити прокрутку сам. */
    i.addEventListener("change", () => {
      const tgls = () => [...document.querySelectorAll("#adaptisCfg .tgl")];
      const idx = tgls().indexOf(w), before = w.getBoundingClientRect().top;
      state.purpose = i.checked ? "defense" : "civil";
      render();
      const fix = () => {
        const now = tgls()[idx];
        if (!now) return;
        const d = now.getBoundingClientRect().top - before;
        if (Math.abs(d) >= 1) window.scrollBy({top:d, behavior:"instant"});
      };
      fix();
      requestAnimationFrame(() => { fix(); requestAnimationFrame(fix); });
    });
    /* У блоці Amulet посилання «Що таке Adaptis Amulet?» лишається останнім. */
    const info = host.querySelector(":scope > .cfgset__info");
    if (info) host.insertBefore(w, info); else host.appendChild(w);
  });
}

/* Іконки Hugeicons (@hugeicons/core-free-icons 4.3.0): viewBox 24, обведення
   1.5, без заливки. Вони підкріплюють конкретний факт у картці, а не позначають
   картку цілком: та сама іконка означає те саме в усіх комплектаціях. */
const ICONS = {
  wifi:'<path d="M2 8.8C7.6 4 16.4 4 22 8.8"/><path d="M5.2 12.3C9 9.2 15 9.2 18.8 12.3"/><path d="M8.5 15.7C10.6 14.1 13.4 14.1 15.5 15.7"/><path d="M12 19.5H12.01"/>',
  refresh:'<path d="M20.5 11A8.5 8.5 0 0 0 5.9 6L3.5 8.5"/><path d="M3.5 4V8.5H8"/><path d="M3.5 13A8.5 8.5 0 0 0 18.1 18L20.5 15.5"/><path d="M20.5 20V15.5H16"/>',
  chip:'<rect x="6" y="6" width="12" height="12" rx="2.5"/><path d="M9.5 10H14.5V14H9.5Z"/><path d="M9 2.5V6M15 2.5V6M9 18V21.5M15 18V21.5M2.5 9H6M2.5 15H6M18 9H21.5M18 15H21.5"/>',
  check:'<circle cx="12" cy="12" r="10"/><path d="M8 12.5L10.5 15L16 9.5"/>',
  gpsoff:'<path d="M9.2 3A8.6 8.6 0 0 1 20.3 7.4C21.4 10 21 12.3 19.8 14.4"/><path d="M17.2 17.6C16 18.9 14.8 20.1 13.6 21.4C13.2 21.8 12.6 22 12 22C11.4 22 10.8 21.8 10.4 21.4C6.4 17.6 1.1 13.4 3.7 7.4"/><path d="M12 14.5A3.5 3.5 0 0 1 8.5 11"/><path d="M3 3L21 21"/>',
  socket:'<path d="M9 2L9 5"/><path d="M15 2L15 5"/><path d="M12 18L12 22"/><path d="M12.6939 8.5L10.6029 10.6749C10.3788 10.9079 10.5394 11.2433 10.9048 11.3053L13.0952 11.6773C13.4848 11.7434 13.6334 12.1147 13.361 12.3413L10.7666 14.5"/><path d="M14.3066 5L9.69342 5C7.5551 5 6.48594 5 5.89527 5.69774C5.3046 6.39548 5.46717 7.46639 5.79232 9.60823L6.31604 13.0581C6.83606 16.4836 8.28588 18 12 18C15.7141 18 17.1639 16.4836 17.684 13.0581L18.2077 9.60823C18.5328 7.46639 18.6954 6.39548 18.1047 5.69774C17.5141 5 16.4449 5 14.3066 5Z"/>',
  plug:'<path d="M17.854 12.16C17.471 12.6105 16.7631 12.6138 16.3165 12.1671L11.8329 7.68351C11.3862 7.23686 11.3895 6.529 11.84 6.14596L13.071 5.09939C13.9559 4.34704 15.0349 3.84824 16.2044 3.6509L16.9294 3.52858C17.614 3.41306 18.3339 3.65221 18.8475 4.16577L19.8342 5.15255C20.3478 5.66611 20.5869 6.38601 20.4714 7.07063L20.3491 7.79559C20.1518 8.9651 19.653 10.0441 18.9006 10.929L17.854 12.16Z"/><path d="M19.5 4.5L21.5 2.5"/><path d="M2.5 21.5L4.5 19.5"/><path d="M6.14596 11.84C6.52901 11.3895 7.23686 11.3862 7.68351 11.8329L12.1671 16.3165C12.6138 16.7631 12.6105 17.471 12.16 17.854L10.929 18.9006C10.0441 19.653 8.9651 20.1518 7.79559 20.3491L7.07063 20.4714C6.38601 20.5869 5.66611 20.3478 5.15255 19.8342L4.16577 18.8475C3.65221 18.3339 3.41306 17.614 3.52858 16.9294L3.6509 16.2044C3.84824 15.0349 4.34704 13.9559 5.09939 13.071L6.14596 11.84Z"/><path d="M8.5 12.5L10.5 10.5M11.5 15.5L13.5 13.5"/>',
  cable:'<path d="M8 17.125V17C8 16.5355 8 16.3032 7.96922 16.1089C7.79979 15.0392 6.96082 14.2002 5.89109 14.0308C5.69675 14 5.4645 14 5 14C4.5355 14 4.30325 14 4.10891 14.0308C3.03918 14.2002 2.20021 15.0392 2.03078 16.1089C2 16.3032 2 16.5355 2 17V17.125C2 17.4735 2 17.6477 2.02882 17.7926C2.14718 18.3877 2.61233 18.8528 3.20736 18.9712C3.35226 19 3.52651 19 3.875 19H6.125C6.47349 19 6.64774 19 6.79264 18.9712C7.38767 18.8528 7.85282 18.3877 7.97118 17.7926C8 17.6477 8 17.4735 8 17.125Z"/><path d="M5 14V6.5C5 4.567 6.567 3 8.5 3C10.433 3 12 4.567 12 6.5V17.5C12 19.433 13.567 21 15.5 21C17.433 21 19 19.433 19 17.5V10"/><path d="M20.125 5H17.875C17.5265 5 17.3523 5 17.2074 5.02882C16.6123 5.14718 16.1472 5.61233 16.0288 6.20736C16 6.35226 16 6.52651 16 6.875V7C16 7.4645 16 7.69675 16.0308 7.89109C16.2002 8.96082 17.0392 9.79979 18.1089 9.96922C18.3032 10 18.5355 10 19 10C19.4645 10 19.6968 10 19.8911 9.96922C20.9608 9.79979 21.7998 8.96082 21.9692 7.89109C22 7.69675 22 7.4645 22 7V6.875C22 6.52651 22 6.35226 21.9712 6.20736C21.8528 5.61233 21.3877 5.14718 20.7926 5.02882C20.6477 5 20.4735 5 20.125 5Z"/><path d="M17 5V3M21 3V5"/><path d="M3 21V19M7 19V21"/>',
  ports:'<path d="M15.5 6V5.5C15.5 4.09554 15.5 3.39331 15.1629 2.88886C15.017 2.67048 14.8295 2.48298 14.6111 2.33706C14.1067 2 13.4045 2 12 2C10.5955 2 9.89331 2 9.38886 2.33706C9.17048 2.48298 8.98298 2.67048 8.83706 2.88886C8.5 3.39331 8.5 4.09554 8.5 5.5V6"/><path d="M6.00446 7.11331C5.93719 6.24273 6.63957 5.5 7.53014 5.5H16.4699C17.3604 5.5 18.0628 6.24273 17.9955 7.11331L17.8117 9.49197C17.6796 11.2019 17.1011 12.8498 16.132 14.2773L15.5312 15.1622C14.9638 15.9979 14.0077 16.5 12.9838 16.5H11.0162C9.99228 16.5 9.03617 15.9979 8.46881 15.1622L7.86803 14.2773C6.89885 12.8498 6.32041 11.2019 6.18827 9.49197L6.00446 7.11331Z"/><path d="M12 17V22"/><path d="M11 8.5H13"/>',
  battery:'<path d="M2 12C2 9.17157 2 7.75736 2.87868 6.87868C3.75736 6 5.17157 6 8 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12C19 14.8284 19 16.2426 18.1213 17.1213C17.2426 18 15.8284 18 13 18H8C5.17157 18 3.75736 18 2.87868 17.1213C2 16.2426 2 14.8284 2 12Z"/><path d="M19 9.5L20.0272 9.6712C20.7085 9.78475 21.0491 9.84152 21.3076 10.0067C21.5618 10.1691 21.7612 10.4044 21.8796 10.6819C22 10.964 22 11.3093 22 12C22 12.6907 22 13.036 21.8796 13.3181C21.7612 13.5956 21.5618 13.8309 21.3076 13.9933C21.0491 14.1585 20.7085 14.2153 20.0272 14.3288L19 14.5"/><path d="M6 10V14"/><path d="M9 10V14"/><path d="M12 10V14"/><path d="M15 10V14"/>',
  batteryfull:'<path d="M2 12C2 9.17157 2 7.75736 2.87868 6.87868C3.75736 6 5.17157 6 8 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12C19 14.8284 19 16.2426 18.1213 17.1213C17.2426 18 15.8284 18 13 18H8C5.17157 18 3.75736 18 2.87868 17.1213C2 16.2426 2 14.8284 2 12Z"/><path d="M19 9.5L20.0272 9.6712C20.7085 9.78475 21.0491 9.84152 21.3076 10.0067C21.5618 10.1691 21.7612 10.4044 21.8796 10.6819C22 10.964 22 11.3093 22 12C22 12.6907 22 13.036 21.8796 13.3181C21.7612 13.5956 21.5618 13.8309 21.3076 13.9933C21.0491 14.1585 20.7085 14.2153 20.0272 14.3288L19 14.5"/><path d="M6 10V14"/><path d="M9 10V14"/><path d="M12 10V14"/><path d="M15 10V14"/>',
  phone:'<path d="M13.5 2H10.5C8.14298 2 6.96447 2 6.23223 2.73223C5.5 3.46447 5.5 4.64298 5.5 7V17C5.5 19.357 5.5 20.5355 6.23223 21.2678C6.96447 22 8.14298 22 10.5 22H13.5C15.857 22 17.0355 22 17.7678 21.2678C18.5 20.5355 18.5 19.357 18.5 17V7C18.5 4.64298 18.5 3.46447 17.7678 2.73223C17.0355 2 15.857 2 13.5 2Z"/><path d="M12.125 19H12M12.25 19C12.25 19.1381 12.1381 19.25 12 19.25C11.8619 19.25 11.75 19.1381 11.75 19C11.75 18.8619 11.8619 18.75 12 18.75C12.1381 18.75 12.25 18.8619 12.25 19Z"/>',
  stopwatch:'<path d="M18.0104 7.48959L19.5 6M20.5 13.5C20.5 18.1944 16.6944 22 12 22C7.30558 22 3.5 18.1944 3.5 13.5C3.5 8.80558 7.30558 5 12 5C16.6944 5 20.5 8.80558 20.5 13.5Z"/><path d="M14.5 2H9.5"/><path d="M12 13.5L15.5 10"/>',
  shield:'<path d="M18.7088 3.49534C16.8165 2.55382 14.5009 2 12 2C9.4991 2 7.1835 2.55382 5.29116 3.49534C4.36318 3.95706 3.89919 4.18792 3.4496 4.91378C3 5.63965 3 6.34248 3 7.74814V11.2371C3 16.9205 7.54236 20.0804 10.173 21.4338C10.9067 21.8113 11.2735 22 12 22C12.7265 22 13.0933 21.8113 13.8269 21.4338C16.4576 20.0804 21 16.9205 21 11.2371L21 7.74814C21 6.34249 21 5.63966 20.5504 4.91378C20.1008 4.18791 19.6368 3.95706 18.7088 3.49534Z"/><path d="M15 11C15 12.6568 13.6569 14 12 14C10.3431 14 9 12.6568 9 11C9 9.34314 10.3431 8 12 8C13.6569 8 15 9.34314 15 11Z"/>',
  magnet:'<path d="M3.925 2.5H9.15C9.15 2.5 8.2 7.7 8.2 10.1C8.2 13.1 10.1 15.5 12 15.5C13.9 15.5 15.8 13.1 15.8 10.1C15.8 7.7 14.85 2.5 14.85 2.5H20.075C20.075 2.5 21.5 7.13842 21.5 11.5C21.5 17 17.7 21.5 12 21.5C6.3 21.5 2.5 17 2.5 11.5C2.5 7.13842 3.925 2.5 3.925 2.5Z"/><path d="M2.97266 7.25H8.19766M15.7977 7.25L21.0227 7.25"/>',
  energy:'<path d="M6.19351 11.3965L12.192 3.31186C12.6611 2.67957 13.5405 3.07311 13.5405 3.91536V10.1729C13.5405 10.6775 13.8853 11.0865 14.3107 11.0865H17.2283C17.891 11.0865 18.2443 12.0134 17.8065 12.6035L11.808 20.6881C11.3389 21.3204 10.4595 20.9269 10.4595 20.0846V13.8271C10.4595 13.3225 10.1147 12.9135 9.68931 12.9135H6.77173C6.10895 12.9135 5.75566 11.9866 6.19351 11.3965Z"/>',
  globe:'<circle cx="12" cy="12" r="10"/><path d="M8 12C8 18 12 22 12 22C12 22 16 18 16 12C16 6 12 2 12 2C12 2 8 6 8 12Z"/><path d="M21 15H3"/><path d="M21 9H3"/>',
  infinity:'<path d="M12 12C12 12 10.3569 14.5 8.7 14.5C7.04315 14.5 6 13.3807 6 12C6 10.6193 7.04315 9.5 8.7 9.5C10.3569 9.5 12 12 12 12ZM12 12C12 12 13.6431 14.5 15.3 14.5C16.9569 14.5 18 13.3807 18 12C18 10.6193 16.9569 9.5 15.3 9.5C13.6431 9.5 12 12 12 12Z"/><circle cx="12" cy="12" r="10"/>',
  road:'<path d="M2 21.9979V11.9955"/><path d="M22 21.9979V11.9955"/><path d="M12 21.9974V20.9977"/><path d="M12 17.9964V16.9967"/><path d="M5.72533 5.65438L6.55526 6.41335M6.55526 6.41335C6.71446 6.14502 6.99041 5.67493 7.08183 5.38084C7.88067 2.81094 7.95145 2.10297 9.18504 2.00183H14.8119C16.0455 2.10297 16.1163 2.81094 16.9151 5.38084C17.0065 5.67493 17.2326 6.14502 17.3918 6.41335M6.55526 6.41335C5.95054 7.43262 5.1493 8.09969 5.02924 8.98037C5.0096 9.12441 5.02924 10.7318 5.02924 11.898C5.02924 12.7742 5.87312 12.7475 6.69535 12.8157C7.21787 12.859 7.74116 12.9538 8.26545 12.9592C11.1713 12.9888 13.0926 12.9919 15.9671 12.9606C16.5229 12.9545 17.083 12.85 17.637 12.803C18.2625 12.7499 18.9165 12.6794 18.9677 11.898C19.044 10.733 18.9873 9.12441 18.9677 8.98037C18.8476 8.09969 17.9965 7.43262 17.3918 6.41335M6.55526 6.41335H17.3918M17.3918 6.41335L18.364 5.65438M5.20362 8.42936L6.41209 9.34913M10.5581 10.5112L13.4968 10.5112M17.6201 9.32635L18.9548 8.90078M7.08183 12.855L7.00382 14.4987M16.9822 12.8755V14.4987"/>',
  user:'<path d="M20 21.0001C19.713 17.269 16.7289 14.3151 12.995 14.0662L12 13.9999C11.6446 14.0096 11.3134 14.0225 11.0008 14.0378C7.3 14.2192 4.28417 17.3057 4 21.0001"/><circle cx="12" cy="6.99988" r="4"/>',
  calendar:'<path d="M16 2V6M8 2V6"/><path d="M13 4H11C7.22876 4 5.34315 4 4.17157 5.17157C3 6.34315 3 8.22876 3 12V14C3 17.7712 3 19.6569 4.17157 20.8284C5.34315 22 7.22876 22 11 22H13C16.7712 22 18.6569 22 19.8284 20.8284C21 19.6569 21 17.7712 21 14V12C21 8.22876 21 6.34315 19.8284 5.17157C18.6569 4 16.7712 4 13 4Z"/><path d="M3 10H21"/>',
  card:'<path d="M2 12C2 8.46252 2 6.69377 3.0528 5.5129C3.22119 5.32403 3.40678 5.14935 3.60746 4.99087C4.86213 4 6.74142 4 10.5 4H13.5C17.2586 4 19.1379 4 20.3925 4.99087C20.5932 5.14935 20.7788 5.32403 20.9472 5.5129C22 6.69377 22 8.46252 22 12C22 15.5375 22 17.3062 20.9472 18.4871C20.7788 18.676 20.5932 18.8506 20.3925 19.0091C19.1379 20 17.2586 20 13.5 20H10.5C6.74142 20 4.86213 20 3.60746 19.0091C3.40678 18.8506 3.22119 18.676 3.0528 18.4871C2 17.3062 2 15.5375 2 12Z"/><path d="M10 16H11.5"/><path d="M14.5 16L18 16"/><path d="M2 9H22"/>',
  speed:'<path d="M13.5 13L17 9M14 15C14 16.1046 13.1046 17 12 17C10.8954 17 10 16.1046 10 15C10 13.8954 10.8954 13 12 13C13.1046 13 14 13.8954 14 15Z"/><path d="M6 12C6 8.68629 8.68629 6 12 6C13.0929 6 14.1175 6.29218 15 6.80269"/><path d="M2.50006 12.0001C2.50006 7.52172 2.50006 5.28255 3.8913 3.8913C5.28255 2.50006 7.52172 2.50006 12.0001 2.50006C16.4784 2.50006 18.7176 2.50006 20.1088 3.8913C21.5001 5.28255 21.5001 7.52172 21.5001 12.0001C21.5001 16.4784 21.5001 18.7176 20.1088 20.1088C18.7176 21.5001 16.4784 21.5001 12.0001 21.5001C7.52172 21.5001 5.28255 21.5001 3.8913 20.1088C2.50006 18.7176 2.50006 16.4784 2.50006 12.0001Z"/>',
  wrench:'<path d="M20.3584 13.3567C19.1689 14.546 16.9308 14.4998 13.4992 14.4998C11.2914 14.4998 9.50138 12.7071 9.50024 10.4993C9.50024 7.07001 9.454 4.83065 10.6435 3.64138C11.8329 2.45212 12.3583 2.50027 17.6274 2.50027C18.1366 2.49809 18.3929 3.11389 18.0329 3.47394L15.3199 6.18714C14.6313 6.87582 14.6294 7.99233 15.3181 8.68092C16.0068 9.36952 17.1234 9.36959 17.8122 8.68109L20.5259 5.96855C20.886 5.60859 21.5019 5.86483 21.4997 6.37395C21.4997 11.6422 21.5479 12.1675 20.3584 13.3567Z"/><path d="M13.5 14.5L7.32842 20.6716C6.22386 21.7761 4.433 21.7761 3.32843 20.6716C2.22386 19.567 2.22386 17.7761 3.32843 16.6716L9.5 10.5"/><path d="M5.50896 18.5H5.5"/>',
  pin:'<path d="M13.6177 21.367C13.1841 21.773 12.6044 22 12.0011 22C11.3978 22 10.8182 21.773 10.3845 21.367C6.41302 17.626 1.09076 13.4469 3.68627 7.37966C5.08963 4.09916 8.45834 2 12.0011 2C15.5439 2 18.9126 4.09916 20.316 7.37966C22.9082 13.4393 17.599 17.6389 13.6177 21.367Z"/><path d="M15.5 11C15.5 12.933 13.933 14.5 12 14.5C10.067 14.5 8.5 12.933 8.5 11C8.5 9.067 10.067 7.5 12 7.5C13.933 7.5 15.5 9.067 15.5 11Z"/>',
  support:'<path d="M17 11.8045C17 11.4588 17 11.286 17.052 11.132C17.2032 10.6844 17.6018 10.5108 18.0011 10.3289C18.45 10.1244 18.6744 10.0222 18.8968 10.0042C19.1493 9.98378 19.4022 10.0382 19.618 10.1593C19.9041 10.3198 20.1036 10.6249 20.3079 10.873C21.2513 12.0188 21.7229 12.5918 21.8955 13.2236C22.0348 13.7334 22.0348 14.2666 21.8955 14.7764C21.6438 15.6979 20.8485 16.4704 20.2598 17.1854C19.9587 17.5511 19.8081 17.734 19.618 17.8407C19.4022 17.9618 19.1493 18.0162 18.8968 17.9958C18.6744 17.9778 18.45 17.8756 18.0011 17.6711C17.6018 17.4892 17.2032 17.3156 17.052 16.868C17 16.714 17 16.5412 17 16.1955V11.8045Z"/><path d="M7 11.8046C7 11.3694 6.98778 10.9782 6.63591 10.6722C6.50793 10.5609 6.33825 10.4836 5.99891 10.329C5.55001 10.1246 5.32556 10.0224 5.10316 10.0044C4.43591 9.9504 4.07692 10.4058 3.69213 10.8732C2.74875 12.019 2.27706 12.5919 2.10446 13.2237C1.96518 13.7336 1.96518 14.2668 2.10446 14.7766C2.3562 15.6981 3.15152 16.4705 3.74021 17.1856C4.11129 17.6363 4.46577 18.0475 5.10316 17.996C5.32556 17.978 5.55001 17.8757 5.99891 17.6713C6.33825 17.5167 6.50793 17.4394 6.63591 17.3281C6.98778 17.0221 7 16.631 7 16.1957V11.8046Z"/><path d="M20 10.5V9C20 5.13401 16.4183 2 12 2C7.58172 2 4 5.13401 4 9V10.5"/><path d="M20 17.5C20 22 16 22 12 22"/>',
  chevron:'<path d="M6 9L12 15L18 9"/>',
  home:'<path d="M3 10.5L12 3l9 7.5"/><path d="M5 9v11h14V9"/><path d="M10 20v-6h4v6"/>',
  /* 09.10.2026 (власник): проста іконка авто для комплекту «на авто» (road це авто на дорозі). Lucide car, ISC. */
  car:'<path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2"/><circle cx="7" cy="17" r="2"/><path d="M9 17h6"/><circle cx="17" cy="17" r="2"/>',
  info:'<circle cx="12" cy="12" r="10"/><path d="M12 16V12"/><path d="M12.125 8.25H12M12.25 8.25C12.25 8.11193 12.1381 8 12 8C11.8619 8 11.75 8.11193 11.75 8.25C11.75 8.38807 11.8619 8.5 12 8.5C12.1381 8.5 12.25 8.38807 12.25 8.25Z"/>',
};
function icon(name, cls){
  return '<svg class="' + cls + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
    'stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    (ICONS[name] || ICONS.info) + '</svg>';
}

/* Рядок характеристики: іконка плюс факт. Використовується і в картці
   комплектації, і в блоці підписки. */
function featRow(f, cls){
  const li = document.createElement("li");
  li.innerHTML = icon(f.i, cls);
  const t = document.createElement("span");
  t.textContent = f.t;
  li.appendChild(t);
  return li;
}
function featList(feats, listCls, iconCls){
  const ul = document.createElement("ul");
  ul.className = listCls;
  feats.forEach(f => ul.appendChild(featRow(f, iconCls)));
  return ul;
}

/* Готові комплектації це головне рішення сторінки, тому вони займають повну
   ширину колонки й показують склад із цінами, а не два слова на чіпі.

   A1: спершу питаємо, чи термінал уже є, і показуємо тільки ті комплектації,
   які відповідають відповіді. Пропонувати набір із терміналом тому, у кого він
   лежить у багажнику, це змарнований блок і привід подумати, що термінал
   входить у корпус.

   A2: зайвий вибір гальмує. У списку лишаються основні комплектації, решта
   ховається за рядком «інші варіанти». */
/* Картка комплектації згортається: основні розгорнуті, решта стоїть згорнутим
   рядком і розкривається кліком. Так видно весь список, але він не займає
   пів екрана і не змушує вибирати з пʼяти однаково докладних карток. */
const openBundles = new Set();
/* Рекомендовані це ті самі комплектації, які відкриті на вході. Плашка йде за
   ними і не міняється, коли покупець щось згортає чи розгортає руками. */
const recBundles = new Set();
let bundlesInit = false;
function initOpenBundles(){
  if (bundlesInit || typeof BUNDLES === "undefined") return;
  bundlesInit = true;
  /* Рекомендовані задані в даних полем rec, а не позицією: рекомендація це
     рішення продажу, а не побічний ефект порядку. Рекомендовані ж і розгорнуті:
     якщо ми радимо набір, покупець має бачити його склад одразу. */
  /* 22.09.2026: за замовчуванням усі картки згорнуті, рекомендовані теж:
     пігулка «Рекомендуємо» стоїть поруч із назвою і видна в згорнутому рядку. */
  BUNDLES.forEach(p => { if (p.rec) recBundles.add(p.handle); });
}
function bundleList(){
  const list = typeof BUNDLES === "undefined" ? [] : BUNDLES;
  /* Порядок сходинки не міняємо: назви комплектацій це градація від простого
     до максимального, і якщо винести розгорнуті наперед, Drive Pro опиниться
     над Base, а сходинка перестане читатись. Згорнуті стоять на своїх місцях,
     просто складеними. */
  return list.filter(p => {
    if (p.when && !p.when()) return false;
    /* Комплектація прив'язана до відповіді про термінал самим складом. */
    if ("terminal" in state && p.pick && p.pick.terminal)
      /* Поки відповіді немає, показуємо повну лінійку наборів із терміналом:
         це основна пропозиція магазину, і ховати її до відповіді немає сенсу.
         Модель термінала на список не впливає, впливає лише те, купують його
         чи ні, тому відповіді зводяться до двох груп. */
      return p.pick.terminal === termGroup(state.terminal || "buy");
    return true;
  });
}
function bundles(){
  const host = el("bundles");
  if (!host || typeof BUNDLES === "undefined") return;
  const list = bundleList();
  host.innerHTML = "";
  const own = "terminal" in state && state.terminal === "own";
  /* Порожній блок виглядав би поламаним, тому кажемо прямо, чому наборів
     немає, і куди йти далі. */
  if (!list.length){
    if (!own){ host.hidden = true; return; }
    host.hidden = false;
    host.innerHTML = ("<h2 class=\"cfgset__t\">" + ADL("Комплектації до вашого терміналу") + "</h2>") +
      ("<p class=\"cfgset__h\">" + ADL("Готових наборів без термінала в каталозі поки немає.") + " ") +
      (ADL("Зберіть свою нижче: корпус уже в кошику, лишається живлення й монтаж.") + "</p>");
    return;
  }
  host.hidden = false;
  const h = document.createElement("h2");
  h.className = "cfgset__t";
  h.textContent = own ? ADL("Комплектації до вашого терміналу") : ADL("Готові комплектації");
  host.appendChild(h);
  const hint = document.createElement("p");
  hint.className = "cfgset__h";
  hint.textContent = own
    ? ADL("Термінал у них не входить, ви ставите свій. Обрана комплектація заповнює блоки нижче, будь-що можна змінити.")
    : ADL("Готові набори з каталогу. Обрана комплектація заповнює блоки нижче, будь-що можна змінити.");
  host.appendChild(hint);

  initOpenBundles();
  list.forEach(p => host.appendChild(bundleCard(p)));
  kitDisc(host);
}

/* Склад комплектації рахується з тих самих кроків, які вона заповнює,
   тому картка не може розійтися з тим, що станеться після кліку. */
/* Комплектація описує групу («з терміналом»), а модель обирає покупець, тому
   ціну термінала беремо з його відповіді, а не зі складу набору. Поки відповіді
   немає, рахуємо за складом, тобто за Starlink Mini. */
const pickVal = (p, k) => (k === "terminal" && state[k]) ? state[k] : p.pick[k];
function bundleLines(p){
  const corpusImg = typeof COLOR_MEDIA === "undefined" ? null : (COLOR_MEDIA[state.color] || [])[0];
  const out = [{t:baseTitle() + ", " + colorTitle(), price:corpusPrice(), img:corpusImg, base:true, variant:corpusVariant()}];
  Object.keys(p.pick).forEach(k => {
    const st = step(k);
    if (!st) return;
    const o = opt(st, pickVal(p, k));
    /* Перелічуємо тільки те, що входить у комплектацію. Рядки на кшталт
       «термінал ваш» або «без павербанка» це перелік того, чого немає. */
    if (!o || (!priceOf(o) && !variantOf(o))) return;
    out.push({t:val(o.sumT) || o.title, price:priceOf(o), img:o.img, variant:variantOf(o)});
  });
  /* Крок з inBundles не заповнюється комплектацією, але входить у склад її
     картки, поки покупець його не зняв: так Adaptis Amulet стає частиною
     кожного набору з терміналом. Набору без термінала він не стосується. */
  if (p.pick.terminal !== "own")
    STEPS.filter(st => st.inBundles && !(st.handle in p.pick)).forEach(st => {
      const o = opt(st, state[st.handle]);
      if (o && priceOf(o)) out.push({t:val(o.sumT) || o.title, price:priceOf(o), img:o.img, src:o.src, variant:variantOf(o)});
    });
  return out;
}

/* Ціна картки: якщо в каталозі є справжній набір із тим самим складом,
   показуємо його ціну і різницю з ціною тих самих товарів окремо. Набір
   покриває не обовʼязково всю комплектацію, тому те, що лишилось поза ним,
   додається зверху за своєю ціною. */
function bundlePrice(p, lines){
  const loose = lines.reduce((a,l) => a + l.price, 0);
  const k = kitOf(p);
  if (!k || k.colors.indexOf(state.color) < 0) return {sum:loose, loose:loose, save:0};
  const inKit = corpusPrice() + k.covers.reduce((a,h) => {
    const st = step(h), o = st ? opt(st, pickVal(p, h)) : null;
    return a + (o ? priceOf(o) : 0);
  }, 0);
  const kp = kitPrice(k);
  return {sum:kp + (loose - inKit), loose:loose, save:inKit - kp};
}

/* Картка комплектації однакова на сторінці адаптації і на сторінці термінала:
   заголовок, кому підходить, характеристики, склад із фото, ціна. */
/* 22.09.2026: після вибору комплектації сторінка перемальовується, і картки
   над обраною можуть змінити висоту. Тримаємо обрану картку на тому самому
   місці екрана, щоб сторінка не стрибала. */
function keepPlace(h, fn){
  const q = () => document.querySelector('.cfgcard[data-h="' + h + '"]');
  const a = q();
  const before = a ? a.getBoundingClientRect().top : null;
  fn();
  const b2 = q();
  if (before === null || !b2) return;
  const d = b2.getBoundingClientRect().top - before;
  if (d) window.scrollBy({top:d, behavior:"instant"});
}
function comboCard(c){
  const art = document.createElement("article");
  if (c.handle) art.dataset.h = c.handle;
  const folded = !!c.onFold && !c.open;
  art.className = "cfgcard" + (c.on ? " is-on" : "") + (folded ? " is-folded" : "");
  art.innerHTML =
    '<div class="cfgcard__h">' +
      '<div class="cfgcard__hb">' +
        '<div class="cfgcard__tt"><h3 class="cfgcard__t"></h3>' +
        /* 23.09.2026: концепцію «рекомендуємо» прибрано зовсім. */
        '</div>' +
        '<p class="cfgcard__w"></p>' +
      '</div>' +
      (c.onFold ? '<button type="button" class="cfgcard__fold">' +
        icon("chevron", "cfgcard__ch") + '</button>' : '') +
    '</div>' +
    '<ul class="cfgcard__f"></ul>' +
    '<ul class="cfgcard__l"></ul>' +
    '<div class="cfgcard__foot">' +
      /* Перекреслених цін у комплектаціях немає: у каталозі знижки на набори
         зараз немає, а суцільне перекреслення дає банерну сліпоту. Показуємо
         тільки кінцеву ціну. */
      '<span class="cfgcard__p"><b>' + money(c.sum) + '</b></span>' +
      '<button type="button" class="cfgcard__b"></button>' +
    '</div>';
  art.querySelector(".cfgcard__t").textContent = c.title;
  art.querySelector(".cfgcard__w").textContent = c.who || "";
  const fl = art.querySelector(".cfgcard__f");
  (c.feats || []).forEach(f => fl.appendChild(featRow(f, "cfgcard__fi")));

  const ul = art.querySelector(".cfgcard__l");
  (c.lines || []).forEach(l => {
    const li = document.createElement("li");
    /* 22.09.2026: кожен товар складу відкривається окремо в новій вкладці,
       сторінка з конструктором лишається на місці. /variants/<id> Shopify
       переводить на сторінку товару з потрібним варіантом. */
    const href = l.variant ? cartRoot() + "variants/" + l.variant : null;
    const wrap = tagName => {
      const n = document.createElement(href ? "a" : tagName);
      if (href){ n.href = href; n.target = "_blank"; n.rel = "noopener"; }
      return n;
    };
    if (l.img){
      const ph = wrap("span");
      ph.className = "cfgcard__th";
      ph.innerHTML = '<img src="' + im(l.img, 240) + '" alt="" loading="lazy">';
      li.appendChild(ph);
    } else if (l.src){
      const ph = wrap("span");
      ph.className = "cfgcard__th";
      ph.innerHTML = '<img src="' + l.src + '" alt="" loading="lazy">';
      li.appendChild(ph);
    }
    const t = wrap("span");
    if (href){ t.className = "cfgcard__ln"; t.title = ADL("Відкрити товар у новій вкладці"); }
    t.textContent = l.t;
    li.appendChild(t);
    if (l.price){
      const v = document.createElement("b");
      v.textContent = money(l.price);
      li.appendChild(v);
    }
    ul.appendChild(li);
  });

  if (c.onFold){
    const f = art.querySelector(".cfgcard__fold");
    f.setAttribute("aria-expanded", String(!folded));
    f.setAttribute("aria-label", folded ? ADL("Показати склад") : ADL("Згорнути склад"));
    /* Уся шапка картки відкриває й закриває склад: цілитись у шеврон на телефоні
       незручно, а назва комплектації це найбільша мішень на картці. */
    art.querySelector(".cfgcard__h").addEventListener("click", c.onFold);
  }

  const b = art.querySelector(".cfgcard__b");
  /* Обране треба вміти зняти. Поки кнопка казала «Обрано», вийти з комплектації
     можна було тільки переклацуванням кроків. */
  b.textContent = !c.on ? ADL("Обрати комплектацію")
                : (c.canUnpick === false ? ADL("Обрано") : ADL("Скасувати вибір"));
  b.setAttribute("aria-pressed", String(c.on));
  b.addEventListener("click", c.onPick);
  return art;
}

function bundleCard(p){
  const lines = bundleLines(p);
  const pr = bundlePrice(p, lines);
  return comboCard({
    handle:p.handle, on:bundleOn(p), rec:recBundles.has(p.handle), title:p.title, who:p.who, feats:p.feats,
    lines:lines, sum:pr.sum, loose:pr.loose, save:pr.save,
    open:openBundles.has(p.handle),
    onFold:() => keepPlace(p.handle, () => {
      if (openBundles.has(p.handle)) openBundles.delete(p.handle);
      else openBundles.add(p.handle);
      render();
    }),
    /* Вибір комплектації розкриває її картку: покупець щойно сказав, що вона
       його цікавить, і має побачити склад, який поїхав у кроки. */
    onPick:() => {
      if (bundleOn(p)){ keepPlace(p.handle, () => { clearBundle(p); openSteps.clear(); slide = 0; render(); }); return; }
      keepPlace(p.handle, () => {
        applyBundle(p.handle); openBundles.add(p.handle);
        if (window.AdaptisSrc) window.AdaptisSrc.track("cfg_pick_" + window.AdaptisSrc.fam() + "_" + p.handle);
        openSteps.clear(); slide = 0; render();
      });
      /* 22.09.2026: обрана комплектація одразу йде в кошик, далі pop-up кошика
         з допродажем монтажу й підписки. */
      addToCart(el("buy"));
    }
  });
}

/* Слот, який малюється звичайною карткою на рівні з рештою блоків,
   а не згорнутим рядком. */
function slotCard(hostId, name){
  const host = el(hostId);
  if (!host) return;
  const list = slotSteps(name);
  host.innerHTML = "";
  if (!list.length){ host.hidden = true; return; }
  host.hidden = false;
  list.forEach(s => {
    /* 24.09.2026: підписка має власну будову, див. subsCard. */
    if (s.plans){ subsCard(host, s); return; }
    const h = document.createElement("h2");
    h.className = "cfgset__t";
    h.textContent = s.title;
    host.appendChild(h);
    const hintT = s.hint;
    if (hintT){
      const hint = document.createElement("p");
      hint.className = "cfgset__h";
      hint.textContent = hintT;
      host.appendChild(hint);
    }
    if (s.feats) host.appendChild(featList(s.feats, "cfgcard__f", "cfgcard__fi"));
    /* Примітка слота живе під варіантами: вона стосується того, що вже обрали. */
    const noteOn = typeof s.noteWhen === "function" ? s.noteWhen() : state[s.handle] === s.noteWhen;
    /* Довга розповідь про тариф не вміщається в крок і не потрібна тим, хто вже
       все знає. Тому крок лишається коротким, а деталі живуть окремою сторінкою. */
    host.appendChild(options(s));
    kids(s.handle).forEach(c => host.appendChild(subBlock(c)));
    if (s.note && noteOn) host.appendChild(noteBox(s));
    if (s.foot){
      const f = document.createElement("p");
      f.className = "cfgset__h cfgset__foot";
      f.textContent = val(s.foot);
      host.appendChild(f);
    }
    /* 23.09.2026: посилання «Дізнатися більше» внизу блока, під варіантами,
       як «Що таке Adaptis Amulet?». */
    if (s.more){
      const a = document.createElement("a");
      a.className = "cfgset__more cfgset__more--end";
      a.href = locHref(s.more.href);
      a.textContent = s.more.text;
      host.appendChild(a);
    }
    /* 23.09.2026: «Що таке Adaptis Amulet?» у самому низу блока, під варіантами. */
    if (s.info){
      const b = document.createElement("button");
      b.type = "button";
      b.className = "cfgset__more cfgset__info";
      b.textContent = s.info.cta || ADL("Дізнатися більше");
      b.addEventListener("click", () => openInfo(s.info));
      host.appendChild(b);
    }
  });
}

/* s25 07.10.2026 (власник): готові комплекти на сторінці термінала. До 17.10.2026 лише в тестовому варіанті A/B
   (прапорець window.ADAPTIS_QP від секції adaptis-pdp-intro). s76a 17.10.2026 (власник): тест завершено, комплекти
   показуються завжди, коли в даних сторінки є SIMPLE.quick (Mini, Mini X, MiniKit), без прапорця. Поки лише
   українською, як було в тесті: англійська й польська версії лишаються з повним конструктором. Вимкнути комплекти
   можна галочкою секції adaptis-pdp-intro (вона ставить window.ADAPTIS_QP = false).
   Покупцеві не треба збирати конструктор з нуля: під ціною дві картки, «лише термінал» і готовий комплект
   на авто. Картка лише відповідає на питання конструктора за покупця (SIMPLE.quick.cards[].sp), тож сума,
   склад і кошик рахуються тим самим шляхом, що й при ручному виборі; конструктор нижче лишається і показує,
   що обрано. Ціна на картці: термінал плюс те, що дають ці відповіді. Картка світиться обраною, поки склад
   збігається з нею. Картки звичайні (.card-opt): фото, сірий рядок, ціна. */
/* 08.10.2026 (власник, зустріч з Мірою): у тестовому варіанті зверху лише готові комплекти й Adaptis Amulet.
   Питання конструктора сховані за кнопкою «Зібрати свій комплект» (клас qp-min), підписки в цьому варіанті
   немає (клас qp), кнопка квізу стоїть під «Купити» і в нижній панелі. Комплекти є і на сторінці корпусу. */
let qpOpen = false;
/* s79 17.10.2026 (власник): усюди, де показуємо склад комплекту, стоїть дисклеймер. Той самий текст, що на картці
   «Комплектація» в галереї і під «Що входить». */
function kitDisc(host){
  if ((window.ADAPTIS_LOCALE || "uk") !== "uk") return; /* перекладу поки немає: en і pl без рядка */
  const p = document.createElement("p");
  p.className = "cfgset__disc";
  p.textContent = ADL("Зображення ілюстративні: комплектація і зовнішній вигляд товарів можуть відрізнятися залежно від партії постачання");
  host.appendChild(p);
}
function quickPacks(){
  const Q = SIMPLE_ON && SIMPLE.quick && window.ADAPTIS_QP !== false && (window.ADAPTIS_LOCALE || "uk") === "uk" ? SIMPLE.quick : null;
  const root = el("adaptisCfg");
  let host = el("quickPacks");
  if (!Q){
    if (host) host.remove();
    if (root) root.classList.remove("qp", "qp-min");
    return;
  }
  const buy = document.querySelector("#adaptisCfg .cfg > .sum");
  if (!buy) return;
  if (!host){
    host = document.createElement("section");
    host.className = "card pane cfgset";
    host.id = "quickPacks";
    buy.insertAdjacentElement("afterend", host);
  }
  host.innerHTML = "";
  const h = document.createElement("h2");
  h.className = "cfgset__t";
  h.textContent = Q.title;
  host.appendChild(h);
  const TERM = MODE === "terminal";
  const optOf = (q, v) => SIMPLE[q] && (SIMPLE[q].options || []).find(x => x.h === v);
  /* «У русі» завжди з корпусом (див. spChoose), тож він входить і в ціну картки. */
  const answers = c => Object.assign({}, c.sp, TERM && c.sp.where === "move" && SIMPLE.corpus ? {corpus:"yes"} : {});
  const cost = c => { const a = answers(c); return (TERM ? TERMINAL.price : corpusPrice()) + Object.keys(a).reduce((sum, q) => { const o = a[q] && optOf(q, a[q]); return sum + (o ? spCost(q, o).sum : 0); }, 0); };
  /* 09.10.2026 (власник): у тестовому варіанті великого конструктора немає. Уточнення стоять у самій картці
     комплекту компактним опитуванням (c.ask): питання, рядок коротких кнопок-відповідей і один сірий рядок
     про обрану відповідь з ціною. Питання двох видів: {q, t, o} відповідає на питання простого конструктора
     (живлення, монтаж, дах, павербанк, станція), {step, t, o} на крок сторінки (підписка). Тому сума, склад
     і кошик рахуються тим самим шляхом, що й у конструкторі. o це [[відповідь, коротка назва, пояснення]];
     відповіді, якої немає в наявності, немає і тут. c.steps це кроки, які комплект ставить сам (підписка
     на 3 місяці): картка без c.steps повертає їх до типових. */
  const asksOf = c => (c.ask || []).map(a => {
    const st = a.step ? step(a.step) : null;
    if (a.step ? !st : !SIMPLE[a.q]) return null;
    const list = a.o.map(x => ({h:x[0], t:x[1], d:x[2], o:st ? opt(st, x[0]) : optOf(a.q, x[0])})).filter(x => x.o);
    return list.length > 1 ? {q:a.q, st:st, t:a.t, list:list} : null;
  }).filter(Boolean);
  const stepKeys = [...new Set(Q.cards.reduce((all, c) => all.concat(Object.keys(c.steps || {})), []))];
  /* Ціна на картці це те, що покупець заплатить за комплект: разом із підпискою, яку комплект ставить сам.
     В обраній картці рахуємо за поточними відповідями, у решті за типовими. Тариф підписки залежить від
     відповіді where картки, тому на час підрахунку підставляємо її тариф. Adaptis Amulet у ціну картки не йде. */
  const stepSum = (k, h) => { const st = step(k), o = st && opt(st, h); return o && !noCat(o) ? priceOf(o) : 0; };
  const stepsCost = c => {
    const ks = Object.keys(c.steps || {});
    if (!ks.length) return 0;
    const was = state.subplan, w = "where" in c.sp ? c.sp.where : (SIMPLE.where || {}).def, wo = w && optOf("where", w);
    if (wo && wo.plan && "subplan" in state) state.subplan = wo.plan;
    const sum = ks.reduce((a, k) => a + stepSum(k, c.steps[k]), 0);
    if ("subplan" in state) state.subplan = was;
    return sum;
  };
  const cardPrice = (c, on) => on && TERM ? packTotal(curPack()) + stepKeys.reduce((a, k) => a + stepSum(k, state[k]), 0) : cost(c) + (TERM ? stepsCost(c) : 0);
  const withSteps = (c, on) => !!c.steps && (!on || Object.keys(c.steps).some(k => { const st = step(k); return st && state[k] !== st.def; }));
  /* Відповідь null у картці означає «питання без відповіді» (на сторінці Mini це «де користуватиметесь»). */
  const isOn = c => {
    const a = answers(c);
    /* На сторінці корпусу відповідь це стан кроків (spPicked), і без дотику до першого питання жодна картка не обрана. */
    if (!TERM) return touched.has("sp:lead") && Object.keys(a).every(q => (spPicked(q) || {}).h === a[q]);
    /* Питання, на які покупець відповідає в самій картці, картку не знімають: вона обрана з будь-якою відповіддю. */
    const asked = (c.ask || []).map(x => x.q).filter(Boolean);
    if (!Object.keys(a).filter(q => asked.indexOf(q) < 0).every(q => a[q] === null ? !sp[q] : sp[q] === a[q])) return false;
    return asked.length ? true : packTotal(curPack()) === cost(c);
  };
  /* Картка, по якій клікнули, лишається на тому самому місці екрана: блок питань над нею міг згорнутись. */
  const keep = (sel, fn) => {
    const was = host.querySelector(sel), y0 = was ? was.getBoundingClientRect().top : null;
    fn();
    const now = document.querySelector("#quickPacks " + sel);
    if (now && y0 !== null){ const dy = now.getBoundingClientRect().top - y0; if (Math.abs(dy) > 1) window.scrollBy({top:dy, behavior:"instant"}); }
    return now;
  };
  const apply = c => {
    if (TERM && isOn(c)) return;
    keep('[data-qp="' + c.h + '"]', () => {
      /* рівно цей комплект: решта питань повертається до типових відповідей */
      if (TERM) Object.keys(sp).forEach(q => { if (!(q in c.sp) && SIMPLE[q]) sp[q] = SIMPLE[q].def; });
      Object.keys(c.sp).forEach(q => {
        if (c.sp[q] === null){ sp[q] = null; touched.delete("sp:" + q); }
        else spChoose(q, c.sp[q]);
      });
      stepKeys.forEach(k => {
        const st = step(k);
        if (!st) return;
        const v = (c.steps || {})[k];
        if (v && opt(st, v)){ state[k] = v; touched.add(k); }
        else { state[k] = st.def; touched.delete(k); }
      });
      render();
    });
  };
  /* Покупець прийшов уже зі своєю збіркою (посилання, повернення на сторінку): конструктор одразу відкритий. */
  if (!qpOpen && [...touched].some(k => String(k).indexOf("sp:") === 0) && !Q.cards.some(isOn)) qpOpen = true;
  root.classList.add("qp");
  root.classList.toggle("qp-min", !qpOpen);
  const src = f => /^(https?:)?\/\//.test(f) ? f : im(f, 300);
  const g = document.createElement("div");
  g.className = "list";
  Q.cards.forEach(c => {
    const b = document.createElement("button");
    const on = isOn(c);
    b.type = "button";
    b.className = "card-opt";
    b.setAttribute("data-qp", c.h);
    b.setAttribute("aria-pressed", String(on));
    /* 09.10.2026 (власник): картка комплекту з іконкою (c.icon), а не з фото одного з товарів: фото корпусу
       поруч із фото термінала збивало. Без іконки лишається фото, як на сторінці корпусу. */
    /* 09.10.2026 (власник): на сторінці корпусу три картки мали те саме фото корпусу. c.photo це фото товару,
       яким комплект відрізняється від сусідніх (блок живлення, термінал). */
    const file = c.icon ? null : (val(c.photo) || (c.img === "corpus" || !TERM ? (typeof COLOR_MEDIA === "undefined" ? null : (COLOR_MEDIA[state.color] || [])[0]) : (TERMINAL.img || (typeof MEDIA === "undefined" ? null : MEDIA[0]))));
    b.innerHTML = (c.icon ? '<span class="card__img card__img--ic">' + icon(c.icon, "qp__ic") + '</span>' : file ? '<span class="card__img"><img src="' + src(file) + '" alt="" loading="lazy"></span>' : '') +
      '<span class="card__main"><span class="card__row"><span class="card__t"></span><span class="card__p"></span></span><span class="card__d"></span></span>';
    b.querySelector(".card__t").textContent = c.t;
    b.querySelector(".card__p").textContent = money(cardPrice(c, on) * qtyN());
    b.querySelector(".card__d").textContent = c.dWith && withSteps(c, on) ? c.dWith : c.d;
    b.addEventListener("click", () => apply(c));
    g.appendChild(b);
    /* 09.10.2026 (власник): «Зібрати свій комплект» повернуто й на сторінки терміналів. Коли повний конструктор
       відкрито, короткі питання в картці ховаємо: ті самі питання стоять нижче, двічі їх не показуємо. */
    const asks = on && TERM && !qpOpen ? asksOf(c) : [];
    if (!asks.length) return;
    const box = document.createElement("div");
    box.className = "qpadd";
    /* 09.10.2026 (власник): в обраному комплекті бракувало фото. Над питаннями стоїть справжнє фото того, як це
       виглядає (c.shot: корпус на даху авто, корпус на кондиціонері); клік відкриває його цілим на весь екран. */
    if (c.shot){
      const sh = document.createElement("button");
      sh.type = "button";
      sh.className = "qpshot";
      sh.setAttribute("aria-label", ADL("Фото"));
      sh.innerHTML = '<img src="' + im(c.shot, 900) + '" alt="" loading="lazy">';
      sh.addEventListener("click", () => { if (window.AdaptisUI && window.AdaptisUI.photos) window.AdaptisUI.photos([im(c.shot, 2000)], 0, null, [im(c.shot, 900)]); });
      box.appendChild(sh);
    }
    asks.forEach(a => {
      const key = a.st ? "step:" + a.st.handle : a.q;
      const cur = a.st ? a.list.find(x => x.h === state[a.st.handle]) : a.list.find(x => x.h === sp[a.q]);
      const blk = document.createElement("div");
      blk.className = "qpq";
      const h3 = document.createElement("p");
      h3.className = "qpq__t";
      /* у питанні про підписку поруч із назвою стоїть тариф, який комплект обрав сам */
      h3.textContent = a.t + (a.st && a.st.plan ? ": " + a.st.plan().label : "");
      blk.appendChild(h3);
      const row = document.createElement("div");
      row.className = "seg-row qpq__row";
      a.list.forEach(x => {
        const ch = document.createElement("button");
        ch.type = "button";
        ch.className = "seg qpq__c";
        ch.textContent = x.t;
        ch.setAttribute("aria-pressed", String(!!cur && cur.h === x.h));
        ch.setAttribute("data-qpq", key + ":" + x.h);
        if (!a.st && spBlocked(a.q, x.o)) ch.disabled = true;
        ch.addEventListener("click", () => {
          if (cur && cur.h === x.h) return;
          const now = keep('[data-qpq="' + key + ":" + x.h + '"]', () => {
            if (a.st){ state[a.st.handle] = x.h; touched.add(a.st.handle); }
            else spChoose(a.q, x.h);
            render();
          });
          if (now) now.focus({preventScroll:true});
        });
        row.appendChild(ch);
      });
      blk.appendChild(row);
      if (cur){
        /* один рядок про обрану відповідь: що це і скільки додає до суми */
        const sum = a.st ? priceOf(cur.o) : spCost(a.q, cur.o).sum;
        /* 10.10.2026 (власник): «Оформлю сам» у картці комплекту показує, від скільки коштує Starlink для цього
           сценарію, а не ціну одного тарифу: вдома найдешевший тариф Starlink 30 $ (поле from тарифу), у русі 100 $. */
        const pl = a.st && a.st.plan ? a.st.plan() : null;
        const pt = a.st ? (cur.h === "self" && pl && pl.usd ? ADL("від") + " " + (pl.from || pl.usd).toLocaleString("uk-UA") + " " + ADL("$ / міс") : val(cur.o.priceText)) : null;
        const note = document.createElement("p");
        note.className = "qpq__d";
        const tx = document.createElement("span");
        tx.textContent = cur.d || (a.st ? cur.o.desc : cur.o.d) || "";
        note.appendChild(tx);
        if (sum || pt){
          const pr = document.createElement("b");
          pr.textContent = sum ? (a.q === "mount" ? ADL("від") + " " : "+ ") + money(sum * (a.st ? 1 : qtyN())) : pt;
          note.appendChild(pr);
        }
        blk.appendChild(note);
      }
      box.appendChild(blk);
    });
    g.appendChild(box);
  });
  host.appendChild(g);
  /* s79b 18.10.2026 (власник): біля кнопки «Купити» дисклеймера не треба, рядок прибрано. */
  if (Q.more && !qpOpen){
    const m = document.createElement("button");
    m.type = "button";
    m.className = "cfgset__more cfgset__info";
    m.textContent = Q.more;
    m.addEventListener("click", () => {
      qpOpen = true;
      render();
      const first = [].find.call(document.querySelectorAll("#adaptisCfg .cfg > .cfgset"), x => x.id !== "quickPacks" && x.id !== "amulet" && x.id !== "cover" && x.offsetParent);
      if (first) first.scrollIntoView({behavior:"smooth", block:"start"});
    });
    host.appendChild(m);
  }
  /* 10.10.2026 (власник): на сторінці термінала колір корпусу й «Ціна для Сил Оборони» у блок ціни більше не
     переїжджають (09.10 переносили їх під «Купити»): при виборі комплекту вони з'являлись над комплектами
     й зсували сторінку. Покупець обирає колір і ціну для Сил Оборони в кошику, а з розкритим конструктором
     вони стоять у питанні про корпус, як і раніше. */
  qpQuiz(root, buy);
}
/* Кнопка квізу «Не знаєте, що обрати?»: у блоці ціни під «Купити» і посиланням у нижній панелі. */
function qpQuiz(root, buy){
  const cta = root.querySelector(".quizcta"), row = buy.querySelector(".buyrow");
  if (!cta) return;
  /* 09.10.2026 (власник): перемикач «Ціна для Сил Оборони» стоїть над плашкою квізу. Тому плашку ставимо не одразу
     під «Купити», а під перемикачем ціни й кольором корпусу (вони йдуть у блоці ціни після рядка покупки). */
  const after = [buy.querySelector(":scope > #spCorpusOpts"), el("colorTop"), el("priceMode"), row].find(x => x && x.parentNode === buy);
  if (after && cta.previousElementSibling !== after){ after.insertAdjacentElement("afterend", cta); cta.classList.add("quizcta--in"); }
  /* Нижня панель: кнопка «Швидкий підбір» поруч із «Купити» (власник 08.10). */
  const bar = document.querySelector("#buybar .buybar__in"), buyBar = el("buyBar");
  if (bar && buyBar && !bar.querySelector(".buybar__acts")){
    const acts = document.createElement("div");
    acts.className = "buybar__acts";
    const a = document.createElement("a");
    a.className = "buybar__quick";
    a.href = cta.getAttribute("href");
    a.textContent = ADL("Швидкий підбір");
    buyBar.insertAdjacentElement("beforebegin", acts);
    acts.appendChild(a);
    acts.appendChild(buyBar);
  }
}

/* 24.09.2026, третя редакція. Блок підписки, компактний.
   Тариф списком, під ним одна головна перевага тарифу. Лінія. Далі вибір:
   «Оформлю самостійно» (тариф Starlink сірим, у суму не йде) або строки з
   супроводом Adaptis рядками один під одним, у кожному розрахунок «ціна за
   місяць × місяці». Над строками один рядок: що робимо і з чого ціна.
   «Дізнатися більше про тарифи» в самому низу картки. */
function subsCard(host, s){
  /* 26.09.2026: розмітка спільна з квізом (window.AdaptisUI.subs), тут лише стан і кліки. */
  const box = document.createElement("div");
  box.innerHTML = window.AdaptisUI.subs(s, {cur:s.plan(), money, price:priceOf, icon,
    pressed:h => touched.has(s.handle) && state[s.handle] === h});
  while (box.firstChild) host.appendChild(box.firstChild);
  const sel = host.querySelector("[data-subplansel]");
  if (sel) sel.addEventListener("change", () => { state.subplan = sel.value; render(); });
  host.querySelectorAll("[data-sub]").forEach(b => b.addEventListener("click", () => {
    const o = opt(s, b.getAttribute("data-sub"));
    if (o) pick(s, o);
  }));
  const old = document.getElementById("subsMore");
  if (old) old.remove();
}

/* Примітка з текстовою шапкою: перший рядок називає суть, далі деталі.
   Посилання живе тут, а не в описі опції: опція це кнопка, і вкладене в неї
   посилання і ламало б розмітку, і клікалось би разом з вибором. */
function noteBox(s){
  /* З іконкою примітка малюється рядком характеристики, як у комплектаціях
     і в підписці: фон тільки під іконкою, без плашки на всю ширину. */
  if (s.noteIcon){
    const ul = document.createElement("ul");
    ul.className = "cfgcard__f note--feat";
    const li = document.createElement("li");
    li.innerHTML = icon(s.noteIcon, "cfgcard__fi");
    const t = document.createElement("span");
    t.textContent = s.note;
    if (s.noteLink){
      const a = document.createElement("a");
      a.className = "note__a";
      a.href = locHref(s.noteLink.href);
      a.target = "_blank";
      a.rel = "noopener";
      a.textContent = s.noteLink.text;
      t.appendChild(a);
    }
    li.appendChild(t);
    ul.appendChild(li);
    return ul;
  }
  const n = document.createElement("div");
  n.className = "note";
  if (s.noteHead){
    const h = document.createElement("b");
    h.className = "note__h";
    h.textContent = s.noteHead;
    n.appendChild(h);
  }
  const t = document.createElement("span");
  t.textContent = s.note;
  n.appendChild(t);
  if (s.noteLink){
    const a = document.createElement("a");
    a.className = "note__a";
    a.href = locHref(s.noteLink.href);
    a.target = "_blank";
    a.rel = "noopener";
    a.textContent = s.noteLink.text;
    n.appendChild(a);
  }
  return n;
}

/* Колір стоїть у блоці покупки вгорі: це перше, що питають про корпус,
   і воно не має ховатися за згортанням. */
function colorTop(){
  /* 23.09.2026: на сторінці термінала колір корпусу теж під вибором корпусу. */
  const top = el("colorTop"), inner = el("spCorpusOpts");
  if (inner && top){ top.innerHTML = ""; top.hidden = true; }
  /* Усередині блоку колір стоїть першим, над перемикачем ціни. */
  let host = top;
  if (inner){ host = document.createElement("div"); host.className = "spick__color"; inner.prepend(host); }
  if (!host) return;
  const list = slotSteps("color");
  host.innerHTML = "";
  if (!list.length){ host.hidden = true; return; }
  host.hidden = false;
  list.forEach(s => {
    const l = document.createElement("span");
    l.className = "sub__l";
    const extra = BASE[state.purpose][state.color][1] - BASE[state.purpose][s.options[0].handle][1];
    l.textContent = s.title + ": " + colorTitle() + (extra > 0 ? ", + " + money(extra) : "");
    host.appendChild(l);
    host.appendChild(swatches(s));
    /* Про відсутній у каталозі варіант кольору покупцю не пишемо: це наша
       внутрішня недоробка, а не його проблема. Слід лишається в payload,
       який друкується в консоль. */
    kids(s.handle).forEach(c => {
      host.appendChild(subBlock(c));
      if (c.handle === "paint") paintExtra(host);
    });
  });
}

function stepCard(s){
  const sec = document.createElement("section");
  /* Кроки це просто блоки: без нумерації і без складання. Складання лишалось
     від спроби вкоротити мобільну версію, але воно давало дубльовані заголовки
     і зайвий клік перед кожною відповіддю. Механіка openSteps лишилась у коді,
     бо на ній тримається компенсація зсуву після перемальовування. */
  sec.className = "step";
  sec.dataset.step = s.handle;

  const f = document.createElement("button");
  f.type = "button";
  f.className = "step__fold";
  f.innerHTML = '<span class="step__fk"></span><span class="step__fv"></span>' +
    icon("chevron", "step__ch");
  f.setAttribute("aria-label", (s.short || s.title) + ADL(": змінити"));
  /* Згорнутий рядок називає крок коротко, розгорнутий бере повну назву: у
     розгорнутому стані свій заголовок у тілі кроку сховано, щоб назва не
     стояла двічі. */
  f.querySelector(".step__fk").textContent = openSteps.has(s.handle) ? s.title : (s.short || s.title);
  f.querySelector(".step__fv").textContent = foldValue(s);
  f.addEventListener("click", () => toggleStep(s.handle));
  sec.appendChild(f);

  const body = document.createElement("div");
  body.className = "step__body";
  /* Нумерації «Крок N» більше немає: блоки читаються згори вниз і без неї,
     а порядковий номер плутав, бо частина блоків показується не завжди. */
  body.innerHTML = '<h2 class="step__t"></h2>' + (s.hint ? '<p class="step__h"></p>' : '');
  body.querySelector(".step__t").textContent = s.title;
  if (s.hint) body.querySelector(".step__h").textContent = s.hint;
  const tag = stepTag(s);
  if (tag) body.appendChild(tag);
  body.appendChild(options(s));
  kids(s.handle).forEach(c => body.appendChild(subBlock(c)));
  const noteOn = typeof s.noteWhen === "function" ? s.noteWhen() : state[s.handle] === s.noteWhen;
  if (s.note && noteOn) body.appendChild(noteBox(s));
  const dep = depNote(s);
  if (dep) body.appendChild(dep);
  sec.appendChild(body);
  return sec;
}

/* Звʼязок кроку з готовою комплектацією має бути видимий: інакше незрозуміло,
   чому кроки заповнені і чому картка комплектації перестала бути активною. */
function stepTag(s){
  if (!fromBundle) return null;
  const p = (typeof BUNDLES === "undefined" ? [] : BUNDLES).find(x => x.handle === fromBundle);
  if (!p) return null;
  const own = byBundle.has(s.handle), edited = manual.has(s.handle);
  if (!own && !edited) return null;
  const n = document.createElement("p");
  n.className = "step__tag" + (edited ? " step__tag--edit" : "");
  n.textContent = own ? ADL("з комплектації «") + p.title + "»" : ADL("змінено вручну");
  return n;
}

/* Згорнутий рядок кроку: «адаптер 65W · + 1 925 ₴». */
/* Обране в кроці, разом із підпитаннями. Підпитання може бути й мультивибором,
   тому значення завжди зводимо до списку опцій. */
function picked(s){
  const v = state[s.handle];
  return (Array.isArray(v) ? v : [v])
    .filter(x => x !== null && x !== undefined)
    .map(h => opt(s,h))
    .filter(Boolean);
}
function foldValue(s){
  const parts = picked(s);
  if (!parts.length) return ADL("не вибрано");
  const kidOpts = kids(s.handle).reduce((a,c) => a.concat(picked(c)), []);
  const price = parts.concat(kidOpts).reduce((a,o) => a + priceOf(o), 0);
  const names = parts.concat(kidOpts).map(shortOf).join(", ");
  return names + (price ? " · + " + money(price) : "");
}

function options(s){
  if (s.type === "swatch") return swatches(s);
  if (s.type === "seg") return segs(s);
  return cards(s);
}

/* 24.09.2026: з ціною для Сил Оборони поруч перекреслена цивільна ціна тієї
   самої позиції: корпус, Amulet, набір. Цивільну рахуємо тими самими
   функціями, на мить перемкнувши призначення. */
function civilPrice(fn){
  if (state.purpose !== "defense") return null;
  state.purpose = "civil";
  try { return fn(); } finally { state.purpose = "defense"; }
}
function wasHtml(fn, now){
  const was = civilPrice(fn);
  return was && was > now ? '<s class="card__was">' + money(was) + '</s> ' : '';
}

function cards(s){
  const g = document.createElement("div");
  g.className = "list";
  const multi = s.type === "multi";
  s.options.forEach(o => {
    if (o.hideWhen && o.hideWhen()) return;
    const on = touched.has(s.handle) && (multi ? state[s.handle].includes(o.handle) : state[s.handle] === o.handle);
    const lock = lockReason(o);
    /* 25.09.2026: опція з go:true має фото-посилання на товар (↗ у кутку, як
       у картках корпусу й живлення). Посилання в кнопці ламало б розмітку,
       тому така картка це div з роллю кнопки. */
    const goId = o.go && o.img ? variantOf(o) : null;
    const b = document.createElement(goId ? "div" : "button");
    if (goId){ b.setAttribute("role", "button"); b.tabIndex = lock ? -1 : 0; if (lock) b.setAttribute("aria-disabled", "true"); }
    else b.type = "button";
    b.className = "card-opt";
    b.setAttribute("aria-pressed", String(on));
    if (lock && !goId) b.disabled = true;

    let price;
    if (o.role === "base") price = '<span class="card__p">' + money(BASE[o.handle][state.color][1]) + '</span>';
    /* 26.09.2026: bare: уточнення, а не покупка («Знаю код», «Сталевий дах»):
       ціни праворуч немає зовсім, замість сірого «0 ₴» (рішення власника). */
    else if (val(o.bare)) price = '';
    /* muted: сума, яку покупець платить не нам, а напряму, тому сіра. */
    else if (val(o.priceText)) price = '<span class="card__p' + (o.muted ? ' free' : '') + '">' + val(o.priceText) + '</span>';
    else if (noCat(o)) price = ("<span class=\"card__p free\">" + ADL("за запитом") + "</span>");
    else if (isQuote(o)) price = ("<span class=\"card__p free\">" + ADL("рахується окремо") + "</span>");
    /* from: ціна «від», бо до опції за замовчуванням додається ще щось,
       як Adaptis Amulet до термінала. */
    else if (priceOf(o) && val(o.from)) price = '<span class="card__p">' + wasHtml(() => priceOf(o), priceOf(o)) + (ADL("від") + " ") + money(priceOf(o)) + '</span>';
    else if (priceOf(o)) price = '<span class="card__p">' + wasHtml(() => priceOf(o), priceOf(o)) + '+ ' + money(priceOf(o)) + '</span>';
    else price = '<span class="card__p free">0 ₴</span>';

    /* блок зображення додається тільки якщо фото справді є */
    /* src це власне зображення прототипу, яке не лежить у каталозі Shopify. */
    /* s13z4: imgs, кілька товарів в одному варіанті (Mini X і кабель): фото стопкою, як у живленні. */
    const thumb = o.imgs ? stackHtml(val(o.imgs))
      : o.src ? '<span class="card__img card__img--full"><img src="' + o.src + '" alt="" loading="lazy"></span>'
      : goId ? '<a class="card__img spick__im--ln" href="' + cartRoot() + 'variants/' + goId + ("\" target=\"_blank\" rel=\"noopener\" title=\"" + ADL("Відкрити товар у новій вкладці").replace(/"/g, "&quot;") + "\" aria-label=\"" + ADL("Відкрити товар у новій вкладці").replace(/"/g, "&quot;") + "\"><img src=\"") + im(o.img, 300) + '" alt="" loading="lazy"><span class="spick__go" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8 16L16 8M9 8h7v7"/></svg></span></a>'
      : o.img ? '<span class="card__img"><img src="' + im(o.img, 300) + '" alt="" loading="lazy"></span>' : '';

    b.innerHTML = thumb +
      '<span class="card__main">' +
        '<span class="card__row"><span class="card__t"></span>' + price + '</span>' +
        (o.desc ? '<span class="card__d"></span>' : '') +
        /* 22.09.2026: застереження окремим рядком чорним текстом, без іконки. */
        (o.warn ? '<span class="card__w"></span>' : '') +
        (o.feats ? '<span class="card__f"></span>' : '') +
        (o.badge ? '<span class="pill pill--hit"></span>' : '') +
        (lock ? '<span class="pill pill--oos"></span>' : '') +
        ((isQuote(o) || noCat(o)) ? ("<span class=\"pill pill--quote\">" + ADL("ціна за запитом") + "</span>") : '') +
      '</span>';
    b.querySelector(".card__t").textContent = o.title;
    if (o.badge) b.querySelector(".pill--hit").textContent = o.badge;
    /* 24.09.2026, ніч: пігулка «немає в наявності» малювалась порожньою. */
    if (lock) b.querySelector(".pill--oos").textContent = lock;
    if (o.desc) b.querySelector(".card__d").textContent = o.desc;
    /* 26.09.2026: accent синім окремим рядком під описом (Adaptis Amulet). */
    if (o.desc && o.accent){ const a = document.createElement("span"); a.className = "card__acc"; a.textContent = o.accent; b.querySelector(".card__d").appendChild(a); }
    if (o.warn) b.querySelector(".card__w").textContent = o.warn;
    if (o.feats){
      const host = b.querySelector(".card__f");
      o.feats.forEach(f => {
        const row = document.createElement("span");
        row.innerHTML = icon(f.i, "card__fi");
        const t = document.createElement("span");
        t.textContent = f.t;
        row.appendChild(t);
        host.appendChild(row);
      });
    }
    b.addEventListener("click", e => {
      if (goId && (lock || e.target.closest(".spick__im--ln"))) return;
      pick(s, o);
    });
    if (goId) b.addEventListener("keydown", e => { if (!lock && (e.key === "Enter" || e.key === " ")){ e.preventDefault(); pick(s, o); } });
    g.appendChild(b);
    /* 24.09.2026: pick: під обраним варіантом список з прихованого кроку
       (довжина кабелю). Ціна й товар варіанта беруться з цього вибору. */
    if (o.pick && on) g.appendChild(pickSelect(step(o.pick)));
  });
  return g;
}
/* 26.09.2026: довжина кабелю картками «довжина + ціна» під розділювачем,
   а не випадним списком: вибір і ціну видно одразу. */
function pickSelect(ps){
  const w = document.createElement("div");
  w.className = "pick pick--cards";
  if (!ps) return w;
  const l = document.createElement("span");
  l.className = "pick__l";
  l.textContent = ps.title;
  const g = document.createElement("div");
  g.className = "pick__g";
  g.setAttribute("role", "group");
  g.setAttribute("aria-label", ps.title);
  ps.options.forEach(x => {
    const b = document.createElement("button");
    b.type = "button";
    b.className = "seg seg--card";
    b.setAttribute("aria-pressed", String(state[ps.handle] === x.handle));
    const t = document.createElement("span");
    t.className = "seg__t";
    t.textContent = x.title;
    b.appendChild(t);
    if (x.len){
      const pr = document.createElement("span");
      pr.className = "seg__p";
      pr.textContent = money(x.len);
      b.appendChild(pr);
    }
    b.addEventListener("click", () => { state[ps.handle] = x.handle; render(); });
    g.appendChild(b);
  });
  w.appendChild(l);
  w.appendChild(g);
  return w;
}

/* Підпитання всередині кроку: компактні пігулки, щоб не додавати скролу. */
function subBlock(s){
  const w = document.createElement("div");
  w.className = "sub";
  const l = document.createElement("span");
  l.className = "sub__l";
  l.textContent = s.title;
  w.appendChild(l);
  if (s.hint){
    const h = document.createElement("p");
    h.className = "sub__h";
    h.textContent = s.hint;
    w.appendChild(h);
  }
  w.appendChild(options(s));
  return w;
}

function segs(s){
  const g = document.createElement("div");
  g.className = "seg-row";
  s.options.forEach(o => {
    const b = document.createElement("button");
    b.type = "button";
    b.className = "seg";
    b.setAttribute("aria-pressed", String(touched.has(s.handle) && state[s.handle] === o.handle));
    b.innerHTML = '<span></span>';
    b.querySelector("span").textContent = o.title;
    if (isQuote(o)) b.appendChild(tag(ADL("рахується окремо")));
    else if (priceOf(o)) b.appendChild(tag(money(priceOf(o))));
    b.addEventListener("click", () => { pick(s, o); });
    g.appendChild(b);
  });
  return g;
}
function tag(t){
  const s = document.createElement("b");
  s.textContent = t;
  return s;
}

function pick(s, o){
  const before = STEPS.map(x => JSON.stringify(state[x.handle]));
  touched.add(s.handle);
  if (s.type === "multi"){
    const a = state[s.handle], i = a.indexOf(o.handle);
    if (i > -1){
      a.splice(i,1);
    } else a.push(o.handle);
  } else {
    state[s.handle] = o.handle;
    if (s.handle === "paint" && o.handle === "unknown") paintCode = "";
    if (s.handle === "terminal") slide = 0;
  }
  /* Відповідь на одне питання може змінити стан іншого кроку: дах не сталевий
     означає, що без пластин магнітам нема за що триматися, і ціна на екрані
     має це показувати одразу, а не після дзвінка менеджера. */
  if (o.effect){
    o.effect();
  }
  /* Кроки, які змінились разом із цим вибором (пластини від даху), теж
     показуємо обраними. */
  STEPS.forEach((x, i) => { if (JSON.stringify(state[x.handle]) !== before[i]) touched.add(x.handle); });
  /* Крок, який покупець змінив сам, більше не належить комплектації. */
  const h = s.parent || s.handle;
  if (fromBundle && byBundle.has(h)){ byBundle.delete(h); manual.add(h); }
  /* Вибрали, крок згортається назад у рядок. Підпитання лишають крок відкритим. */
  if (!s.parent) openSteps.delete(h);
  reRender(h);
}

/* R12: павербанк заряджається від бортової мережі, тому без живлення від авто
   він працює один раз і все. Не блокуємо вибір, а кажемо прямо. */
function depNote(s){
  const v = state[s.handle];
  const o = v && !Array.isArray(v) ? opt(s, v) : null;
  if (!o || !o.needs) return null;
  const dep = step(o.needs.step);
  if (!dep || o.needs.any.indexOf(state[dep.handle]) > -1) return null;
  const n = document.createElement("div");
  n.className = "note note--row";
  const t = document.createElement("span");
  t.textContent = o.needs.text;
  const b = document.createElement("button");
  b.type = "button";
  b.className = "note__x";
  b.textContent = ADL("Обрати живлення");
  b.addEventListener("click", () => { openSteps.add(dep.handle); reRender(dep.handle); });
  n.appendChild(t);
  n.appendChild(b);
  return n;
}

/* ---------- згорнуті блоки: колір і аксесуари ---------- */
function paintExtra(host){
  if (state.paint === "known"){
    const f = document.createElement("div");
    f.className = "field";
    /* s13z25: удома «свій колір», а не колір кузова. */
    const homeP = SIMPLE_ON && sp.where === "home";
    f.innerHTML = ("<label for=\"paintCode\">" + (homeP ? ADL("Код або назва кольору") : ADL("Код або назва кольору кузова")) + "</label>") +
      /* 24.09.2026: приклад короткий, щоб не обрізався на телефоні. Де шукати
         код, уже сказано над варіантами, тому підказки під полем немає. */
      ("<input id=\"paintCode\" type=\"text\" placeholder=\"" + (homeP ? ADL("Напр. RAL 7016") : ADL("Напр. LC9X або RAL 6014")).replace(/"/g, "&quot;") + "\" autocomplete=\"off\">");
    const inp = f.querySelector("input");
    inp.value = paintCode;
    inp.addEventListener("input", e => { paintCode = e.target.value; paint(); });
    host.appendChild(f);
  } else if (state.paint === "unknown"){
    const n = document.createElement("div");
    n.className = "note";
    n.textContent = ADL("Добре, менеджер відділу продажів уточнить код кольору з вами при підтвердженні замовлення. На вартість це не впливає.");
    host.appendChild(n);
  }
}

function swatches(s){
  const g = document.createElement("div");
  g.className = "sw-row";
  const from = BASE[state.purpose][s.options[0].handle][1];
  s.options.forEach(o => {
    if (o.hideWhen && o.hideWhen()) return;
    const b = document.createElement("button");
    b.type = "button";
    b.className = "sw";
    b.setAttribute("aria-pressed", String(state.color === o.handle));
    const extra = BASE[state.purpose][o.handle][1] - from;
    /* Тільки кола: назва обраного кольору і доплата стоять у підписі блоку,
       як на adaptis.com. Так шість кольорів вміщаються в один рядок. */
    b.title = o.title + (extra ? ", + " + money(extra) : "");
    b.setAttribute("aria-label", b.title);
    b.innerHTML = '<span class="sw__c' + (o.hex.indexOf("gradient") > -1 ? " sw__c--grad" : "") +
      '" style="background:' + o.hex + '"></span>';
    b.addEventListener("click", () => {
      state.color = o.handle; slide = 0;
      if (o.handle !== "custom" && "paint" in state){ state.paint = null; paintCode = ""; }
      render();
    });
    g.appendChild(b);
  });
  return g;
}

/* ---------- галерея ---------- */
/* Набір фотографій не змінюється від вибору опцій: додавати й прибирати
   картинки посеред конфігурування збиває. Змінює галерею тільки колір. */
/* 26.09.2026 (власник): на сторінці Amulet галерея лишається фото Amulet, а не
   фото терміналу, який обрали: товар на сторінці не «підміняється». */
const AMULET_MEDIA = ((window.ADAPTIS_ASSETS || {}).media || []).filter(Boolean);
function slides(){
  if (AMULET_MODE && AMULET_MEDIA.length) return AMULET_MEDIA;
  if (MODE === "terminal") return MEDIA;
  const cm = COLOR_MEDIA[state.color] || COLOR_MEDIA[step("color").options[0].handle];
  /* s13r: фото товару з Shopify у його порядку, першим фото обраного кольору. Без них (стара
     сторінка, інший шаблон) лишається список з даних. */
  if (PMEDIA.length){
    const nm = f => String(f || "").split("?")[0];
    const first = cm && cm[0];
    /* 07.10.2026: коли галерею зібрано в темі (mediaLock), фото інших кольорів у стрічку не
       йдуть: першим стоїть обраний колір, далі картки товару. */
    const other = (window.ADAPTIS_ASSETS || {}).mediaLock
      ? Object.keys(COLOR_MEDIA).map(c => nm((COLOR_MEDIA[c] || [])[0])).filter(Boolean) : [];
    return first ? [first].concat(PMEDIA.filter(f => nm(f) !== nm(first) && other.indexOf(nm(f)) < 0)) : PMEDIA.slice();
  }
  return cm.concat(LIFESTYLE);
}

/* 23.09.2026, вечір: галерея це стрічка всіх фото, яку гортає сам браузер
   (scroll-snap): з інерцією, прилипанням до кадру і без перезавантаження.
   Раніше одне фото міняло адресу на кожен свайп, і поки нове вантажилось,
   на його місці блимала порожнеча. Стрічку, крапки й мініатюри будуємо, лише
   коли змінюється набір фото (колір корпусу); перемальовування конструктора
   тільки перемикає активну. Серверне перше фото (#stage) лежить під стрічкою,
   поки її перше фото не завантажиться. */
let galKey = "", galTrack = null, galT = 0, galN = 0;
/* Зациклення: по краях стрічки копії останнього і першого фото. Коли стрічка
   зупинилась на копії, непомітно переставляємо її на справжнє фото. Позиція
   raw це кадр у стрічці разом із копіями, slide це номер фото. */
const galLoop = () => galN > 1;
/* 24.09.2026: ширина кадру дробова (наприклад 565,8 px), а clientWidth ціла,
   тому кадр зсувався і з краю визирало сусіднє фото. Беремо точну ширину. */
function galW(){ return galTrack ? Math.max(1, galTrack.getBoundingClientRect().width) : 1; }
function galRaw(i){ return galLoop() ? i + 1 : i; }
function galMark(){
  const dots = el("galDots").children, th = el("thumbs").children;
  for (let i = 0; i < dots.length; i++) dots[i].classList.toggle("is-on", i === slide);
  for (let i = 0; i < th.length; i++){
    const on = String(i === slide);
    if (th[i].getAttribute("aria-pressed") !== on) th[i].setAttribute("aria-pressed", on);
  }
}
function galTo(raw, smooth){
  if (galTrack) galTrack.scrollTo({left:raw * galW(), behavior:smooth ? "smooth" : "instant"});
}
function galGo(i, smooth){
  slide = i;
  galMark();
  galTo(galRaw(i), smooth);
}
function galSettle(){
  if (!galTrack) return;
  const raw = Math.round(galTrack.scrollLeft / galW());
  let i = raw;
  if (galLoop()){
    if (raw <= 0){ i = galN - 1; galTo(galN, false); }
    else if (raw >= galN + 1){ i = 0; galTo(1, false); }
    else i = raw - 1;
  }
  if (i !== slide && i >= 0 && i < galN){ slide = i; galMark(); }
}
function galTrackInit(){
  const stage = document.querySelector(".gal__stage");
  if (!stage) return;
  galTrack = document.createElement("div");
  galTrack.className = "gal__track";
  stage.insertBefore(galTrack, stage.firstChild);
  /* Покупець гортає сам: коли стрічка зупинилась, кадр під нею і є активний. */
  galTrack.addEventListener("scroll", () => {
    clearTimeout(galT);
    galT = setTimeout(galSettle, 90);
  }, {passive:true});
  if ("onscrollend" in window) galTrack.addEventListener("scrollend", () => { clearTimeout(galT); galSettle(); });
  /* 09.10.2026: клік по фото відкриває його на весь екран (galZoom), на будь-якій ширині екрана. */
  galTrack.addEventListener("click", e => { if (e.target.tagName === "IMG") galZoom(slide); });
  /* 26.09.2026: кадр вирівнюємо лише, коли змінилась ширина стрічки. Safari на
     iPad шле resize під час прокрутки сторінки (ховає панелі), і стрічка фото
     щоразу перескакувала на місце: галерея тремтіла. */
  let galLastW = 0;
  const galRealign = () => {
    if (!live()) return;
    const w = galTrack.clientWidth;
    if (!w || w === galLastW) return;
    galLastW = w;
    galTo(galRaw(slide), false);
  };
  window.addEventListener("resize", galRealign);
  /* Ширина стрічки міняється й без resize вікна (зʼявилась смуга прокрутки,
     довантажився шрифт): вирівнюємо кадр і тоді. */
  if (window.ResizeObserver) new ResizeObserver(galRealign).observe(galTrack);
}
function gallery(){
  const list = slides();
  if (slide >= list.length) slide = 0;
  if (!galTrack) galTrackInit();
  const key = list.join("|");
  if (key !== galKey){
    galKey = key;
    galN = list.length;
    /* 26.09.2026: одне фото: без стрілок, крапок і мініатюр (CSS .gal--one). */
    const galBox = document.querySelector("#adaptisCfg .gal");
    if (galBox) galBox.classList.toggle("gal--one", galN < 2);
    const main = el("stage");
    if (galTrack){
      galTrack.innerHTML = "";
      const add = (f, first, clone) => {
        const img = document.createElement("img");
        img.width = 900; img.height = 900;
        img.alt = first && main ? main.alt : "";
        img.draggable = false;
        img.decoding = "async";
        if (clone) img.setAttribute("aria-hidden", "true");
        if (first){
          img.setAttribute("fetchpriority", "high");
          img.addEventListener("load", () => { galTrack.classList.add("is-ready"); }, {once:true});
        } else img.loading = "lazy";
        img.src = im(f, 900);
        /* s61 13.10.2026 (власник): на екранах Retina фото в галереї було нерізке: просили 900 px, а показували
           на 1130 px і більше. Тепер браузер сам бере 1400 чи 2000 px, коли екран цього потребує; телефон
           лишається на 900 px (sizes 300px), щоб не качати зайвого. */
        const s9 = im(f, 900), s14 = im(f, 1400), s20 = im(f, 2000);
        if (s9 !== s20){ img.srcset = s9 + " 900w, " + s14 + " 1400w, " + s20 + " 2000w"; img.sizes = "(min-width: 990px) 40vw, 300px"; }
        galTrack.appendChild(img);
      };
      if (galLoop()) add(list[list.length - 1], false, true);
      list.forEach((f, i) => add(f, i === 0, false));
      if (galLoop()) add(list[0], false, true);
    } else if (main) main.src = im(list[slide], 900);

    const dots = el("galDots");
    dots.innerHTML = "";
    list.forEach((f, i) => {
      const b = document.createElement("button");
      b.type = "button";
      b.className = "gdot";
      b.setAttribute("aria-label", (ADL("Фото") + " ") + (i + 1));
      b.addEventListener("click", () => galGo(i, true));
      dots.appendChild(b);
    });

    const t = el("thumbs");
    t.innerHTML = "";
    list.forEach((f, i) => {
      const b = document.createElement("button");
      b.type = "button"; b.className = "gth";
      b.setAttribute("aria-pressed", "false");
      b.innerHTML = '<img src="' + im(f, 200) + '" alt="" loading="lazy">';
      b.addEventListener("click", () => galGo(i, true));
      t.appendChild(b);
    });
    galTo(galRaw(slide), false);
  } else if (galTrack && Math.round(galTrack.scrollLeft / galW()) !== galRaw(slide)){
    /* Хтось скинув кадр (зміна комплектації): переходимо без анімації. */
    galTo(galRaw(slide), false);
  }
  galMark();
}

/* Стрілки гортають по колу: з останнього фото вперед на копію першого, далі
   galSettle переставляє на справжнє. */
function shift(d){
  const n = slides().length;
  if (!galTrack || !galLoop()){ galGo((slide + d + n) % n, true); return; }
  const next = (slide + d + n) % n;
  slide = next;
  galMark();
  galTo(galRaw(next) + (d > 0 && next === 0 ? n : d < 0 && next === n - 1 ? -n : 0), true);
}
el("galPrev").addEventListener("click", () => shift(-1));
el("galNext").addEventListener("click", () => shift(1));
/* Свайп тепер нативний: стрічку гортає браузер, вертикальний рух лишається
   сторінці. Окремий обробник дотиків не потрібен. */

/* 09.10.2026 (власник): клік по фото галереї відкриває його на весь екран (спільне вікно AdaptisUI.photos,
   те саме на сторінках товарів без конструктора): на нових картках товару дрібний текст, у колонці його
   не прочитати. Галерея під вікном лишається на тому самому фото. */
function galZoom(start){
  const list = slides();
  if (!list.length || !window.AdaptisUI || !window.AdaptisUI.photos) return;
  window.AdaptisUI.photos(list.map(f => im(f, 2000)), start, i => galGo(i, false), list.map(f => im(f, 900)));
}

/* ---------- підсумок ---------- */
/* Усе, що піде в кошик окремими позиціями, крім базового товару. */
function chosen(){
  const out = [];
  const ak = MODE === "terminal" ? null : activeKit();
  STEPS.forEach(s => {
    if (s.handle === "color") return;
    if (ak && ak.k.covers.indexOf(s.handle) > -1) return;
    if (!vis(s)) return;
    const v = state[s.handle];
    if (v === null || v === undefined) return;
    (Array.isArray(v) ? v : [v]).forEach(h => {
      const o = opt(s,h);
      if (o && !lockReason(o)) out.push({s,o});
    });
  });
  return out;
}

function paint(){
  gallery();
  const mg = amuletMerge(baseRows(), chosen());
  const sel = mg.sel;
  const quote = sel.some(x => isQuote(x.o));
  const rows = mg.rows;
  /* У суму йде тільки те, що справді поїде в кошик. Позиція без товару
     в каталозі лишається на екрані, але рахується як «за запитом». */
  let sum = rows.reduce((a,r) => a + (r.variant ? r.price : 0), 0);
  sel.forEach(({o}) => { if (!noCat(o)) sum += priceOf(o); });

  /* У список ідуть і позиції, і те, що має ціну, але окремого товару в каталозі
     не має: інакше сума не збігалася б із переліком під нею. */
  const items = rows.concat(sel.filter(x => variantOf(x.o) || priceOf(x.o))
    .map(({o}) => ({t:val(o.sumT) || o.title, short:val(o.sumT) || shortOf(o),
                    price:priceOf(o), variant:variantOf(o), quote:noCat(o)})));
  /* Кількість комплектів множить суму, а не кожну ціну на екрані. */
  const unitSum = sum;
  sum = unitSum * qtyN();
  setText("qtyN", String(qtyN()));
  document.querySelectorAll("[data-qd]").forEach(b => {
    b.disabled = (+b.dataset.qd < 0 && qtyN() <= 1) || (+b.dataset.qd > 0 && qtyN() >= QTY_MAX);
  });
  rows.forEach(r => { if (!r.variant) r.quote = true; });

  const t = labels(sum, quote, items);
  /* Коли базової позиції ще немає в каталозі, сума виходить нульова, і «0 ₴»
     читалося б як «безкоштовно». Тут чесніше сказати прямо. */
  const priceText = (sum === 0 && items.some(i => i.quote))
    ? ADL("Ціна за запитом")
    : t.pre + money(sum);
  setText("totVal", priceText);
  /* 24.09.2026: «від … ₴ на місяць» для оплати частинами monobank (до 3
     платежів). Суму ділимо на 3 і округлюємо вгору до гривні. */
  const parts = sum > 0 ? (ADL("До 3 платежів, від") + " ") + money(Math.ceil(sum / 300) * 100) + (" " + ADL("на місяць")) : ADL("До 3 платежів");
  document.querySelectorAll("[data-parts]").forEach(n => { if (n.textContent !== parts) n.textContent = parts; });
  /* 21.09.2026: під ціною лише «Ціна вказана з ПДВ». Позиції за запитом
     менеджер бачить в атрибуті замовлення, покупцю окремий рядок не потрібен. */
  setText("totNote", t.note);
  /* 21.09.2026: «Ціна вказана з ПДВ» прибрано, рядок лишається тільки для
     справжнього застереження, як-от виїзний монтаж. */
  if (el("totNote")) el("totNote").hidden = t.note === DELIVERY;
  saveLine(rows, sum);
  oldPrice(rows, sum);

  /* Про варіант, якого немає в каталозі, покупцю не пишемо: це наша внутрішня
     недоробка. Слід лишається в payload, який друкується в консоль, і в
     docs/catalog-reference.md. */
  [el("buy"), el("buyBar")].forEach(b => {
    if (!b) return;
    b.textContent = t.cta;
    b.classList.toggle("buy--quote", t.dark);
    b.classList.remove("buy--wait");
  });
  setText("barVal", priceText);
  /* 28.09.2026 (власник): у панелі не перелік усього обраного (повний MiniKit
     давав 270 знаків, видно було півтори позиції і «…»), а головна позиція
     і скільки ще до неї. Склад лишається в блоці покупки й у кошику. */
  const more = items.length - 1;
  setText("barCfg", (qtyN() > 1 ? qtyN() + " × " : "") + (items[0] ? String(items[0].short).split(", ")[0] : "") +
    (more > 0 ? " " + ADL("і ще") + " " + goodsN(more) : ""));
  payload(sel, rows, sum);
  syncBuyLabel(t.cta);
}

/* Базові позиції: корпус на сторінці адаптації, термінал і комплектація
   на сторінці термінала. */
function baseRows(){
  if (MODE === "terminal") return packRows();
  const props = {"Колір":colorTitle(), "Призначення":purposeTitle()[state.purpose]};
  /* Тип даху не окрема позиція в кошику, але менеджеру він потрібен: від нього
     залежить і монтаж, і пластини. */
  const rf = step("roof");
  if (rf && state.roof) props["Дах авто"] = shortOf(opt(rf, state.roof));
  /* 26.09.2026: і спосіб встановлення, зокрема самостійно (власник). */
  const mt = step("montage");
  if (mt && state.montage && opt(mt, state.montage)) props["Встановлення"] = shortOf(opt(mt, state.montage));
  if (roofUnknown()) props["Модель авто"] = carModel.trim() || "уточнити з менеджером";
  /* 09.10.2026 (власник): відповідь «Starlink у мене вже є» їде з корпусом у кошик: вікно «Додано в
     кошик» і кошик тоді не радять докупити термінал (AdaptisRecsCore читає «свій»). */
  if ("terminal" in state && state.terminal === "own") props["Starlink"] = "уже є свій";
  if (state.color === "custom")
    props["Код кольору кузова"] =
      state.paint === "known" ? (paintCode.trim() || "не вказано") : "уточнити з менеджером";
  const ak = activeKit();
  if (ak) return [{t:ak.k.short + ", " + colorTitle(), short:ak.k.short + ", " + colorTitle(),
                   cat:ak.k.parts + ", " + PURPOSE_NOTE[state.purpose],
                   price:kitPrice(ak.k), variant:kitVariant(ak.k), props:props,
                   loose:loosePrice(ak.k)}];
  return [{t:baseTitle() + ", " + colorTitle(), short:baseShort() + ", " + colorTitle(),
           cat:PURPOSE_NOTE[state.purpose], price:corpusPrice(), variant:corpusVariant(), props:props}];
}

/* Стара ціна термінала показується тільки тоді, коли купують сам термінал:
   до неї не додано нічого, тому порівняння чесне. */
function oldPrice(rows, sum){
  const o = el("totOld"), off = el("totOff");
  if (!o || !off) return;
  /* 21.09.2026: знижка на термінал лишається, що б покупець не додав.
     Термінал є в кожному замовленні цієї сторінки, тому стара ціна це сума
     плюс та сама різниця, а вигода не змінюється. */
  let save = MODE === "terminal" && TERMINAL.compare ? (TERMINAL.compare - TERMINAL.price) * qtyN() : 0;
  /* 28.09.2026 (власник): на сторінках конструктора стара ціна корпусу чи
     набору з Shopify, як у списку товарів. Корпус або набір є в кожному
     замовленні сторінки, тому, як і з терміналом, знижка лишається при
     будь-якому виборі. */
  if (MODE !== "terminal" && rows[0] && rows[0].variant && window.AdaptisStock && AdaptisStock.compareOf){
    const c = AdaptisStock.compareOf(rows[0].variant);
    if (c > rows[0].price) save = c - rows[0].price;
  }
  const show = save > 0 && sum > 0;
  /* 23.09.2026, вечір: рядка «вигода» немає. Стара й нова ціна стоять поруч,
     різницю видно й так, а рядок то вміщувався поруч, то падав на новий
     рядок, і блок покупки стрибав на кожен вибір. */
  o.hidden = !show; off.hidden = true;
  if (show) o.textContent = money(sum + save);
}

/* Рядок вигоди: скільки коштувала б та сама збірка окремими товарами. */
function saveLine(rows, sum){
  const host = el("totSave");
  if (!host) return;
  const base = rows[0] || {};
  /* Рядка про вигоду набору тут більше немає: у каталозі знижки на набори
     зараз немає, тому й показувати нічого. Механізм лишається, бо коли знижки
     вирівняють, рядок повернеться одним рядком коду. */
  host.hidden = true;
}

const DELIVERY = ADL("Ціна вказана з ПДВ");

/* Назва того, що зараз у кошику: готова комплектація або своя збірка. */

function labels(sum, quote, items){
  if (MODE === "terminal") return {
    pre:"", dark:false, note:DELIVERY, cta:ADL("Купити")
  };
  return {
    pre:   quote ? (ADL("від") + " ") : "",
    note:  quote
      ? ADL("Вартість виїзного монтажу менеджер узгодить окремо.")
      : DELIVERY,
    cta:   quote ? ADL("Надіслати запит менеджеру") : ADL("Купити"),
    dark:  quote
  };
}

/* ---------- payload ---------- */
/* Кожен компонент лишається окремою позицією з власним variant ID,
   компоненти одного комплекту звʼязані властивістю _bundle_id. */
let cart = {items:[], attributes:{}, quote:[]};

/* Кожен компонент лишається окремою позицією з власним variant ID,
   компоненти одного комплекту звʼязані властивістю _bundle_id.
   Прототип друкував цей payload у консоль. У темі він іде в /cart/add.js. */
/* 25.09.2026: без властивостей _bundle_* і без «Колір» / «Призначення» (їх
   уже задає варіант товару). Властивості робили той самий товар окремим
   рядком кошика: Starlink, доданий раніше, і два нових лягали двома рядками
   замість одного з кількістю 3. Лишаються тільки ті, що кажуть менеджеру
   щось, чого немає у варіанті (наприклад, «Модифікація» для Amulet). */
const LINE_DROP = ["Колір", "Призначення"];
function lineProps(p){
  const out = {};
  Object.keys(p || {}).forEach(k => { if (k.charAt(0) !== "_" && LINE_DROP.indexOf(k) < 0 && p[k]) out[k] = p[k]; });
  return Object.keys(out).length ? out : null;
}
function lineItem(id, quantity, p){
  const it = {id:id, quantity:quantity}, lp = lineProps(p);
  if (lp) it.properties = lp;
  return it;
}
/* 26.09.2026: термінал + Adaptis Amulet однією позицією (window.AdaptisAmuletKit).
   Термінал буває рядком сторінки термінала або варіантом першого питання
   сторінки корпусу. Ціна та сама: товар коштує рівно як термінал і послуга. */
function amuletMerge(rows, sel){
  const K = window.AdaptisAmuletKit;
  if (!K) return {rows, sel};
  const ai = sel.findIndex(x => x.s && x.s.handle === "amulet" && K.isSvc(variantOf(x.o)));
  if (ai < 0) return {rows, sel};
  const def = state.purpose === "defense";
  const ri = rows.findIndex(r => K.model(r.variant));
  if (ri > -1){
    const m = K.model(rows[ri].variant), k = K.kit(m, def);
    if (!k) return {rows, sel};
    const r = Object.assign({}, rows[ri], {t:K.name(m), short:K.name(m), price:k.price, variant:k.id});
    return {rows:rows.map((x, i) => i === ri ? r : x), sel:sel.filter((x, i) => i !== ai)};
  }
  const ti = sel.findIndex(x => K.model(variantOf(x.o)));
  if (ti < 0) return {rows, sel};
  const o0 = sel[ti].o, m = K.model(variantOf(o0)), k = K.kit(m, def);
  if (!k) return {rows, sel};
  const o = {handle:o0.handle, title:K.name(m), short:shortOf(o0), sumT:K.name(m), price:k.price, variant:k.id, role:"component", img:o0.img, src:o0.src};
  return {rows, sel:sel.map((x, i) => i === ti ? {s:x.s, o:o} : x).filter((x, i) => i !== ai)};
}

function payload(sel, rows, sum){
  const n = qtyN();
  const items = rows.filter(r => r.variant).map(r => lineItem(r.variant, n, r.props));
  sel.forEach(({s,o}) => {
    const vid = variantOf(o);
    if (!vid) return;
    /* Опція може додати свої властивості позиції: наприклад, Amulet каже
       менеджеру, що модифікуємо термінал покупця, а не той, що в замовленні. */
    items.push(lineItem(vid, (o.qty || 1) * n, val(o.props)));
  });

  /* Послуга без окремого товару їде атрибутом замовлення: у кошику вона не
     позиція, але менеджер її бачить. */
  const attrs = {};
  sel.forEach(({o}) => { if (o.attr) attrs[o.attr] = "true"; });
  /* 24.09.2026: на сторінці термінала з монтажем менеджеру потрібен тип даху.
     Порожнє значення прибирає атрибут, коли монтажу вже немає. */
  if (MODE === "terminal" && SIMPLE_ON && SIMPLE.roof){
    /* 26.09.2026: і при самостійному встановленні (власник). */
    const withMount = sp.where !== "home" && sp.corpus === "yes";
    attrs["Дах авто"] = withMount ? ((SIMPLE.roof.options.find(o => o.h === sp.roof) || {}).t || "") : "";
    attrs["Модель авто"] = withMount && roofUnknown() ? (carModel.trim() || "уточнити з менеджером") : "";
  }

  /* Те, що має ціну, але ще не має товару в каталозі. У суму не входить,
     тому менеджер має побачити це в замовленні окремим рядком. */
  const quote = [];
  rows.forEach(r => { if (!r.variant) quote.push(r.t); });
  sel.forEach(({o}) => { if (noCat(o)) quote.push(val(o.sumT) || o.title); });
  /* Порожнє значення прибирає атрибут із кошика: інакше запис лишався від
     попередньої збірки, коли в новій таких позицій уже немає. */
  attrs["Позиції за запитом"] = quote.join("; ");

  /* 26.09.2026: чекаут Chekly не переносить атрибути кошика в замовлення, а
     властивості позицій переносить. Тому те, що потрібно менеджеру, ще й
     властивостями першої позиції. Назви українською: це дані для менеджера. */
  const ATTR_T = {mobile_install:"Виїзний монтаж", electric_help:"Допомога з електромонтажем"};
  const pin = {};
  Object.keys(attrs).forEach(k => {
    if (!attrs[k]) return;
    pin[ATTR_T[k] || k] = ATTR_T[k] ? "так, узгодити з менеджером" : attrs[k];
  });
  if (items.length && Object.keys(pin).length)
    items[0] = Object.assign({}, items[0], {properties:Object.assign({}, items[0].properties || {}, pin)});

  /* 28.09.2026: що саме додаємо, для вікна «Додано в кошик», яке зʼявляється
     ще до відповіді Shopify: назва, фото (те, що вже на сторінці), сума. */
  /* Розміри ті самі, що в мініатюрах галереї (200) і картках опцій (300). */
  const shot = (f, w) => f ? im(f, w) : "";
  const mainImg = MODE === "terminal" ? TERMINAL.img
    : typeof COLOR_MEDIA !== "undefined" ? (COLOR_MEDIA[state.color] || [])[0] : null;
  const preview = [];
  rows.forEach((r, k) => { if (r.variant) preview.push({variant_id:r.variant, title:r.t,
    image_exact:r.src || (r.img ? shot(r.img, 300) : k === 0 ? shot(mainImg, 200) : ""), line_price:r.price * n, quantity:n}); });
  sel.forEach(({o}) => {
    const vid = variantOf(o);
    if (vid) preview.push({variant_id:vid, title:val(o.sumT) || o.title, image_exact:o.src || shot(o.img, 300),
      line_price:priceOf(o) * n, quantity:(o.qty || 1) * n});
  });
  cart = {items:items, attributes:attrs, quote:quote, preview:preview};
}

/* ---------- кошик ---------- */
/* Shopify.routes.root враховує мовний префікс, тому шляхи будуються від нього,
   а не від кореня домену. */
const CP = window.AdaptisCartPop;
const cartRoot = CP.cartRoot;
const locHref = CP.loc || (h => h);
const postJSON = CP.postJSON;
const announceCart = CP.announce;
/* Кошик, яким його бачить Shopify, живе в модулі pop-up (CP.cart): з нього
   рахуємо, чи поточна збірка вже там. */
const refreshCart = () => CP.refresh();
let adding = false;

/* Збірка в кошику, коли кожна її позиція вже лежить там у потрібній кількості. */
function inCart(){
  const liveCart = CP.cart;
  if (!liveCart || !cart.items.length) return false;
  const have = {};
  liveCart.items.forEach(i => { have[i.variant_id] = (have[i.variant_id] || 0) + i.quantity; });
  const need = {};
  cart.items.forEach(i => { need[i.id] = (need[i.id] || 0) + i.quantity; });
  return Object.keys(need).every(id => (have[id] || 0) >= need[id]);
}

let lastCta = ADL("Купити");
/* 24.09.2026: термінала цієї сторінки немає в наявності: кнопка неактивна. */
let termOut = false;
function syncBuyLabel(cta){
  if (cta) lastCta = cta;
  const cfgRoot = el("adaptisCfg");
  if (cfgRoot) cfgRoot.classList.toggle("is-out", termOut);
  const done = inCart();
  [el("buy"), el("buyBar")].forEach(b => {
    if (!b || adding) return;
    /* 26.09.2026 (власник): термінала немає в наявності: конструктор не
       працює, кнопка відкриває «Повідомити про наявність» (ім'я й телефон). */
    b.disabled = false;
    if (termOut){ b.textContent = ADL("Повідомити про наявність"); b.classList.remove("buy--done"); return; }
    /* 24.09.2026: галочка малюнком, а не символом: символ ✓ сидів у колі
       не по центру через метрики шрифту. */
    /* 25.09.2026: «В кошику» з іконкою кошика, кнопка з обводкою (власник). */
    if (done) b.innerHTML = ("<span class=\"buy__cart\" aria-hidden=\"true\"><svg viewBox=\"0 0 20 20\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3.392 6.875h13.216v8.016c0 .567-.224 1.112-.624 1.513-.4.402-.941.627-1.506.627H5.522a2.13 2.13 0 0 1-1.506-.627 2.15 2.15 0 0 1-.624-1.513zM8.818 2.969h2.333c.618 0 1.211.247 1.649.686a2.35 2.35 0 0 1 .683 1.658v1.562H6.486V5.313c0-.622.246-1.218.683-1.658a2.33 2.33 0 0 1 1.65-.686\"/></svg></span>" + ADL("В кошику"));
    else b.textContent = lastCta;
    b.classList.toggle("buy--done", done);
  });

}

function addToCart(btn, next){
  if (termOut){
    if (window.AdaptisNotify) window.AdaptisNotify.open(TERMINAL.title, (el("adaptisCfg") || {dataset:{}}).dataset.handle, TERMINAL.variant);
    return;
  }
  if (adding) return;
  const root0 = cartRoot();
  /* 26.09.2026: «В кошику» веде одразу в кошик, без вікна (власник). */
  if (inCart()){ window.location.href = root0 + (next === "checkout" ? "checkout" : "cart"); return; }
  const label = btn.textContent;
  const fail = msg => {
    btn.textContent = msg;
    setTimeout(() => { btn.textContent = label; }, 2600);
  };
  if (!cart.items.length){
    fail(ADL("Ця збірка ще не має товарів у каталозі"));
    return;
  }
  adding = true;
  [el("buy"), el("buyBar"), el("buyNow")].forEach(b => { if (b) b.disabled = true; });
  btn.textContent = ADL("Додаємо…");
  const root = cartRoot();
  const unlock = () => { adding = false; [el("buy"), el("buyBar"), el("buyNow")].forEach(b => { if (b) b.disabled = false; }); };
  /* update.js з атрибутами повертає весь кошик: окремий /cart.js не потрібен. */
  const req = postJSON(root + "cart/add.js", {items:cart.items})
    .then(() => postJSON(root + "cart/update.js", {attributes:cart.attributes}));
  if (next === "checkout"){
    req
      /* 26.09.2026: одна цінова категорія на весь кошик, і перед оформленням теж. */
      .then(c => CP.sync ? CP.sync(c) : c)
      .then(c => {
        CP.cart = c;
        announceCart(c);
        if (window.AdaptisSrc) window.AdaptisSrc.track("cfg_add_" + window.AdaptisSrc.fam());
        window.location.href = root + "checkout";
      })
      .catch(e => { unlock(); fail(String(e && e.message || e).slice(0, 80) || ADL("Не вдалося додати в кошик")); });
    return;
  }
  /* 28.09.2026: вікно «Додано в кошик» відкривається одразу, зі складом збірки
     зі сторінки; кошик, сума й допродаж домальовуються після відповіді
     Shopify, подія cfg_add_ теж лише тоді. Відмову показує саме вікно. */
  const tracked = req.then(c => {
    if (window.AdaptisSrc) window.AdaptisSrc.track("cfg_add_" + window.AdaptisSrc.fam());
    return c;
  });
  tracked.catch(() => {});
  CP.open({
    productId: el("adaptisCfg") && el("adaptisCfg").dataset ? el("adaptisCfg").dataset.productId : null,
    purpose: () => state.purpose,
    onChange: () => syncBuyLabel(),
    adding: tracked,
    preview: cart.preview || [],
    onShown: () => { const c = CP.cart; if (c) announceCart(c); unlock(); syncBuyLabel(); },
    onFail: () => { unlock(); syncBuyLabel(); }
  });
}

/* ---------- pop-up кошика ---------- */
/* 22.09.2026: pop-up живе окремим модулем угорі файла (window.AdaptisCartPop),
   бо той самий pop-up відкриває і квіз підбору. */
/* 28.09.2026: відкриває його addToCart разом із запитом додавання. */
const escHtml = CP.esc;

/* ---------- сторінка термінала: комплектація ---------- */
const curPack = () => MODE === "terminal" ? PACKS.find(p => p.handle === state.pack) || PACKS[0] : null;
const packHasCorpus = () => !!curPack() && curPack().parts.some(p => p.corpus);
/* Позиція з corpus:true бере ціну й варіант з матриці корпусу,
   бо вони залежать від призначення та кольору. */
const packParts = p => p.parts.map(x => x.corpus
  ? {t:baseTitle() + ", " + colorTitle(), short:baseShort() + ", " + colorTitle(),
     img:(typeof COLOR_MEDIA === "undefined" ? null : (COLOR_MEDIA[state.color] || [])[0]),
     cat:PURPOSE_NOTE[state.purpose], price:corpusPrice(), variant:corpusVariant(), role:"component",
     props:Object.assign({"Колір":colorTitle(), "Призначення":purposeTitle()[state.purpose]},
       /* 23.09.2026: «В колір авто» і на сторінці термінала: код фарби йде з корпусом. */
       state.color === "custom" ? {[SIMPLE_ON && sp.where === "home" ? "Код кольору корпусу" : "Код кольору кузова"]: state.paint === "known" ? (paintCode.trim() || "не вказано") : "уточнити з менеджером"} : {},
       mountProps())}
  : Object.assign({role:"component"}, x));
/* 26.09.2026 (власник): дах, спосіб встановлення і модель авто при «Не знаю»
   коментарем до корпусу, і при самостійному встановленні теж: менеджер має
   бачити, наприклад, броньоване авто, яке покупець ставитиме сам. */
function mountProps(){
  /* 09.10.2026 (власник): удома корпус ставлять на кондиціонер. Та сама позначка, що у квізі: менеджер
     бачить, куди корпус, а рекомендації читають її як ознаку дому, а не авто. */
  if (SIMPLE_ON && sp.where === "home" && sp.homeCorpus === "yes") return {"Встановлення": "на кондиціонер, корпус Adaptis MiniKit"};
  if (!(SIMPLE_ON && SIMPLE.roof && sp.where !== "home" && sp.corpus === "yes")) return {};
  const t = (k, h) => ((SIMPLE[k] && (SIMPLE[k].options || []).find(o => o.h === h)) || {}).t || "";
  const out = {"Дах авто": t("roof", sp.roof), "Встановлення": t("mount", sp.mount)};
  if (roofUnknown()) out["Модель авто"] = carModel.trim() || "уточнити з менеджером";
  return out;
}
const packPrice = p => p.parts.reduce((a,x) => a + (x.corpus ? corpusPrice() : x.price), 0);

/* Набір із каталогу для цієї комплектації, якщо він є під обраний колір. */
const packKit = p => USE_KITS && p && p.kit && p.kit.colors.indexOf(state.color) > -1 ? p.kit : null;
/* Ціна комплектації: ціна набору, якщо він є, інакше сума компонентів. */
function packTotal(p){
  const k = packKit(p);
  if (!k) return TERMINAL.price + packPrice(p);
  return kitPrice(k) + (k.plus || []).reduce((a,x) => a + x.price, 0);
}

function packRows(){
  const p = curPack();
  const k = packKit(p);
  const plus = k && k.plus ? k.plus.map(x => Object.assign({role:"component"}, x)) : [];
  if (k) return [{t:k.short + ", " + colorTitle(), short:k.short + ", " + colorTitle(),
                  cat:k.parts + ", " + PURPOSE_NOTE[state.purpose],
                  price:kitPrice(k), variant:kitVariant(k),
                  props:{"Колір":colorTitle(), "Призначення":purposeTitle()[state.purpose]},
                  loose:TERMINAL.price + packPrice(p)}].concat(plus);
  return [{t:TERMINAL.title, short:TERMINAL.short, price:TERMINAL.price, variant:TERMINAL.variant}]
    .concat(packParts(p));
}

/* Той самий патерн згортання, що й у BUNDLES: обрана комплектація і основні
   розгорнуті, решта стоїть згорнутим рядком. */
const openPacks = new Set();
const recPacks = new Set();
let packsInit = false;
function initOpenPacks(){
  if (packsInit) return;
  packsInit = true;
  /* 22.09.2026: за замовчуванням усі складені, розгортає вибір покупця. */
  PACKS.forEach(p => { if (p.rec) recPacks.add(p.handle); });
}
function packs(){
  const host = el("packs");
  if (!host) return;
  initOpenPacks();
  host.innerHTML = "";
  PACKS.forEach(p => {
    const sum = packTotal(p);
    const loose = TERMINAL.price + packPrice(p);
    const lines = [{t:TERMINAL.title, price:TERMINAL.price, img:TERMINAL.img, variant:TERMINAL.variant}].concat(packParts(p));
    host.appendChild(comboCard({
      handle:p.handle, on:state.pack === p.handle, canUnpick:p.handle !== PACKS[0].handle,
      rec:recPacks.has(p.handle), title:p.title, who:p.desc, feats:p.feats,
      lines:lines, sum:sum, loose:loose, save:loose - sum,
      open:openPacks.has(p.handle),
      onFold:() => keepPlace(p.handle, () => {
        if (openPacks.has(p.handle)) openPacks.delete(p.handle);
        else openPacks.add(p.handle);
        render();
      }),
      onPick:() => {
        /* Комплектація завжди якась є, бо сторінка продає термінал. Тому
           «скасувати» це повернення до базової: лише термінал. */
        const unpick = state.pack === p.handle && p.handle !== PACKS[0].handle;
        keepPlace(p.handle, () => {
          state.pack = unpick ? PACKS[0].handle : p.handle;
          if (!unpick && window.AdaptisSrc) window.AdaptisSrc.track("cfg_pick_" + window.AdaptisSrc.fam() + "_" + p.handle);
          openPacks.add(state.pack);
          slide = 0; render();
        });
        /* 22.09.2026: обрана комплектація одразу йде в кошик і відкриває pop-up
           кошика з допродажем. Скасування в кошик нічого не кладе. */
        if (!unpick) addToCart(el("buy"));
      }
    }));
  });
}

/* ---------- 23.09.2026: питання замість готових комплектів ---------- */
/* Покупець не порівнює картки Base, Drive, Drive Pro, а відповідає на два
   питання: від чого живити Starlink і чи має він працювати із заглушеним
   двигуном. Кожен варіант показує, скільки додає до ціни. Під питаннями склад
   замовлення, той самий, що піде в кошик. */
function syncMix(){
  if (MODE !== "terminal") return;
  const mix = PACKS.find(p => p.handle === "mix");
  const o = (k) => SIMPLE[k] && SIMPLE[k].options.find(x => x.h === sp[k]);
  /* 24.09.2026: вдома корпусу й живлення від авто немає, лише живлення вдома. */
  /* Монтаж на будинку поки прихований: у склад не додаємо. */
  /* 29.09.2026 (власник, s13i): вдома корпус MiniKit на кондиціонер (homeCorpus), якщо сторінка його має. */
  if (sp.where === "home"){ mix.parts = [].concat((o("home") || {}).parts || [], (o("homeCorpus") || {}).parts || []); state.pack = "mix"; return; }
  if (SIMPLE.where && !sp.where){ mix.parts = []; state.pack = "mix"; return; }
  mix.parts = sp.corpus === "yes"
    ? [{corpus:true}].concat((o("power") || {}).parts || [], (o("auto") || {}).parts || [],
        (o("mount") || {}).parts || [], (o("roof") || {}).parts || [])
    : [];
  state.pack = "mix";
}
/* На сторінці корпусу обраний варіант той, чий set збігається зі станом кроків. */
function spPicked(q){
  const Q = SIMPLE[q];
  if (!Q) return null;
  if (MODE === "terminal") return Q.options.find(o => o.h === sp[q]) || null;
  return Q.options.find(o => Object.keys(o.set || {}).every(k => {
    const v = o.set[k], a = state[k];
    return Array.isArray(v) ? Array.isArray(a) && a.length === v.length && v.every(x => a.includes(x)) : a === v;
  })) || null;
}
function spSet(q, h){
  const o = SIMPLE[q].options.find(x => x.h === h);
  if (!o) return;
  touched.add("sp:" + q);
  Object.keys(o.set || {}).forEach(k => touched.add(k));
  if (MODE === "terminal") { sp[q] = h; return; }
  Object.keys(o.set || {}).forEach(k => {
    if (!(k in state)) return;
    state[k] = Array.isArray(o.set[k]) ? [...o.set[k]] : o.set[k];
    manual.add(k);
    /* Наслідки вибору ті самі, що в кроці: дах ставить або знімає пластини. */
    const st = step(k), op = st && !Array.isArray(o.set[k]) ? opt(st, o.set[k]) : null;
    if (op && op.effect) op.effect();
  });
}
/* 24.09.2026: взаємовиключні варіанти. Поле excl:{питання:[варіанти]} на
   варіанті: поки він обраний, ті варіанти неактивні, і навпаки, обраний
   варіант з того списку робить неактивним цей. */
function spBlocked(q, o){
  return Object.keys(SIMPLE).some(k => {
    if (k === q || !SIMPLE[k] || !SIMPLE[k].options) return false;
    const cur = spPicked(k);
    if (!cur) return false;
    if (cur.excl && (cur.excl[q] || []).indexOf(o.h) > -1) return true;
    return !!(o.excl && (o.excl[k] || []).indexOf(cur.h) > -1);
  });
}
function spChoose(q, h){
  const o = SIMPLE[q].options.find(x => x.h === h);
  if (!o) return;
  if (spBlocked(q, o)) return;
  /* Вибір знімає вже обрані несумісні варіанти в інших питаннях. */
  Object.keys(o.excl || {}).forEach(k => {
    const cur = spPicked(k);
    if (cur && o.excl[k].indexOf(cur.h) > -1 && SIMPLE[k].def) spSet(k, SIMPLE[k].def);
  });
  /* Павербанк заряджається від АЗП, тому живлення перемикаємо разом з ним,
     а інше живлення знімає павербанк. */
  /* 28.09.2026 (власник): needs може бути списком. P2Fit працює і з АЗП, і з
     блоком 12-24V: живлення перемикаємо, лише коли обране не зі списку. */
  if (q === "auto" && o.needs && [].concat(o.needs).indexOf((spPicked("power") || {}).h) < 0) spSet("power", [].concat(o.needs)[0]);
  /* Де користуватимуться, те й тариф підписки: вдома Домашній, у русі Мандрівний. */
  if (q === "where" && o.plan && "subplan" in state) state.subplan = o.plan;
  /* 23.09.2026, вечір: у русі Starlink стоїть на даху, тож корпус входить
     завжди. Варіанта «лише термінал» у русі немає (див. spQuestion). */
  if (q === "where" && h === "move" && SIMPLE.corpus) spSet("corpus", "yes");
  if (q === "power"){
    const a = spPicked("auto");
    if (a && a.needs && [].concat(a.needs).indexOf(h) < 0) spSet("auto", SIMPLE.auto.def);
  }
  spSet(q, h);
}
function spCost(q, o){
  if (q === "corpus") return {sum:o.h === "yes" ? corpusPrice() : 0, quote:false};
  /* s13i: частина {corpus:true} (корпус удома) коштує як корпус, а не «за запитом». */
  if (o.parts) return o.parts.reduce((a, x) => x.corpus ? {sum:a.sum + corpusPrice(), quote:a.quote} : ({sum:a.sum + (x.variant ? x.price : 0), quote:a.quote || !x.variant}), {sum:0, quote:false});
  let sum = 0, quote = false, text = null;
  Object.keys(o.set || {}).forEach(k => {
    const st = step(k);
    if (!st) return;
    [].concat(o.set[k]).forEach(h => {
      const op = opt(st, h);
      if (!op) return;
      if (noCat(op)) quote = true; else sum += priceOf(op);
      /* Без власної ціни, але з підписом: «+ 1 800 ₴» за пластини, «рахується окремо». */
      if (!priceOf(op) && val(op.priceText)) text = val(op.priceText);
    });
  });
  return {sum:sum, quote:quote, text:text};
}
/* 23.09.2026: варіант показує фото товару, який піде в кошик. Варіант без
   товару (розетка, «ні») лишається текстом, без іконки. */
const NO_PREVIEW = ["roof", "mount", "homeMount"];
function spImg(q, o){
  /* s13i: власне фото варіанта (корпус MiniKit на кондиціонері). */
  if (o.photo) return o.photo;
  /* 24.09.2026: у питаннях про дах і встановлення фото немає: це послуга й
     уточнення, а не товар, і прев'ю тільки збивало. Позиції в замовленні лишаються. */
  if (NO_PREVIEW.indexOf(q) > -1) return null;
  if (q === "corpus") return o.h === "yes" && typeof COLOR_MEDIA !== "undefined" ? (COLOR_MEDIA[state.color] || [])[0] : null;
  if (o.parts){ const x = o.parts.find(x => x.img); return x ? x.img : null; }
  for (const k of Object.keys(o.set || {})){
    const st = step(k);
    if (!st) continue;
    for (const h of [].concat(o.set[k])){ const op = opt(st, h); if (op && op.img) return op.img; }
  }
  return null;
}
/* 24.09.2026: варіант із кількох товарів (павербанк і кабель) показує всі
   фото складеними, від дешевшого до дорожчого: дорожчий товар спереду. */
function spImgs(q, o){
  if (NO_PREVIEW.indexOf(q) > -1) return [];
  if (o.parts) return o.parts.filter(x => x.img).map(x => ({img:x.img, price:x.price || 0, variant:x.variant || null}))
    .sort((a, b) => a.price - b.price);
  const one = spImg(q, o);
  return one ? [{img:one, price:0, variant:spVariant(q, o)}] : [];
}
/* Два товари: кожне фото веде на свій товар. Значок ↗ заднього фото стоїть
   зверху зліва, переднього знизу справа, у кутах, які не перекриваються. */
const GO_ICON = '<span class="spick__go" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8 16L16 8M9 8h7v7"/></svg></span>';
function stackHtml(items){
  return '<span class="spick__im spick__im--stack">' + items.slice(-2).map((x, i) => {
    const cls = "spick__st spick__st--" + (i ? "b" : "a");
    const pic = '<img src="' + im(x.img, 200) + '" alt="" loading="lazy">';
    return x.variant
      ? '<a class="' + cls + ' spick__ln" href="' + cartRoot() + 'variants/' + x.variant + ("\" target=\"_blank\" rel=\"noopener\" title=\"" + ADL("Відкрити товар у новій вкладці").replace(/"/g, "&quot;") + "\" aria-label=\"" + ADL("Відкрити товар у новій вкладці").replace(/"/g, "&quot;") + "\">") + pic + GO_ICON + '</a>'
      : '<span class="' + cls + '">' + pic + '</span>';
  }).join("") + '</span>';
}
function spVariant(q, o){
  if (q === "corpus") return o.h === "yes" ? corpusVariant() : null;
  if (o.parts){ const x = o.parts.find(x => x.variant); return x ? x.variant : null; }
  for (const k of Object.keys(o.set || {})){
    const st = step(k);
    if (!st) continue;
    for (const h of [].concat(o.set[k])){ const op = opt(st, h); const v = op && variantOf(op); if (v && op.role === "component") return v; }
  }
  return null;
}
function spQuestion(q, first){
  const Q = SIMPLE[q], on = spPicked(q);
  const wrap = document.createElement("div");
  wrap.className = "spick__q";
  wrap.innerHTML = (first ? '<h2 class="cfgset__t"></h2>' : '<h3 class="spick__t"></h3>') +
    (Q.hint ? '<p class="cfgset__h"></p>' : '') + '<div class="spick__opts"></div>' +
    (Q.note ? '<p class="spick__note"></p>' : '');
  wrap.querySelector(first ? ".cfgset__t" : ".spick__t").textContent = Q.title;
  if (Q.hint) wrap.querySelector(".cfgset__h").textContent = Q.hint;
  if (Q.note){
    const n = wrap.querySelector(".spick__note");
    n.textContent = Q.note;
    if (Q.noteLink){ const a = document.createElement("a"); a.href = locHref(Q.noteLink.href); a.target = "_blank"; a.rel = "noopener"; a.textContent = Q.noteLink.text; n.appendChild(a); }
  }
  const box = wrap.querySelector(".spick__opts");
  /* «Не знаю» про дах: під варіантами поле для моделі авто. Фокус не ставимо:
     на телефоні клавіатура сама закривала б екран. */
  if (q === "roof" && on && on.h === "unknown"){
    const f = document.createElement("div");
    f.className = "field";
    f.innerHTML = ("<label for=\"carModel\">" + ADL("Яка у вас модель авто і рік?") + "</label>") +
      ("<input id=\"carModel\" type=\"text\" maxlength=\"80\" placeholder=\"" + ADL("Наприклад, BMW X5 2024").replace(/"/g, "&quot;") + "\" autocomplete=\"off\">");
    const inp = f.querySelector("input");
    inp.value = carModel;
    inp.addEventListener("input", e => { carModel = e.target.value; paint(); });
    wrap.appendChild(f);
  }
  /* 24.09.2026: варіанти живлення від дешевшого до дорожчого, «за запитом»
     останнім. Решту питань лишаємо в порядку даних. */
  const byPrice = ["power", "auto", "home"].indexOf(q) > -1;
  const cost = o => { const c = spCost(q, o); return c.quote ? Infinity : c.sum; };
  let list = byPrice ? Q.options.slice().sort((a, b) => cost(a) - cost(b)) : Q.options;
  /* У русі корпус обов’язковий: «Лише термінал» не показуємо. */
  if (q === "corpus" && SIMPLE.where && sp.where === "move") list = list.filter(o => o.h !== "no");
  list.forEach(o => {
    const c = spCost(q, o);
    /* Рядок не кнопка, а div з роллю кнопки: усередині посилання на товар,
       а посилання в кнопці ламало б розмітку. */
    const b = document.createElement("div");
    b.setAttribute("role", "button");
    b.tabIndex = 0;
    const img = spImg(q, o);
    b.className = "spick__o" + (img ? "" : " spick__o--text");
    b.dataset.q = q; b.dataset.h = o.h;
    b.setAttribute("aria-pressed", String(!!on && on.h === o.h && touched.has("sp:" + q)));
    const blocked = spBlocked(q, o);
    if (blocked){
      b.classList.add("spick__o--off");
      b.setAttribute("aria-disabled", "true");
      b.tabIndex = -1;
      b.title = ADL("Недоступно разом з уже обраним варіантом");
    }
    const vId = spVariant(q, o);
    /* 23.09.2026: назва варіанта звичайним текстом. Посилання на товар це
       фото: у куті значок ↗, видно завжди, і на телефоні теж. Клік по фото
       відкриває товар у новій вкладці, клік по решті рядка обирає варіант. */
    const imgs = spImgs(q, o);
    /* s13p: фото корпусу на кондиціонері на всю ширину картки, тому більша роздільність. */
    const pic = img ? '<img src="' + (/^(https?:)?\/\//.test(img) ? img : im(img, o.photo ? 900 : 240)) + '" alt="" loading="lazy">' : '';
    const stack = "";
    b.innerHTML = (imgs.length > 1 ? stackHtml(imgs) : img ? (vId
        ? '<a class="spick__im spick__im--ln' + stack + '" href="' + cartRoot() + 'variants/' + vId + ("\" target=\"_blank\" rel=\"noopener\" title=\"" + ADL("Відкрити товар у новій вкладці").replace(/"/g, "&quot;") + "\" aria-label=\"" + ADL("Відкрити товар у новій вкладці").replace(/"/g, "&quot;") + "\">") + pic +
          '<span class="spick__go" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8 16L16 8M9 8h7v7"/></svg></span></a>'
        : '<span class="spick__im' + stack + '">' + pic + '</span>') : '') +
      '<span class="spick__x"><span class="spick__ot"></span><small></small>' + (o.w ? '<span class="spick__w"></span>' : '') + '</span>' +
      /* «Де користуватимуться» це питання, а не товар: ціни в ньому немає. */
      /* 23.09.2026, вечір: «0 ₴» сірим, як у кроках (card__p.free). */
      /* 26.09.2026: bare без ціни (уточнення), pt свій підпис ціни: «від 3 200 ₴»
         за монтаж, бо ціна залежить від даху; «8 500 ₴» за броньоване авто. */
      (q === "where" || val(o.bare) ? '' : val(o.pt) ? '<b class="spick__p">' + val(o.pt) + '</b>' :
        '<b class="spick__p' + (!c.quote && !c.sum && !c.text ? ' is-zero' : '') + '">' + (c.quote ? ADL("за запитом") : c.sum ? wasHtml(() => spCost(q, o).sum, c.sum) + "+ " + money(c.sum) : c.text || "0 ₴") + '</b>');
    b.querySelector(".spick__ot").textContent = o.t;
    b.querySelector("small").textContent = o.d || "";
    /* 26.09.2026: застереження окремим рядком, темним і напівжирним (павербанк 27 000 mAh). */
    /* s14u (власник 30.09): адреса Центру інсталяції відкривається в Google Maps. Клік по посиланню варіант не обирає (spick__ln). */
    if (o.map){ const ml = document.createElement("a"); ml.className = "spick__ln spick__map"; ml.href = o.map; ml.target = "_blank"; ml.rel = "noopener"; ml.textContent = ADL("Відкрити на карті"); b.querySelector(".spick__x").appendChild(ml); }
    if (o.w){
      const wEl = b.querySelector(".spick__w");
      /* s14k (власник 30.09): у «Як встановити Starlink» перше речення (про магніти) жирним і темним, решта сіра, як у квізі. */
      /* s15q (власник 01.10): у «Як встановити Starlink» примітка світло-синьою плашкою, два рядки з іконками
         (магніт, перевірка), звичайним шрифтом, щоб не сперечалась із заголовком. */
      const m = q === "homeCorpus" && /^(.+?[.!?])\s+(.+)$/.exec(o.w);
      if (m){ wEl.classList.add("ax-acnote"); [["mag", m[1]], ["chk", m[2]]].forEach(x => { const l = document.createElement("span"); l.className = "ax-acnote__l ax-acnote__l--" + x[0]; l.textContent = x[1]; wEl.appendChild(l); }); }
      else wEl.textContent = o.w;
    }
    b.addEventListener("keydown", e => { if ((e.key === "Enter" || e.key === " ") && e.target === b){ e.preventDefault(); b.click(); } });
    b.addEventListener("click", e => {
      if (e.target.closest(".spick__im--ln, .spick__ln")) return;
      const top = b.getBoundingClientRect().top;
      spChoose(q, o.h);
      /* 26.09.2026: подія воронки: вибір у спрощеному конструкторі (питання й відповідь у назві). */
      if (window.AdaptisSrc) window.AdaptisSrc.track("cfg_choose_" + window.AdaptisSrc.fam() + "_" + q + "_" + o.h);
      render();
      const nb = document.querySelector('.spick__o[data-q="' + q + '"][data-h="' + o.h + '"]');
      if (nb){ const d = nb.getBoundingClientRect().top - top; if (d) window.scrollBy({top:d, behavior:"instant"}); }
    });
    box.appendChild(b);
  });
  return wrap;
}
/* Склад замовлення: ті самі позиції, що підуть у кошик. */
function spLines(){
  const mg = amuletMerge(baseRows(), chosen());
  const rows = mg.rows.map(r => Object.assign({}, r));
  /* Перший рядок сторінки термінала це термінал, і з Amulet теж. */
  if (MODE === "terminal" && rows[0]) rows[0].img = TERMINAL.img;
  if (MODE !== "terminal" && rows[0]) rows[0].img = typeof COLOR_MEDIA === "undefined" ? null : (COLOR_MEDIA[state.color] || [])[0];
  return rows.concat(mg.sel.filter(x => variantOf(x.o) || priceOf(x.o)).map(({o}) =>
    ({t:val(o.sumT) || o.title, price:priceOf(o), variant:variantOf(o), img:o.img, src:o.src, quote:noCat(o)})));
}
/* 23.09.2026: перше питання сторінки корпусу («У вас є Starlink?») тим самим
   рядком, що й питання про живлення: картки з фото 96 px займали пів екрана. */
function leadBlock(){
  const host = el("lead");
  if (!host) return;
  host.hidden = false;
  host.classList.add("spick");
  host.innerHTML = "";
  host.appendChild(spQuestion("lead", true));
}
/* 23.09.2026: монтаж і дах однією компактною карткою, першою серед кроків.
   Малюється після кроків, бо render() спершу очищає їхній контейнер. */
function simpleGroup2(){
  /* На сторінці термінала монтаж і дах стоять у блоці комплектації. */
  if (MODE === "terminal") return;
  const g2 = ["mount", "roof"].filter(q => SIMPLE[q]);
  if (!g2.length || !stepsEl) return;
  const card = document.createElement("section");
  card.className = "card pane cfgset spick spick--g2";
  g2.forEach((q, i) => card.appendChild(spQuestion(q, i === 0)));
  stepsEl.prepend(card);
}
function simpleBlock(){
  const host = el(MODE === "terminal" ? "packs" : "bundles");
  if (!host) return;
  /* На сторінці термінала блок живе в секції з заголовком «Комплектація»:
     питання мають свої заголовки, тож загальний ховаємо. */
  const sec = host.closest("section");
  if (sec && sec !== host) sec.querySelectorAll(":scope > .cfgset__t, :scope > .cfgset__h").forEach(n => n.hidden = true);
  host.hidden = false;
  host.classList.add("spick");
  host.innerHTML = "";
  const qs = [];
  /* Сесія 9: питання «де користуватимуться» з однією відповіддю (сторінка Mini X, лише вдома) не
     показуємо: відповідь уже обрана наперед. */
  /* 09.10.2026: відповідь з qpOnly існує лише для готових комплектів тестового варіанта (Mini X на авто),
     у звичайному конструкторі її не рахуємо, тож питання на сторінці Mini X лишається прихованим. */
  if (SIMPLE.where && SIMPLE.where.options.filter(o => !o.qpOnly).length > 1) qs.push("where");
  /* 24.09.2026: послуги монтажу на будинку ще немає, питання «Встановлення
     на будинку» приховане. Повернути: qs.push("home", "homeMount"). */
  /* 30.09.2026 (власник, s14e): «Як встановити Starlink» (MiniKit на кондиціонер) вище за живлення. */
  if (SIMPLE.where && sp.where === "home"){ if (SIMPLE.homeCorpus) qs.push("homeCorpus"); qs.push("home"); }
  /* 24.09.2026: поки не відповіли, де користуватимуться, питаємо тільки це. */
  else if (SIMPLE.where && !sp.where) {}
  else {
    if (SIMPLE.corpus) qs.push("corpus");
    if (!SIMPLE.corpus || sp.corpus === "yes") qs.push("power", "auto");
    if (MODE === "terminal" && sp.corpus === "yes") qs.push("mount", "roof");
  }
  qs.filter(q => SIMPLE[q]).forEach((q, i) => {
    host.appendChild(spQuestion(q, i === 0));
    /* Під вибором корпусу: колір і ціна для Сил Оборони (заповнюють
       colorTop і purposeToggle). */
    if ((q === "corpus" && sp.corpus === "yes") || (q === "homeCorpus" && sp.homeCorpus === "yes")){
      const box = document.createElement("div");
      box.id = "spCorpusOpts";
      box.className = "spick__corpus colortop";
      host.appendChild(box);
    }
  });


  /* Блоку «Що буде в замовленні» немає: фото у варіантах уже показують, що
     піде в кошик. spLines лишається для повернення блоку. */
}

/* ---------- вікна поверх сторінки ---------- */
/* 26.09.2026: вікна спільні з квізом, див. window.AdaptisUI на початку файлу. */
const openSheet = o => window.AdaptisUI.sheet(o);
const openInfo = info => window.AdaptisUI.info(info, n => icon(n, "cfgcard__fi"));

/* ---------- панель покупки ---------- */
/* На мобільному завжди внизу; на десктопі щойно основний блок ціни
   виходить із вʼюпорта. */
const bar = el("buybar");
function showBar(on){
  bar.classList.toggle("is-on", on);
  /* Кнопка чату піднімається над панеллю, щоб не закривати «Купити». */
  document.documentElement.classList.toggle("adaptis-bar-on", on);
  placeChat();
  bar.setAttribute("aria-hidden", String(!on));
  document.body.classList.toggle("has-bar", on);
}
/* 22.09.2026: кнопки Binotel («Замовити дзвінок», «Почати діалог») на телефоні
   завжди праворуч і вище: над панеллю покупки з урахуванням її справжньої
   висоти, а без панелі на 96 px від низу. Якщо вони все одно лягають на кнопку
   «Купити» в блоці покупки, ховаємо їх, поки кнопка під ними. */
/* 23.09.2026, вечір: пишемо в стилі тільки те, що змінилось. Запис на кожному
   кадрі прокрутки змушував iPhone перераховувати стилі всієї сторінки, і липкі
   шапка з навігацією сіпались вгору-вниз. */
let chatOff = "", chatHit = null;
function placeChat(){
  const w = document.getElementById("bwc-widget-action");
  if (!w || window.innerWidth > 640) return;
  const on = bar.classList.contains("is-on");
  const off = (on ? bar.offsetHeight + 16 : 96) + "px";
  if (off !== chatOff){
    const root = document.documentElement.style;
    root.setProperty("--bwc-chat-mob-offset-vertical", off, "important");
    root.setProperty("--bwc-chat-mob-offset-horizontal", "10px", "important");
    chatOff = off;
  }
  const b = el("buy") && el("buy").getBoundingClientRect();
  const r = w.getBoundingClientRect();
  const hit = !!(!on && b && r.bottom > b.top && r.top < b.bottom && r.right > b.left && r.left < b.right);
  if (hit === chatHit && w.style.opacity === (hit ? "0" : "")) return;
  chatHit = hit;
  w.style.opacity = hit ? "0" : "";
  w.style.pointerEvents = hit ? "none" : "";
}
let chatTick = false;
window.addEventListener("scroll", () => { if (!live()) return; if (!chatTick){ chatTick = true; requestAnimationFrame(() => { chatTick = false; placeChat(); }); } }, {passive:true});
window.addEventListener("resize", () => { if (live()) placeChat(); });
/* Віджет вантажиться пізніше за сторінку. */
[1000, 3000, 6000].forEach(t => setTimeout(placeChat, t));

(function initGate(){
  const b = el("gate");
  if (!b) return;
  b.addEventListener("change", () => { gateOn = b.checked; render(); });
})();

(function initBar(){
  const anchor = document.querySelector(".sum");
  if (!anchor || typeof IntersectionObserver === "undefined"){ showBar(true); return; }
  new IntersectionObserver(
    entries => { if (live()) showBar(!entries[0].isIntersecting); },
    {rootMargin: "-70px 0px 0px 0px", threshold: 0}
  ).observe(anchor);
})();

["buy","buyBar"].forEach(id => {
  const b = el(id);
  if (!b) return;
  b.addEventListener("click", function(){ addToCart(this); });
});
document.querySelectorAll("[data-qd]").forEach(b => b.addEventListener("click", () => {
  state.qty = Math.max(1, Math.min(QTY_MAX, state.qty + (+b.dataset.qd)));
  render();
}));
if (el("buyNow")) el("buyNow").addEventListener("click", function(){ addToCart(this, "checkout"); });
refreshCart().then(() => syncBuyLabel()).catch(() => {});
/* Допродаж вантажимо у фоні, коли сторінка вже вільна. */
(function warmPop(){
  const go = () => CP.prefetch({
    productId: el("adaptisCfg") && el("adaptisCfg").dataset ? el("adaptisCfg").dataset.productId : null,
    purpose: () => state.purpose,
    onChange: () => syncBuyLabel()
  });
  if (window.requestIdleCallback) requestIdleCallback(go, {timeout:4000});
  else setTimeout(go, 2500);
})();

/* ---------- навігація по сторінці товару ---------- */
/* Модуль AdaptisPageNav на початку файлу. На сторінці Amulet навігації
   немає: поява смуги під шапкою зсувала сторінку. */
if (!AMULET_MODE && window.AdaptisPageNav) window.AdaptisPageNav(el("adaptisCfg"));

/* Прив'язка копіювання винесена окремо: колись поруч стояла друга кнопка
   з посиланням на кошик adaptis.com. */
function bindCopy(id, makeUrl, label){
  const b = el(id);
  if (!b) return;
  const setLabel = t => { b.textContent = t; };
  b.addEventListener("click", () => {
    const url = makeUrl();
    if (!url){
      setLabel(ADL("Ця збірка ще не має товарів у каталозі"));
      setTimeout(() => setLabel(label), 2500);
      return;
    }
    const done = () => {
      setLabel(ADL("Посилання скопійовано"));
      b.classList.add("is-done");
      setTimeout(() => { setLabel(label); b.classList.remove("is-done"); }, 1800);
    };
    /* Clipboard API падає в частині браузерів і в незахищеному контексті.
       Запасний шлях копіює через приховане поле, щоб менеджер у будь-якому разі
       отримав посилання, а не діалог з проханням скопіювати вручну. */
    const fallback = () => {
      const ta = document.createElement("textarea");
      ta.value = url;
      ta.setAttribute("readonly", "");
      ta.style.cssText = "position:fixed;top:-1000px;opacity:0";
      document.body.appendChild(ta);
      ta.select();
      let ok = false;
      try { ok = document.execCommand("copy"); } catch (e) { ok = false; }
      ta.remove();
      if (ok) return done();
      try { window.prompt(ADL("Скопіюйте посилання"), url); }
      catch (e) {
        setLabel(ADL("Скопіюйте посилання з адресного рядка"));
        setTimeout(() => setLabel(label), 2500);
      }
    };
    if (navigator.clipboard && navigator.clipboard.writeText)
      navigator.clipboard.writeText(url).then(done, fallback);
    else fallback();
  });
}
/* 22.09.2026: посилання веде одразу в кошик з усіма позиціями цієї збірки
   (cart permalink Shopify, ?storefront=true відкриває кошик, а не оплату).
   Властивості позицій permalink не переносить, тому колір, призначення й
   інше, що потрібно менеджеру, їде атрибутами замовлення. */
function cartLink(){
  if (!cart.items.length) return null;
  const qty = {}, order = [];
  cart.items.forEach(i => { if (!(i.id in qty)) order.push(i.id); qty[i.id] = (qty[i.id] || 0) + i.quantity; });
  const q = new URLSearchParams();
  q.set("storefront", "true");
  const attrs = Object.assign({}, cart.attributes);
  const base = cart.items[0] && cart.items[0].properties || {};
  ["Колір", "Призначення", "Дах авто", "Модель авто", "Код кольору кузова"].forEach(k => { if (base[k]) attrs[k] = base[k]; });
  Object.keys(attrs).forEach(k => { if (attrs[k]) q.set("attributes[" + k + "]", attrs[k]); });
  return location.origin + cartRoot() + "cart/" + order.map(id => id + ":" + qty[id]).join(",") + "?" + q.toString();
}
bindCopy("copyCfg", cartLink, ADL("Скопіювати посилання на кошик з цією комплектацією"));
document.querySelectorAll(".tab").forEach(t => {
  t.addEventListener("click", () => {
    document.querySelectorAll(".tab").forEach(x => {
      const on = x === t;
      x.classList.toggle("is-on", on);
      x.setAttribute("aria-selected", String(on));
    });
    document.querySelectorAll(".tabp").forEach(pn => { pn.hidden = pn.id !== t.dataset.p; });
  });
});

if (!restoreState()) readUrl();
render();
if (window.AdaptisSrc) window.AdaptisSrc.track("cfg_view_" + window.AdaptisSrc.fam(), {once:true});

/* 24.09.2026: товари, яких немає в наявності, прибираємо з усіх варіантів
   (adaptis-stock.js). Після перевірки вибір, що зник, повертається до
   значення за замовчуванням, і сторінка перемальовується. */
if (window.AdaptisStock) window.AdaptisStock.ready.then(() => {
  if (!live()) return;
  const S = window.AdaptisStock;
  const changed = S.prune(P);
  const imgs = S.syncImages(P);
  if (MODE === "terminal" && TERMINAL && S.out(TERMINAL.variant)) termOut = true;
  if (changed){
    STEPS.forEach(st => {
      const v = state[st.handle];
      if (!st.options || v === null || v === undefined) return;
      const has = h => st.options.some(o => o.handle === h);
      if (Array.isArray(v)) state[st.handle] = v.filter(has);
      else if (!has(v)) state[st.handle] = Array.isArray(st.def) ? [...st.def] : st.def;
    });
    if (SIMPLE_ON) Object.keys(sp).forEach(k => {
      const Q = SIMPLE[k];
      if (Q && Q.options && !Q.options.some(o => o.h === sp[k])) sp[k] = Q.def || (Q.options[0] || {}).h;
    });
  }
  if (changed || termOut || imgs) render();
});

};
if (!window.ADAPTIS_ENGINE_MANUAL) window.AdaptisEngine();
